// https://svgsprite.com/tools/svg-sprite-generator/
import React from 'react'

const svgIcons = {
   byId: {
      imageIcon: {
         width: 18,
         height: 18,
         viewBox: [0, 0, 18, 18],
         data: (
            <path
               d="M14.45 0H2.55C1.8737 0 1.2251 0.26866 0.746878 0.746878C0.26866 1.2251 0 1.8737 0 2.55V14.45C0 15.1263 0.26866 15.7749 0.746878 16.2531C1.2251 16.7313 1.8737 
          17 2.55 17H14.45C14.5898 16.9981 14.7292 16.9838 14.8665 16.9575L15.1215 16.898H15.2235L15.538 16.779L15.6485 16.7195C15.7335 16.6685 15.827 16.626 15.912 16.5665C16.0255 
          16.483 16.1334 16.3921 16.235 16.2945L16.2945 16.218C16.378 16.1334 16.4547 16.0425 16.524 15.946L16.6005 15.8355C16.6599 15.7409 16.7111 15.6413 16.7535 15.538C16.7768 
          15.4972 16.7967 15.4546 16.813 15.4105C16.8555 15.3085 16.881 15.198 16.915 15.0875V14.96C16.9632 14.7939 16.9917 14.6227 17 14.45V2.55C17 1.8737 16.7313 1.2251 16.2531 
          0.746878C15.7749 0.26866 15.1263 0 14.45 0ZM2.55 15.3C2.32457 15.3 2.10837 15.2104 1.94896 15.051C1.78955 14.8916 1.7 14.6754 1.7 14.45V10.7865L4.4965 7.9815C4.57552 7.90183 
          4.66953 7.8386 4.77311 7.79544C4.87669 7.75229 4.98779 7.73007 5.1 7.73007C5.21221 7.73007 5.32331 7.75229 5.42689 7.79544C5.53047 7.8386 5.62448 7.90183 5.7035 7.9815L13.0135 
          15.3H2.55ZM15.3 14.45C15.2992 14.5548 15.279 14.6585 15.2405 14.756C15.2211 14.7974 15.1983 14.8372 15.1725 14.875C15.1498 14.911 15.1242 14.9451 15.096 14.977L10.5485 
          10.4295L11.2965 9.6815C11.3755 9.60183 11.4695 9.5386 11.5731 9.49544C11.6767 9.45229 11.7878 9.43007 11.9 9.43007C12.0122 9.43007 12.1233 9.45229 12.2269 9.49544C12.3305 
          9.5386 12.4245 9.60183 12.5035 9.6815L15.3 12.4865V14.45ZM15.3 10.081L13.702 8.5C13.2156 8.03844 12.5706 7.78114 11.9 7.78114C11.2294 7.78114 10.5844 8.03844 10.098 8.5L9.35 
          9.248L6.902 6.8C6.41556 6.33844 5.77056 6.08114 5.1 6.08114C4.42944 6.08114 3.78444 6.33844 3.298 6.8L1.7 8.381V2.55C1.7 2.32457 1.78955 2.10837 1.94896 1.94896C2.10837 
          1.78955 2.32457 1.7 2.55 1.7H14.45C14.6754 1.7 14.8916 1.78955 15.051 1.94896C15.2104 2.10837 15.3 2.32457 15.3 2.55V10.081ZM9.775 3.4C9.52283 3.4 9.27632 3.47478 9.06665 
          3.61488C8.85698 3.75498 8.69356 3.9541 8.59705 4.18708C8.50055 4.42005 8.4753 4.67641 8.5245 4.92374C8.5737 5.17107 8.69513 5.39825 8.87344 5.57656C9.05175 5.75487 9.27893 
          5.87631 9.52626 5.9255C9.77359 5.9747 10.0299 5.94945 10.2629 5.85295C10.4959 5.75645 10.695 5.59302 10.8351 5.38335C10.9752 5.17368 11.05 4.92717 11.05 4.675C11.05 4.33685 
          10.9157 4.01255 10.6766 3.77344C10.4375 3.53433 10.1132 3.4 9.775 3.4Z"
               fill="#BABAC4"
            />
         ),
      },
      documentIcon: {
         width: 18,
         height: 18,
         viewBox: [0, 0, 18, 18],
         data: (
            <path
               d="M15 5.899C14.9922 5.82091 14.9771 5.74399 14.955 5.6695V5.593C14.9189 5.5056 14.8708 5.42527 14.8125 5.355V5.355L10.3125 0.255C10.2505 0.188884 10.1796 0.134369 
           10.1025 0.0934999H10.035L9.795 0H5.25C4.65326 0 4.08097 0.26866 3.65901 0.746878C3.23705 1.2251 3 1.8737 3 2.55V14.45C3 15.1263 3.23705 15.7749 3.65901 16.2531C4.08097 
           16.7313 4.65326 17 5.25 17H12.75C13.3467 17 13.919 16.7313 14.341 16.2531C14.7629 15.7749 15 15.1263 15 14.45V5.95C15 5.95 15 5.95 15 5.899ZM10.5 2.8985L12.4425 
           5.1H10.5V2.8985ZM13.5 14.45C13.5 14.6754 13.421 14.8916 13.2803 15.051C13.1397 15.2104 12.9489 15.3 12.75 15.3H5.25C5.05109 15.3 4.86032 15.2104 4.71967 15.051C4.57902 
           14.8916 4.5 14.6754 4.5 14.45V2.55C4.5 2.32457 4.57902 2.10837 4.71967 1.94896C4.86032 1.78955 5.05109 1.7 5.25 1.7H9V5.95C9 6.17543 9.07902 6.39163 9.21967 6.55104C9.36032 
           6.71045 9.55109 6.8 9.75 6.8H13.5V14.45Z"
               fill="#BABAC4"
            />
         ),
      },
      attachmentPaperclip: {
         width: 26,
         height: 26,
         viewBox: [0, 0, 26, 26],
         data: (
            <path
               d="M6.56085 20C4.86773 20 3.1746 19.2991 1.90476 18.1977C0.740741 16.9962 0 15.3942 0 13.7922C0 12.1902 0.634921 10.5882 1.90476 9.38673L10.4762 1.2766C12.2751 
           -0.425532 15.3439 -0.425532 17.037 1.2766C17.8836 2.0776 18.4127 3.2791 18.4127 4.38048C18.4127 5.48185 17.8836 6.68335 17.037 7.48435L8.57143 15.5945C7.51323 16.5957 
           5.60847 16.5957 4.55026 15.5945C4.02116 15.0939 3.7037 14.393 3.7037 13.6921C3.7037 12.9912 4.02116 12.2904 4.55026 11.7897L12.381 4.38048C12.381 4.38048 13.0596 3.71835 
           13.7566 4.38048C14.2105 4.81169 14.1799 5.2816 13.7566 5.6821L5.92593 13.1915C5.92593 13.1915 5.26316 13.6921 5.92593 14.393C6.24339 14.6934 6.77249 14.6934 7.19577 
           14.393L15.6614 6.28285C15.6614 6.28285 16.5079 5.39844 16.5079 4.38048C16.5079 3.6796 16.1905 2.97872 15.6614 2.4781C14.6032 1.47685 12.8042 1.47685 11.8519 2.4781L3.38624 
           10.6884C2.53968 11.4894 2.01058 12.6909 2.01058 13.7922C2.01058 14.8936 2.53968 16.0951 3.38624 16.8961C5.07937 18.4981 8.14815 18.4981 9.84127 16.8961L18.3069 8.78598C18.3069 
           8.78598 18.9474 8 19.6825 8.78598C20.1058 9.18648 20.1058 9.68711 19.6825 10.0876L11.2169 18.1977C10.0529 19.3992 8.35979 20 6.66667 20H6.56085Z"
               fill="#1a4d80"
            />
         ),
      },
      actions: {
         width: 16,
         height: 16,
         viewBox: [0, 0, 16, 16],
         data: (
            <>
               <path
                  d="M8.30769 9.12038L10.0185 9.13269L10.0246 7.2373L13.4585 10.185L10 13.1265L10.0062 11.2496L8.20923 11.2435"
                  fill="none"
                  strokeWidth="1.23077"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  d="M7.69233 6.88018L5.98156 6.86787L5.97541 8.76325L2.54156 5.81556L6.00003 2.87402L5.99387 4.75095L7.7908 4.7571"
                  fill="none"
                  strokeWidth="1.23077"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  d="M12.9108 1.23077C13.9323 1.23077 14.7692 2.06154 14.7692 3.08923V12.9108C14.7692 13.9323 13.9385 14.7692 12.9108 14.7692H3.08923C2.06769 14.7692 1.23077 13.9385 1.23077 12.9108V3.08923C1.23077 2.06769 2.06154 1.23077 3.08923 1.23077H12.9108ZM12.9108 0H3.08923C1.38462 0 0 1.38462 0 3.08923V12.9108C0 14.6154 1.38462 16 3.08923 16H12.9108C14.6154 16 16 14.6154 16 12.9108V3.08923C16 1.38462 14.6154 0 12.9108 0Z"
                  stroke="none"
               />
            </>
         ),
      },
      actionLoan: {
         width: 30,
         height: 30,
         viewBox: [0, 0, 30, 30],
         fill: 'none',
         data: (
            <>
               <rect width="30" height="30" rx="5.02" ry="5.02" />
               <polyline
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeWidth="1.5px"
                  strokeLinejoin="round"
                  points="7.73 16.83 16.26 16.83 16.26 20.14 22.81 15 16.26 9.86 16.26 13.14 7.73 13.14"
               />
               <path
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeWidth="1.5px"
                  strokeMiterlimit="10"
                  d="M9.78,21.15h-.8c-.99,0-1.79-.79-1.79-1.75v-8.78c0-.97.8-1.75,1.79-1.75h.8"
               />
            </>
         ),
      },
      actionBorrow: {
         width: 30,
         height: 30,
         viewBox: [0, 0, 30, 30],
         fill: 'none',
         data: (
            <>
               <rect
                  fill="#f3f3f3"
                  width="30"
                  height="30"
                  rx="5.02"
                  ry="5.02"
               />
               <polyline
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeWidth="1.5px"
                  strokeLinejoin="round"
                  points="13.17 8.21 13.17 15.25 9.86 15.25 15 21.79 20.14 15.25 16.86 15.25 16.86 8.21"
               />
               <path
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeWidth="1.5px"
                  strokeMiterlimit="10"
                  d="M8.85,10.8v-.8c0-.99.79-1.79,1.75-1.79h8.78c.97,0,1.75.8,1.75,1.79v.8"
               />
            </>
         ),
      },
      actionReturn: {
         width: 30,
         height: 30,
         viewBox: [0, 0, 30, 30],
         fill: 'none',
         data: (
            <>
               <rect width="30" height="30" rx="5.02" ry="5.02" />
               <polyline
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5px"
                  points="23.74 13.17 15.21 13.17 15.21 9.86 8.66 15 15.21 20.14 15.21 16.86 23.74 16.86"
               />
               <path
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5px"
                  d="M8.85,21.15h-.8c-.99,0-1.79-.79-1.79-1.75v-8.78c0-.97.8-1.75,1.79-1.75h.8"
               />
            </>
         ),
      },
      actionTransfer: {
         width: 30,
         height: 30,
         viewBox: [0, 0, 30, 30],
         fill: 'none',
         data: (
            <>
               <rect width="30" height="30" rx="5.02" ry="5.02" />
               <polyline
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5px"
                  points="14.61 15 11.21 15 11.21 12.18 5.17 16.92 11.21 21.66 11.21 18.85 14.61 18.85"
               />
               <line
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5px"
                  x1="16.22"
                  y1="18.85"
                  x2="12"
                  y2="18.85"
               />
               <line
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5px"
                  x1="17.04"
                  y1="15"
                  x2="12"
                  y2="15"
               />
               <polyline
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5px"
                  points="15.39 15 18.79 15 18.79 17.82 24.83 13.08 18.79 8.34 18.79 11.15 15.39 11.15"
               />
               <line
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5px"
                  x1="13.81"
                  y1="11.15"
                  x2="18"
                  y2="11.15"
               />
               <line
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5px"
                  x1="12.96"
                  y1="15"
                  x2="18"
                  y2="15"
               />
            </>
         ),
      },
      adjust: {
         width: 30,
         height: 30,
         viewBox: [0, 0, 30, 30],
         fill: 'none',
         data: (
            <>
               <rect
                  fill="none"
                  x="0"
                  width="30"
                  height="30"
                  rx="5.02"
                  ry="5.02"
               />
               <circle
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeMiterlimit="10"
                  strokeWidth="1.5px"
                  cx="15.18"
                  cy="15.44"
                  r="7.31"
               />
               <line
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeMiterlimit="10"
                  strokeWidth="1.5px"
                  x1="12.71"
                  y1="12.12"
                  x2="12.71"
                  y2="14.58"
               />
               <line
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeMiterlimit="10"
                  strokeWidth="1.5px"
                  x1="13.94"
                  y1="13.35"
                  x2="11.48"
                  y2="13.35"
               />
               <line
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeMiterlimit="10"
                  strokeWidth="1.5px"
                  x1="18.65"
                  y1="17.68"
                  x2="16.19"
                  y2="17.68"
               />
               <line
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeMiterlimit="10"
                  strokeWidth="1.5px"
                  x1="17.97"
                  y1="12.65"
                  x2="12.39"
                  y2="18.23"
               />
            </>
         ),
      },
      selectItems: {
         width: 26,
         height: 26,
         viewBox: [0, 0, 26, 26],
         data: (
            <path
               fill="#ffca05"
               d="M12.6,0v9.4l9.4,0v3.1l-9.4,0V22H9.4v-9.4l-9.4,0V9.4l9.4,0V0H12.6z"
            />
         ),
      },
      addToCart: {
         width: 26,
         height: 26,
         viewBox: [0, 0, 26, 26],
         data: (
            <>
               <g>
                  <path
                     fill="#1D1D1D"
                     d="M2.3,18.4h1.4c-0.1,0.4-0.2,0.8-0.2,1.1c0,0.9,0.4,1.8,1,2.4s1.5,1,2.4,1s1.8-0.4,2.4-1s1-1.5,1-2.4
            c0-0.4-0.1-0.8-0.2-1.1h5c-0.1,0.4-0.2,0.8-0.2,1.1c0,0.9,0.4,1.8,1,2.4c0.6,0.6,1.5,1,2.4,1s1.8-0.4,2.4-1s1-1.5,1-2.4
            c0-0.4-0.1-0.8-0.2-1.1H23v-2.3H4.6V0H0v2.3h2.3L2.3,18.4z M8.1,19.5c0,0.2-0.1,0.4-0.2,0.6s-0.3,0.3-0.5,0.4
            c-0.2,0.1-0.4,0.1-0.7,0.1c-0.2,0-0.4-0.2-0.6-0.3c-0.2-0.2-0.3-0.4-0.3-0.6c0-0.2,0-0.5,0.1-0.7s0.2-0.4,0.4-0.5
            c0.2-0.1,0.4-0.2,0.6-0.2c0.3,0,0.6,0.1,0.8,0.3C7.9,19,8.1,19.2,8.1,19.5z M19.5,19.5c0,0.2-0.1,0.4-0.2,0.6s-0.3,0.3-0.5,0.4
            c-0.2,0.1-0.4,0.1-0.7,0.1c-0.2,0-0.4-0.2-0.6-0.3c-0.2-0.2-0.3-0.4-0.3-0.6c0-0.2,0-0.5,0.1-0.7c0.1-0.2,0.2-0.4,0.4-0.5
            s0.4-0.2,0.6-0.2c0.3,0,0.6,0.1,0.8,0.3C19.4,19,19.5,19.2,19.5,19.5z"
                  />
               </g>
               <path
                  d="M18.4,6.4h-3V3.7c0-0.7-0.5-1.2-1.2-1.2S13,3,13,3.7v2.7H9.2C8.5,6.4,8,6.9,8,7.6s0.5,1.2,1.2,1.2H13v3.5
                c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2V8.8h3c0.7,0,1.2-0.5,1.2-1.2S19.1,6.4,18.4,6.4z"
               />
            </>
         ),
      },
      removeFromCart: {
         width: 26,
         height: 26,
         viewBox: [0, 0, 26, 26],
         data: (
            <g>
               <line
                  style={{
                     fill: 'none',
                     stroke: '#000000',
                     strokeWidth: 2,
                     strokeLinecap: 'round',
                  }}
                  x1="9"
                  y1="7.6"
                  x2="18.6"
                  y2="7.6"
               />
               <path
                  d="M2.3,18.3h1.4c-0.1,0.4-0.2,0.8-0.2,1.1c0,0.9,0.4,1.8,1,2.4s1.5,1,2.4,1s1.8-0.4,2.4-1s1-1.5,1-2.4c0-0.4-0.1-0.8-0.2-1.1
                    h5c-0.1,0.4-0.1,0.8-0.2,1.2c0,0.9,0.4,1.8,1,2.4s1.5,1,2.4,1s1.8-0.4,2.4-1s1-1.5,1-2.4c0-0.4-0.1-0.8-0.2-1.1H23v-2.3H4.6V-0.1H0
                    v2.3h2.3V18.3z M8.1,19.5c0,0.2-0.1,0.4-0.2,0.6c-0.1,0.2-0.3,0.3-0.5,0.4S7,20.6,6.7,20.6c-0.2,0-0.4-0.2-0.6-0.3
                    c-0.2-0.2-0.3-0.4-0.3-0.6s0-0.5,0.1-0.7s0.2-0.4,0.4-0.5c0.2-0.1,0.4-0.2,0.6-0.2c0.3,0,0.6,0.1,0.8,0.3
                    C7.9,18.9,8.1,19.2,8.1,19.5z M19.5,19.5c0,0.2-0.1,0.4-0.2,0.6s-0.3,0.3-0.5,0.4s-0.4,0.1-0.7,0.1c-0.2,0-0.4-0.2-0.6-0.3
                    c-0.2-0.2-0.3-0.4-0.3-0.6s0-0.5,0.1-0.7s0.2-0.4,0.4-0.5c0.2-0.1,0.4-0.2,0.6-0.2c0.3,0,0.6,0.1,0.8,0.3
                    C19.4,18.9,19.5,19.2,19.5,19.5z"
               />
            </g>
         ),
      },
      cart: {
         width: 26,
         height: 26,
         viewBox: [0, 0, 26, 26],
         data: (
            <>
               <path
                  fill="#ffca05"
                  d="M2.3,18.4h1.4c-0.1,0.4-0.2,0.8-0.2,1.1c0,0.9,0.4,1.8,1,2.4s1.5,1,2.4,1s1.8-0.4,2.4-1s1-1.5,1-2.4
            c0-0.4-0.1-0.8-0.2-1.1h5c-0.1,0.4-0.2,0.8-0.2,1.1c0,0.9,0.4,1.8,1,2.4c0.6,0.6,1.5,1,2.4,1s1.8-0.4,2.4-1s1-1.5,1-2.4
            c0-0.4-0.1-0.8-0.2-1.1H23v-2.3H4.6V0H0v2.3h2.3L2.3,18.4z M8.1,19.5c0,0.2-0.1,0.4-0.2,0.6s-0.3,0.3-0.5,0.4
            c-0.2,0.1-0.4,0.1-0.7,0.1c-0.2,0-0.4-0.2-0.6-0.3c-0.2-0.2-0.3-0.4-0.3-0.6c0-0.2,0-0.5,0.1-0.7s0.2-0.4,0.4-0.5
            c0.2-0.1,0.4-0.2,0.6-0.2c0.3,0,0.6,0.1,0.8,0.3C7.9,19,8.1,19.2,8.1,19.5z M19.5,19.5c0,0.2-0.1,0.4-0.2,0.6s-0.3,0.3-0.5,0.4
            c-0.2,0.1-0.4,0.1-0.7,0.1c-0.2,0-0.4-0.2-0.6-0.3c-0.2-0.2-0.3-0.4-0.3-0.6c0-0.2,0-0.5,0.1-0.7c0.1-0.2,0.2-0.4,0.4-0.5
            s0.4-0.2,0.6-0.2c0.3,0,0.6,0.1,0.8,0.3C19.4,19,19.5,19.2,19.5,19.5z"
               />
               <path
                  fill="#ffca05"
                  d="M6.9,13.8h13.8V0H6.9L6.9,13.8z M9.2,2.3h3.4v3.4h2.3V2.3h3.4v9.2H9.2V2.3z"
               />
            </>
         ),
      },
      help: {
         width: 16,
         height: 17,
         viewBox: [0, 0, 16, 17],
         data: (
            <>
               <path
                  d="M8 1.4974C11.6733 1.4974 14.6667 4.49073 14.6667 8.16406C14.6667 11.8374 11.6733 14.8307 8 14.8307C4.32667 14.8307 1.33333 11.8374 1.33333 8.16406C1.33333 4.49073 4.32667 1.4974 8 1.4974ZM8 0.164062C3.58 0.164062 0 3.74406 0 8.16406C0 12.5841 3.58 16.1641 8 16.1641C12.42 16.1641 16 12.5841 16 8.16406C16 3.74406 12.42 0.164062 8 0.164062Z"
                  stroke="none"
               />
               <path
                  d="M6.35333 6.27733C6.39333 6.09733 6.45333 5.91066 6.54 5.73066C6.75333 5.29733 7.14 4.93066 7.83333 4.93066C9.54 4.93066 9.68667 5.884 9.64 6.51066C9.52667 8.03733 7.96 7.67066 7.96 8.884C7.96 10.0973 7.96 9.424 7.96 9.424"
                  fill="none"
                  strokeWidth="1.33333"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
               />
               <path
                  d="M8 11.3574V11.3974"
                  fill="none"
                  strokeWidth="1.33333"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
               />
            </>
         ),
      },
      history: {
         width: 16,
         height: 17,
         viewBox: [0, 0, 16, 17],
         data: (
            <>
               <path
                  d="M3.15179 3.79785H10.9077"
                  fill="none"
                  strokeWidth="1.236"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
               />
               <path
                  d="M3.15179 6.0166H5.11703"
                  fill="none"
                  strokeWidth="1.236"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
               />
               <path
                  d="M7.03284 6.0166H10.9077"
                  fill="none"
                  strokeWidth="1.236"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
               />
               <path
                  d="M13.5094 8.29672V2.48752C13.5094 1.50491 12.6875 0.713867 11.6678 0.713867H2.45962C1.4461 0.713867 0.617981 1.51109 0.617981 2.48752V11.535C0.617981 12.5177 1.43992 13.3087 2.45962 13.3087H8.20701"
                  fill="none"
                  strokeWidth="1.236"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
               />
               <path
                  stroke="none"
                  d="M11.7235 8.72916C13.3982 8.72916 14.764 10.0949 14.764 11.7697C14.764 13.4445 13.3982 14.8103 11.7235 14.8103C10.0487 14.8103 8.6829 13.4445 8.6829 11.7697C8.6829 10.0949 10.0487 8.72916 11.7235 8.72916ZM11.7235 7.49316C9.3627 7.49316 7.4469 9.40896 7.4469 11.7697C7.4469 14.1305 9.3627 16.0463 11.7235 16.0463C14.0842 16.0463 16 14.1305 16 11.7697C16 9.40896 14.0842 7.49316 11.7235 7.49316Z"
               />
               <path
                  d="M11.4639 10.4229V12.1841"
                  fill="none"
                  strokeWidth="1.236"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
               />
               <path
                  d="M12.9471 12.1836H11.4639"
                  fill="none"
                  strokeWidth="1.236"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
               />
            </>
         ),
      },
      items: {
         width: 17,
         height: 17,
         viewBox: [0, 0, 17, 17],
         data: (
            <>
               <path
                  d="M16.2065 11.4798V14.1485C16.2065 14.8406 15.6454 15.3956 14.9595 15.3956H2.70069C2.00856 15.3956 1.45361 14.8344 1.45361 14.1485V11.4798C1.45361 11.3239 1.50973 11.1742 1.61573 11.062L3.62976 8.86089C3.83553 8.63642 3.848 8.29347 3.66094 8.05653L2.02727 5.98638C1.88385 5.80555 1.85268 5.56861 1.93997 5.35661L2.79422 3.3114C2.79422 3.3114 2.9314 2.9248 3.52376 2.9248H14.205C14.735 2.9248 14.922 3.28022 14.922 3.28022L15.7576 5.36284C15.8386 5.56861 15.8075 5.80555 15.6641 5.98014L14.0179 8.05653C13.8246 8.29347 13.8371 8.63642 14.0429 8.86713L16.0507 11.0682C16.1567 11.1805 16.2128 11.3301 16.2128 11.486L16.2065 11.4798Z"
                  fill="none"
                  strokeWidth="1.24708"
                  strokeMiterlimit="10"
               />
               <path
                  d="M1.79657 5.69336H15.8823"
                  fill="none"
                  strokeWidth="1.24708"
                  strokeMiterlimit="10"
               />
               <path
                  d="M1.45361 11.2363H16.2065"
                  fill="none"
                  strokeWidth="1.24708"
                  strokeMiterlimit="10"
               />
               <path
                  d="M6.03662 2.51958L6.6851 0.960734C6.80981 0.754967 7.0717 0.624023 7.35852 0.624023H10.3016C10.5885 0.624023 10.8441 0.754967 10.975 0.960734L11.6235 2.51958"
                  fill="none"
                  strokeWidth="1.24708"
                  strokeMiterlimit="10"
               />
            </>
         ),
      },
      locations: {
         width: 14,
         height: 17,
         viewBox: [0, 0, 14, 17],
         data: (
            <>
               <path
                  d="M12.5049 7.32373C12.5049 11.763 6.56506 16.3335 6.56506 16.3335C6.56506 16.3335 0.625244 11.763 0.625244 7.32373C0.625244 4.49762 3.28253 1.58398 6.56506 1.58398C9.8476 1.58398 12.5049 4.49762 12.5049 7.32373Z"
                  fill="none"
                  strokeWidth="1.25049"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  d="M6.56506 9.83691C7.80473 9.83691 8.80969 8.83196 8.80969 7.59228C8.80969 6.35261 7.80473 5.34766 6.56506 5.34766C5.32539 5.34766 4.32043 6.35261 4.32043 7.59228C4.32043 8.83196 5.32539 9.83691 6.56506 9.83691Z"
                  fill="none"
                  strokeWidth="1.25049"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
            </>
         ),
      },
      logout: {
         width: 24,
         height: 26,
         viewBox: [0, 0, 24, 26],
         data: (
            <path
               xmlns="http://www.w3.org/2000/svg"
               fill="#000000"
               fillRule="evenodd"
               d="M44.5746495,740.26335 C45.9348238,740.702738 47,742.134327 47,743.522378 L47,760.125 L49.1363362,760.125407 C49.6626475,760.125407 50.0906899,759.704423 50.0906899,759.187519 L50.0906899,752.937296 C50.0906899,752.4198 50.5181294,752 51.0456464,752 C51.5731634,752 52,752.4198 52,752.937296 L52,759.187519 C52,760.738232 50.71527,762 49.1363362,762 L46.9899372,762.000478 C46.932075,762.65722 46.6269181,763.228443 46.132626,763.591547 C45.7654415,763.861367 45.3186813,764 44.8446381,764 C44.5769231,764 44.3012505,763.956462 44.0250095,763.866523 L37.4259189,761.736612 C36.0657446,761.297224 35,759.866208 35,758.477584 L35,740.229551 C35,739.47738 35.3165972,738.81343 35.8679424,738.408414 C36.0736824,738.257311 36.3043166,738.14741 36.5507664,738.079926 C36.665909,738.028537 36.7928659,738 36.926476,738 L49.2199868,738 C50.7533836,738 52,739.261251 52,740.812648 L52,747.062648 C52,747.580767 51.5856317,748 51.073524,748 C50.5614163,748 50.1470481,747.580767 50.1470481,747.062648 L50.1470481,740.812648 C50.1470481,740.295713 49.7315093,739.874704 49.2199868,739.874704 L43.369,739.874 L44.5746495,740.26335 Z M36.8001137,740.229551 L36.8001137,758.477584 C36.8001137,759.080811 37.3599848,759.81064 37.9744221,760.008852 L44.5746495,762.139335 C44.7832512,762.206361 44.9691171,762.201778 45.0714286,762.125587 C45.1828344,762.04424 45.1998863,761.867798 45.1998863,761.769838 L45.1989004,761.635642 C45.0742082,761.477277 45,761.278574 45,761.062704 C45,760.846833 45.0742082,760.64813 45.1989004,760.489765 L45.1998863,743.522378 C45.1998863,742.919151 44.6400152,742.189322 44.0250095,741.99111 L37.468,739.874 L36.927,739.874 L36.872432,739.932615 C36.8110269,740.023137 36.8001137,740.151642 36.8001137,740.229551 Z M55.6006987,746.270636 L58.4633714,749.088342 C58.7599681,749.235251 58.9718072,749.550805 58.9973954,749.923776 C58.9980561,749.939116 58.9989091,749.953493 58.9994216,749.96788 C58.9998344,749.977771 59,749.988864 59,750 L58.9993855,750.033848 C58.9988718,750.047837 58.9980362,750.061816 58.9968786,750.075774 L59,750 C59,750.405009 58.7808941,750.753379 58.4653571,750.910672 L55.6006987,753.72951 C55.4171527,753.909642 55.1773587,754 54.9375648,754 C54.6977708,754 54.4579768,753.909642 54.2744309,753.72951 C53.908523,753.369246 53.908523,752.784544 54.2744309,752.42428 L55.72,751 L48.9124876,751 C48.4086884,751 48,750.552748 48,750 C48,749.447252 48.4086884,749 48.9124876,749 L55.721,749 L54.2744309,747.575283 C53.908523,747.215018 53.908523,746.630317 54.2744309,746.270636 C54.6409308,745.909788 55.2341988,745.909788 55.6006987,746.270636 Z"
               transform="translate(-35 -738)"
            />
         ),
      },
      signout: {
         width: 16,
         height: 17,
         viewBox: [0, 0, 16, 17],
         data: (
            <>
               <path
                  d="M10.0718 5.48359V3.02494C10.0718 2.2449 9.43526 1.6084 8.65522 1.6084H2.04056C1.26053 1.6084 0.624023 2.2449 0.624023 3.02494V14.9438C0.624023 15.7238 1.26053 16.3603 2.04056 16.3603H8.65522C9.43526 16.3603 10.0718 15.7238 10.0718 14.9438V12.3541"
                  fill="none"
                  strokeWidth="1.24805"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
               />
               <path
                  d="M12.0998 11.512L14.1342 8.9098L12.0998 6.30762L14.1342 8.9098H6.78314"
                  fill="none"
                  strokeWidth="1.24805"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
            </>
         ),
      },
      notes: {
         width: 16,
         height: 17,
         viewBox: [0, 0, 16, 17],
         data: (
            <>
               <path
                  d="M12.8369 1.39483C13.9015 1.39483 14.7692 2.26252 14.7692 3.32714V11.0625C14.7692 13.1979 13.0338 14.9333 10.8985 14.9333H3.16308C2.09846 14.9333 1.23077 14.0656 1.23077 13.001V3.32714C1.23077 2.26252 2.09846 1.39483 3.16308 1.39483H12.8308M12.8369 0.164062H3.16308C1.41538 0.164062 0 1.57945 0 3.32714V12.9948C0 14.7425 1.41538 16.1579 3.16308 16.1579H10.8985C13.7169 16.1579 16 13.8748 16 11.0564V3.32714C16 1.57945 14.5846 0.164062 12.8369 0.164062Z"
                  stroke="none"
               />
               <path
                  d="M4.89844 4.91504H10.96"
                  fill="none"
                  strokeWidth="1.23077"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
               />
               <path
                  d="M4.89844 8.16406H10.96"
                  fill="none"
                  strokeWidth="1.23077"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
               />
               <path
                  d="M4.89844 11.4131H9.75382"
                  fill="none"
                  strokeWidth="1.23077"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
               />
            </>
         ),
      },
      profile: {
         width: 16,
         height: 17,
         viewBox: [0, 0, 16, 17],
         data: (
            <>
               <path
                  d="M8.70154 2.80371V4.37294"
                  fill="none"
                  strokeWidth="0.615385"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  d="M7.29846 4.37294V2.80371"
                  fill="none"
                  strokeWidth="0.615385"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  d="M12.1539 13.986C11.9077 12.3122 9.93233 11.543 8.08002 11.543C6.23387 11.543 4.25848 12.3122 4.01233 13.986"
                  fill="none"
                  strokeWidth="1.23077"
                  strokeMiterlimit="10"
               />
               <path
                  d="M10.5354 6.12109C10.8923 6.12109 11.3723 6.41032 11.3723 6.76725V6.94571C11.3723 7.30263 11.0831 7.59186 10.7261 7.59186H7.99999H5.27384C4.91692 7.59186 4.62769 7.30263 4.62769 6.94571V6.76725C4.62769 6.41032 5.11384 6.12109 5.47076 6.12109"
                  fill="none"
                  strokeWidth="1.23077"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  d="M5.58154 6.12106V5.65336C5.58154 4.82259 5.95693 3.78259 6.81231 3.59182L7.18154 3.08105H8.71385L9.05231 3.59182C9.90154 3.77644 10.4185 4.71798 10.4185 5.65336V6.12106"
                  fill="none"
                  strokeWidth="1.23077"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  d="M10.7939 8.13281C10.7939 9.70204 9.54464 10.9759 8.00002 10.9759C6.45541 10.9759 5.20618 9.70204 5.20618 8.13281"
                  fill="none"
                  strokeWidth="1.23077"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  stroke="none"
                  d="M8 1.39483C11.7354 1.39483 14.7692 4.42868 14.7692 8.16406C14.7692 11.8994 11.7354 14.9333 8 14.9333C4.26462 14.9333 1.23077 11.8994 1.23077 8.16406C1.23077 4.42868 4.26462 1.39483 8 1.39483ZM8 0.164062C3.58154 0.164062 0 3.7456 0 8.16406C0 12.5825 3.58154 16.1641 8 16.1641C12.4185 16.1641 16 12.5825 16 8.16406C16 3.7456 12.4185 0.164062 8 0.164062Z"
               />
            </>
         ),
      },
      settings: {
         width: 16,
         height: 17,
         viewBox: [0, 0, 16, 17],
         data: (
            <>
               <path
                  d="M15.3608 9.23899V8.11394C15.3608 7.76236 15.0987 7.4747 14.7535 7.43635L14.1462 7.37243C13.8778 7.34047 13.654 7.15509 13.5709 6.893C13.475 6.58617 13.3472 6.29212 13.2066 6.00447C13.0851 5.76156 13.1043 5.47391 13.2769 5.25657L13.654 4.78353C13.8714 4.50866 13.8522 4.11873 13.6029 3.86943L12.8039 3.07039C12.5546 2.82109 12.1646 2.80191 11.8897 3.01925L11.4167 3.3964C11.2058 3.56899 10.9117 3.59456 10.6688 3.46671C10.3876 3.31969 10.0871 3.19824 9.78028 3.10235C9.52459 3.01925 9.33282 2.79552 9.30085 2.52704L9.23054 1.91977C9.19218 1.57459 8.89814 1.3125 8.55295 1.3125H7.4279C7.07632 1.3125 6.78867 1.57459 6.75032 1.91977L6.68639 2.52704C6.65443 2.79552 6.46905 3.01925 6.20697 3.10235C5.90014 3.19824 5.60609 3.32608 5.31843 3.46671C5.07553 3.58817 4.78787 3.56899 4.57053 3.3964L4.0975 3.01925C3.82263 2.80191 3.4327 2.82109 3.1834 3.07039L2.38436 3.86943C2.13505 4.11873 2.11588 4.50866 2.33322 4.78353L2.71036 5.25657C2.88296 5.46751 2.90853 5.76156 2.78068 6.00447C2.63366 6.28573 2.5122 6.58617 2.41632 6.893C2.33322 7.1487 2.10949 7.34047 1.84101 7.37243L1.23374 7.44274C0.88855 7.4811 0.626465 7.77514 0.626465 8.12033V9.24538C0.626465 9.59696 0.88855 9.88461 1.23374 9.92297L1.84101 9.98689C2.10949 10.0189 2.33322 10.2042 2.41632 10.4663C2.5122 10.7731 2.64005 11.0672 2.78068 11.3548C2.90213 11.5978 2.88296 11.8854 2.71036 12.1028L2.33322 12.5758C2.11588 12.8507 2.13505 13.2406 2.38436 13.4899L3.1834 14.2889C3.4327 14.5382 3.82263 14.5574 4.0975 14.3401L4.57053 13.9629C4.78148 13.7903 5.07553 13.7648 5.31843 13.8926C5.5997 14.0396 5.90014 14.1611 6.20697 14.257C6.46266 14.3401 6.65443 14.5638 6.68639 14.8323L6.75671 15.4395C6.79506 15.7847 7.08911 16.0468 7.43429 16.0468H8.55934C8.91092 16.0468 9.19858 15.7847 9.23693 15.4395L9.30085 14.8323C9.33282 14.5638 9.51819 14.3401 9.78028 14.257C10.0871 14.1611 10.3812 14.0332 10.6688 13.8926C10.9117 13.7711 11.1994 13.7903 11.4167 13.9629L11.8897 14.3401C12.1646 14.5574 12.5546 14.5382 12.8039 14.2889L13.6029 13.4899C13.8522 13.2406 13.8714 12.8507 13.654 12.5758L13.2769 12.1028C13.1043 11.8918 13.0787 11.5978 13.2066 11.3548C13.3536 11.0736 13.475 10.7731 13.5709 10.4663C13.654 10.2106 13.8778 10.0189 14.1462 9.98689L14.7535 9.91657C15.0987 9.87822 15.3608 9.58417 15.3608 9.23899Z"
                  fill="none"
                  strokeWidth="1.27847"
                  strokeMiterlimit="10"
               />
               <path
                  d="M7.99678 11.3419C9.46895 11.3419 10.6624 10.1485 10.6624 8.67634C10.6624 7.20417 9.46895 6.01074 7.99678 6.01074C6.52461 6.01074 5.33118 7.20417 5.33118 8.67634C5.33118 10.1485 6.52461 11.3419 7.99678 11.3419Z"
                  fill="none"
                  strokeWidth="1.27847"
                  strokeMiterlimit="10"
               />
            </>
         ),
      },
      subscriptions: {
         width: 12,
         height: 17,
         viewBox: [0, 0, 12, 17],
         data: (
            <>
               <path
                  d="M9.38445 0.699219H2.02556C1.24899 0.699219 0.619446 1.32876 0.619446 2.10534V14.0542C0.619446 14.8308 1.24899 15.4603 2.02556 15.4603H9.38445C10.161 15.4603 10.7906 14.8308 10.7906 14.0542V2.10534C10.7906 1.32876 10.161 0.699219 9.38445 0.699219Z"
                  fill="none"
                  strokeWidth="1.23887"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
               />
               <path
                  d="M5.98995 2.83619L6.77044 4.22373L8.33142 4.53344C8.58539 4.583 8.6845 4.89272 8.51105 5.07855L7.42704 6.24928L7.61287 7.83503C7.64384 8.089 7.38368 8.28103 7.1483 8.16953L5.69882 7.50054L4.24934 8.16953C4.01396 8.27483 3.75379 8.089 3.78477 7.83503L3.9706 6.24928L2.88659 5.07855C2.71314 4.89272 2.81225 4.583 3.06622 4.53344L4.6272 4.22373L5.40768 2.83619C5.53157 2.6132 5.85368 2.6132 5.97756 2.83619H5.98995Z"
                  fill="none"
                  strokeWidth="1.23887"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
               />
               <path
                  d="M4.1626 10.3193H7.24738"
                  fill="none"
                  strokeWidth="1.23887"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
               />
               <path
                  d="M4.1626 12.3389H7.24738"
                  fill="none"
                  strokeWidth="1.23887"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
               />
            </>
         ),
      },
      audit: {
         width: 25,
         height: 26,
         viewBox: [0, 0, 25, 26],
         data: (
            <path
               xmlns="http://www.w3.org/2000/svg"
               stroke="none"
               fillRule="evenodd"
               d="M57.0658423,398 C59.2350477,398 61,399.763158 61,401.930159 L61,420.069841 C61,422.236842 59.2350477,424 57.0658423,424 L41.9341577,424 C39.7649523,424 38,422.236842 38,420.069841 L38,420 L36.937352,420 C36.456791,420 36.0604734,419.613936 36.0063085,419.116363 L36,418.999684 C36,418.447111 36.4198247,418 36.937352,418 L36.937352,418 L38,418 L38,415 L36.937352,415 C36.456791,415 36.0604734,414.613936 36.0063085,414.116363 L36,413.999684 C36,413.447111 36.4198247,413 36.937352,413 L36.937352,413 L38,413 L38,409 L36.937352,409 C36.456791,409 36.0604734,408.613936 36.0063085,408.116363 L36,407.999684 C36,407.447742 36.4198247,407 36.937352,407 L36.937352,407 L38,407 L38,404 L36.937352,404 C36.456791,404 36.0604734,403.614481 36.0063085,403.116986 L36,403.000316 C36,402.447742 36.4198247,402 36.937352,402 L36.937352,402 L38,402 L38,401.930159 C38,399.763158 39.7649523,398 41.9341577,398 L57.0658423,398 Z M44,399.814 L41.9341577,399.81414 C40.766124,399.81414 39.8159856,400.763886 39.8159856,401.930159 L39.815,402 L40.062648,402 C40.543209,402 40.9395266,402.386064 40.9936915,402.883637 L41,403.000316 C41,403.552889 40.5801753,404 40.062648,404 L40.062648,404 L39.815,404 L39.815,407 L40.062648,407 C40.543209,407 40.9395266,407.386064 40.9936915,407.883131 L41,407.999684 C41,408.552258 40.5801753,409 40.062648,409 L40.062648,409 L39.815,409 L39.815,413 L40.062648,413 C40.543209,413 40.9395266,413.385519 40.9936915,413.883014 L41,413.999684 C41,414.552258 40.5801753,415 40.062648,415 L40.062648,415 L39.815,415 L39.815,418 L40.062648,418 C40.543209,418 40.9395266,418.385519 40.9936915,418.883014 L41,418.999684 C41,419.552258 40.5801753,420 40.062648,420 L40.062648,420 L39.815,420 L39.8159856,420.069841 C39.8159856,421.236687 40.766124,422.186433 41.9341577,422.186433 L44,422.186 L44,399.814 Z M57.0531195,399.8141 L45.8215929,399.8141 L45.8215929,422.1859 L57.0531195,422.1859 C58.2247598,422.1859 59.1784071,421.236175 59.1784071,420.069354 L59.1784071,401.930646 C59.1784071,400.763825 58.2247598,399.8141 57.0531195,399.8141 Z M54.0771025,415 C54.5866492,415 55,415.447742 55,416.000316 C55,416.552889 54.5866492,417 54.0771025,417 L47.9228975,417 C47.4127678,417 47,416.552889 47,416.000316 C47,415.447742 47.4127678,415 47.9228975,415 L54.0771025,415 Z M57.0829474,410 C57.5895263,410 58,410.447742 58,411.000316 C58,411.552889 57.5895263,412 57.0829474,412 L47.9164737,412 C47.4098947,412 47,411.552889 47,411.000316 C47,410.447742 47.4098947,410 47.9164737,410 L57.0829474,410 Z M57.0829474,405 C57.5895263,405 58,405.447742 58,406.000316 C58,406.552258 57.5895263,407 57.0829474,407 L47.9164737,407 C47.4098947,407 47,406.552258 47,406.000316 C47,405.447742 47.4098947,405 47.9164737,405 L57.0829474,405 Z"
               transform="translate(-36 -398)"
            />
         ),
      },
      connections: {
         width: 16,
         height: 17,
         viewBox: [0, 0, 16, 17],
         data: (
            <>
               <path
                  d="M9.01442 13.4359V15.3387C9.01442 15.3947 9.09526 15.4258 9.15122 15.3947L14.5239 11.7445L9.12635 8.09426C9.07038 8.05695 8.98333 8.09426 8.98333 8.14401V10.0406L1.07971 10.0904C1.07971 14.0577 9.0082 13.4421 9.0082 13.4421L9.01442 13.4359Z"
                  fill="none"
                  strokeWidth="1.24368"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  d="M12.447 10.0094C12.447 7.74594 10.3701 5.60059 7.80807 5.60059C5.24608 5.60059 3.16913 7.43502 3.16913 9.69231"
                  fill="none"
                  strokeWidth="1.24368"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  d="M7.80803 5.60025C9.21954 5.60025 10.3638 4.49219 10.3638 3.12532C10.3638 1.75846 9.21954 0.650391 7.80803 0.650391C6.39652 0.650391 5.25226 1.75846 5.25226 3.12532C5.25226 4.49219 6.39652 5.60025 7.80803 5.60025Z"
                  fill="none"
                  strokeWidth="1.24368"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
            </>
         ),
      },
      dashboard: {
         width: 16,
         height: 16,
         viewBox: [0, 0, 16, 16],
         data: (
            <>
               <path
                  d="M6.15385 1.23077V6.15385H1.23077V1.23077H6.15385ZM6.15385 0H1.23077C0.553846 0 0 0.553846 0 1.23077V6.15385C0 6.83077 0.553846 7.38462 1.23077 7.38462H6.15385C6.83077 7.38462 7.38462 6.83077 7.38462 6.15385V1.23077C7.38462 0.553846 6.83077 0 6.15385 0Z"
                  stroke="none"
               />
               <path
                  d="M14.7692 1.23077V6.15385H9.84613V1.23077H14.7692ZM14.7692 0H9.84613C9.1692 0 8.61536 0.553846 8.61536 1.23077V6.15385C8.61536 6.83077 9.1692 7.38462 9.84613 7.38462H14.7692C15.4461 7.38462 16 6.83077 16 6.15385V1.23077C16 0.553846 15.4461 0 14.7692 0Z"
                  stroke="none"
               />
               <path
                  d="M6.15385 9.846V14.7691H1.23077V9.846H6.15385ZM6.15385 8.61523H1.23077C0.553846 8.61523 0 9.16908 0 9.846V14.7691C0 15.446 0.553846 15.9999 1.23077 15.9999H6.15385C6.83077 15.9999 7.38462 15.446 7.38462 14.7691V9.846C7.38462 9.16908 6.83077 8.61523 6.15385 8.61523Z"
                  stroke="none"
               />
               <path
                  d="M14.7692 9.846V14.7691H9.84613V9.846H14.7692ZM14.7692 8.61523H9.84613C9.1692 8.61523 8.61536 9.16908 8.61536 9.846V14.7691C8.61536 15.446 9.1692 15.9999 9.84613 15.9999H14.7692C15.4461 15.9999 16 15.446 16 14.7691V9.846C16 9.16908 15.4461 8.61523 14.7692 8.61523Z"
                  stroke="none"
               />
            </>
         ),
      },
      discounts: {
         width: 27,
         height: 27,
         viewBox: [0, 0, 27, 27],
         data: (
            <path
               xmlns="http://www.w3.org/2000/svg"
               stroke="none"
               d="M54.6673276,401 C55.0811292,401 55.4226298,401.30967 55.4727198,401.709901 L55.4790445,401.811719 L55.4290445,413.035156 L59.2884102,413.035156 C60.0309764,413.035156 60.3660529,413.941005 59.859612,414.424895 L59.7814918,414.491008 L47.5376236,426.93733 C47.2809502,427.130124 46.9384238,427.151546 46.6587274,426.998143 L46.5570768,426.932415 L34.3244434,414.495925 C33.7306802,414.049982 34.0067604,413.124395 34.7087699,413.041172 L34.8119065,413.035156 L38.6212722,413.085156 L38.6212722,401.811719 C38.6212722,401.397916 38.9309419,401.056415 39.3311718,401.006325 L39.4329892,401 L54.6673276,401 Z M40.2447061,402.573437 L40.2447061,413.846875 C40.2447061,414.260678 39.9350364,414.602179 39.5348065,414.652269 L39.4329892,414.658594 L37.1311667,414.574581 L47.0135099,425.301612 L57.0057985,414.658594 L54.6673276,414.658594 C54.2535259,414.658594 53.9120253,414.348923 53.8619353,413.948693 L53.8556107,413.846875 L53.8550245,402.623 L40.2447061,402.573437 Z M50.097026,411.764844 C51.3570582,411.764844 52.3821768,412.789965 52.3821768,414.05 C52.3821768,415.310035 51.3570582,416.335156 50.097026,416.335156 C48.8369939,416.335156 47.8118753,415.310035 47.8118753,414.05 C47.8118753,412.789965 48.8369939,411.764844 50.097026,411.764844 Z M50.519525,405.799012 C50.8404364,406.012907 50.946631,406.42812 50.7823318,406.765453 L50.7307745,406.855313 L44.6370392,415.995938 C44.4038522,416.34582 43.9309784,416.44068 43.5807409,416.207238 C43.2598761,415.993343 43.1536427,415.57813 43.3179352,415.240797 L43.3694914,415.150938 L49.4632268,406.010313 C49.6965661,405.660277 50.1694907,405.565723 50.519525,405.799012 Z M50.097026,413.288281 C49.6770153,413.288281 49.3353091,413.629988 49.3353091,414.05 C49.3353091,414.470012 49.6770153,414.811719 50.097026,414.811719 C50.5170368,414.811719 50.858743,414.470012 50.858743,414.05 C50.858743,413.629988 50.5170368,413.288281 50.097026,413.288281 Z M44.0032907,405.671094 C45.2633228,405.671094 46.2884414,406.696215 46.2884414,407.95625 C46.2884414,409.216285 45.2633228,410.241406 44.0032907,410.241406 C42.7432586,410.241406 41.7181399,409.216285 41.7181399,407.95625 C41.7181399,406.696215 42.7432586,405.671094 44.0032907,405.671094 Z M44.0032907,407.194531 C43.58328,407.194531 43.2415738,407.536238 43.2415738,407.95625 C43.2415738,408.376262 43.58328,408.717969 44.0032907,408.717969 C44.4233014,408.717969 44.7650076,408.376262 44.7650076,407.95625 C44.7650076,407.536238 44.4233014,407.194531 44.0032907,407.194531 Z"
               transform="translate(-34 -401)"
            />
         ),
      },
      'global-prices': {
         width: 30,
         height: 30,
         viewBox: [0, 0, 30, 30],
         data: (
            <>
               <path
                  stroke="none"
                  d="M15,4c6.07,0,11,4.93,11,11s-4.93,11-11,11-11-4.93-11-11S8.93,4,15,4M15,2C7.82,2,2,7.82,2,15s5.82,13,13,13,13-5.82,13-13S22.18,2,15,2h0Z"
               />
               <path
                  fill="none"
                  strokeLinecap="round"
                  strokeMiterlimit="10"
                  strokeWidth="2"
                  d="M18.48,10c-.44-.61-.98-1.17-1.65-1.54s-2.46-.48-3.22-.31c-1.13.25-1.95,1.26-2.06,2.33s.44,2.17,1.3,2.9c.86.74,1.98,1.13,3.01,1.63s2.07,1.18,2.49,2.19c.44,1.08.05,2.36-.84,3.14s-2.2,1.07-3.42.89c-1.09-.16-2.18-.74-2.64-1.69"
               />
               <path
                  fill="none"
                  strokeLinecap="round"
                  strokeMiterlimit="10"
                  strokeWidth="2"
                  d="M14.98,6.06v17.87"
               />
            </>
         ),
      },
      'fast-forward': {
         width: 26,
         height: 26,
         viewBox: [0, 0, 26, 26],
         data: (
            <path
               xmlns="http://www.w3.org/2000/svg"
               d="M5.064 4.111V21.62l8-7.998v7.998l8.756-8.754-8.756-8.754v7.998l-8-7.998z"
               transform="scale(.26458)"
            />
         ),
      },
      delete: {
         width: 26,
         height: 26,
         viewBox: [0, 0, 1000, 1000],
         data: (
            <path d="M819,316.2v551.3c0,67.7-51.9,122.5-116,122.5H297c-64,0-116-54.9-116-122.5V316.2c-32.1,0-58-27.4-58-61.2v-61.3c0-33.8,26-61.3,58-61.3h174V71.2c0-33.8,26-61.2,58-61.2h174c32,0,58,27.4,58,61.2v61.2h174c32,0,58,27.4,58,61.3V255C877,288.8,851,316.2,819,316.2z M239.1,867.5c0,33.8,26,61.2,58,61.2H703c32.1,0,58-27.4,58-61.2V316.2c-32.6,0-26,0-58,0H297c-32,0-18.1,0-58,0L239.1,867.5L239.1,867.5z M587,101.9c0-16.9-13-30.6-29-30.6H442c-16,0-29,13.7-29,30.6v30.6c18.5,0,22.7,0,23.4,0c0,0,0.3,0,0.3,0c0.5,0,1.7,0,5.2,0h116c16,0,0.9,0,29,0L587,101.9L587,101.9z M790,193.7H210.1c-16,0-29,13.7-29,30.6c0,16.9,13,30.6,29,30.6H790c16,0,29-13.7,29-30.6C819,207.4,806,193.7,790,193.7z M355,438.7c16,0,29,13.7,29,30.6v367.5c0,16.9-13,30.6-29,30.6c-16,0-29-13.7-29-30.6V469.3C326.1,452.4,339,438.7,355,438.7z M500,438.7c16,0,29,13.7,29,30.6v367.5c0,16.9-13,30.6-29,30.6c-16,0-29-13.7-29-30.6V469.3C471,452.4,484,438.7,500,438.7z M645,438.7c16,0,29,13.7,29,30.6v367.5c0,16.9-13,30.6-29,30.6c-16,0-29-13.7-29-30.6V469.3C616,452.4,629,438.7,645,438.7z" />
         ),
      },
      'delete-outlined': {
         width: 11,
         height: 14,
         viewBox: [0, 0, 11, 14],
         fill: 'none',
         data: (
            <>
               <g clipPath="url(#clip0_7035_4345)">
                  <path
                     d="M6.65884 12.6407H3.82658C3.2501 12.6407 2.74881 12.2313 2.6402 11.6548L1.27002 4.31934H9.19033L7.83686 11.6548C7.72825 12.2229 7.23532 12.6407 6.65048 12.6407H6.65884Z"
                     stroke="#FF2222"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                  />
                  <path
                     d="M6.46666 6.5083L3.99365 8.98131"
                     stroke="#FF2222"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                  />
                  <path
                     d="M6.46666 8.98131L3.99365 6.5083"
                     stroke="#FF2222"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                  />
                  <path
                     d="M2.04702 2.19727H8.41334C9.19869 2.19727 9.83365 2.83223 9.83365 3.61757V4.10215C9.83365 4.21912 9.74175 4.31937 9.61643 4.31937H0.843933C0.726966 4.31937 0.626709 4.22747 0.626709 4.10215V3.61757C0.626709 2.83223 1.26167 2.19727 2.04702 2.19727Z"
                     stroke="#FF2222"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                  />
                  <path
                     d="M5.22164 0.626709H5.2467C5.91509 0.626709 6.45814 1.16977 6.45814 1.83815V2.20576H4.01855V1.83815C4.01855 1.16977 4.56161 0.626709 5.23 0.626709H5.22164Z"
                     stroke="#FF2222"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                  />
               </g>
               <defs>
                  <clipPath id="clip0_7035_4345">
                     <rect width="10.4685" height="13.2674" fill="white" />
                  </clipPath>
               </defs>
            </>
         ),
      },
      'reviewed-outlined': {
         width: 13,
         height: 13,
         viewBox: [0,0,13,13],
         fill: 'none',
         data: (
            <>
               <path d="M6.5 12.5C9.81371 12.5 12.5 9.81371 12.5 6.5C12.5 3.18629 9.81371 0.5 6.5 0.5C3.18629 0.5 0.5 3.18629 0.5 6.5C0.5 9.81371 3.18629 12.5 6.5 12.5Z" stroke="#346216" stroke-miterlimit="10" stroke-linecap="round"/>
               <path d="M3.578 6.76265C4.32492 7.91176 5.14572 8.53556 5.50687 8.77359C5.62178 8.84746 5.76952 8.83925 5.87622 8.74897C6.45899 8.24828 7.17308 7.49315 9.12657 4.71887" stroke="#346216" stroke-miterlimit="10" stroke-linecap="round"/>
            </>
         )
      },
      'export-row': {
         width: 23,
         height: 26,
         viewBox: [0, 0, 20, 20],
         data: (
            <path
               d="M13.5,0.31880729 L13.5,2.24980729 L19.75,2.25 L19.75,17.75 L13.5,17.7498073 L13.5,19.6811927 L0.5,18.1954784 L0.5,1.80452158 L13.5,0.31880729 Z M12,2 L2,3.14285714 L2,16.8571429 L12,18 L12,2 Z M9.9472136,3.60557281 C10.4059079,3.83491997 10.6113142,4.36922917 10.4405643,4.83989576 L10.3944272,4.9472136 L7.86778094,9.99978094 L10.3944272,15.0527864 C10.6414164,15.5467649 10.4411921,16.1474379 9.9472136,16.3944272 C9.48851928,16.6237744 8.93782813,16.4675139 8.66374483,16.048514 L8.60557281,15.9472136 L6.74978094,12.2357809 L5.39442719,14.9472136 C5.14743794,15.4411921 4.5467649,15.6414164 4.0527864,15.3944272 C3.59409209,15.16508 3.38868578,14.6307708 3.55943572,14.1601042 L3.60557281,14.0527864 L5.63178094,9.99978094 L3.60557281,5.9472136 C3.35858356,5.4532351 3.55880791,4.85256206 4.0527864,4.60557281 C4.51148072,4.37622565 5.06217187,4.53248613 5.33625517,4.95148603 L5.39442719,5.0527864 L6.74978094,7.76378094 L8.60557281,4.0527864 C8.85256206,3.55880791 9.4532351,3.35858356 9.9472136,3.60557281 Z M18.25,3.75 L13.75,3.75 L13.75,5.99980729 L16,6 L16,8 L13.75,7.99980729 L13.75,8.99980729 L16,9 L16,11 L13.75,10.9998073 L13.75,11.9998073 L16,12 L16,14 L13.75,13.9998073 L13.75,16.25 L18.25,16.25 L18.25,3.75 Z"
               id="Combined-Shape"
               fill="#000000"
            />
         ),
      },
      edit: {
         width: 26,
         height: 26,
         viewBox: [0, 0, 26, 26],
         data: (
            <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"></path>
         ),
      },
      edit2: {
         width: 26,
         height: 26,
         viewBox: [0, 0, 26, 26],
         data: (
            <path
               d="m 6.0908219,3.4507416 v 2.813053 H 0.3437542 V 0.63768821 H 3.2172881 V 1.2002988 H 0.918461 V 5.7011837 H 5.5161151 V 3.4507416 Z M 2.3552279,3.5379465 4.6603768,1.276814 5.106924,1.8509588 2.7744765,4.2946576 H 2.3552279 Z M 1.7805212,4.8572685 H 3.0207384 L 5.8675483,1.8515207 4.6758938,0.5167269 1.7805212,3.3005243 Z"
               id="icons/UI/edit_cover-[#1481]"
               fill="#000000"
            />
         ),
      },
      'edit-outlined': {
         width: 12,
         height: 12,
         viewBox: [0, 0, 12, 12],
         fill: 'none',
         data: (
            <>
               <g clipPath="url(#clip0_7035_4336)">
                  <path
                     fillRule="evenodd"
                     clipRule="evenodd"
                     d="M3.60262 10.7101L11.0901 3.07207L8.98852 0.928223L1.50103 8.56627L0.909668 11.0721L3.60262 10.7101Z"
                     stroke="black"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                  />
                  <path
                     d="M7.06006 2.89551L9.16165 5.03936"
                     stroke="black"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                  />
               </g>
               <defs>
                  <clipPath id="clip0_7035_4336">
                     <rect width="12" height="12" fill="white" />
                  </clipPath>
               </defs>
            </>
         ),
      },
      close: {
         width: 26,
         height: 26,
         viewBox: [0, 0, 26, 26],
         data: (
            <path d="m1.106.527-.538.537L2.77 3.266.568 5.467l.538.537 2.201-2.201L5.51 6.004l.537-.537-2.201-2.201 2.201-2.202L5.51.527 3.307 2.73Z" />
         ),
      },
      ellipsis: {
         width: 26,
         height: 26,
         viewBox: [0, 0, 26, 26],
         data: (
            <path d="M 1.517034,5.5066398 A 0.46973664,0.46973664 0 0 0 1.0465702,5.9771036 0.46973664,0.46973664 0 0 0 1.517034,6.4468402 0.46973664,0.46973664 0 0 0 1.9867706,5.9771036 0.46973664,0.46973664 0 0 0 1.517034,5.5066398 Z m 1.766966,0 A 0.46973664,0.46973664 0 0 0 2.8149905,5.9771036 0.46973664,0.46973664 0 0 0 3.2832729,6.4468402 0.46973664,0.46973664 0 0 0 3.7537366,5.9771036 0.46973664,0.46973664 0 0 0 3.2832729,5.5066398 Z m 1.766966,0 A 0.46973664,0.46973664 0 0 0 4.5812293,5.9771036 0.46973664,0.46973664 0 0 0 5.0516931,6.4468402 0.46973664,0.46973664 0 0 0 5.5214298,5.9771036 0.46973664,0.46973664 0 0 0 5.0516931,5.5066398 Z" />
         ),
      },
      glass: {
         width: 19,
         height: 21,
         viewBox: [0, 0, 19, 21],
         data: (
            <>
               <g clipPath="url(#clip0_7035_3139)">
                  <path
                     d="M8.94 1.5C13.04 1.5 16.38 4.84 16.38 8.94C16.38 13.04 13.04 16.38 8.94 16.38C4.84 16.38 1.5 13.04 1.5 8.94C1.5 4.84 4.84 1.5 8.94 1.5ZM8.94 0C4 0 0 4 0 8.94C0 13.88 4 17.88 8.94 17.88C13.88 17.88 17.88 13.88 17.88 8.94C17.88 4 13.87 0 8.94 0Z"
                     fill="#6F7680"
                  />
                  <path
                     d="M13.8799 15.8401L18.0399 20.0001"
                     stroke="#6F7680"
                     strokeWidth="1.5"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                  />
               </g>
               <defs>
                  <clipPath id="clip0_7035_3139">
                     <rect width="18.79" height="20.75" fill="white" />
                  </clipPath>
               </defs>
            </>
         ),
      },
      error: {
         width: 26,
         height: 26,
         viewBox: [0, 0, 26, 26],
         data: (
            <path d="M 2.8504579,4.6512356 H 3.6696547 V 5.312161 H 2.8504579 Z m 0,-3.2941754 H 3.6696547 V 4.3164716 H 2.8504579 Z M 3.3007812,0.27148438 A 3.0431712,3.0431712 0 0 0 0.2578125,3.3144531 3.0431712,3.0431712 0 0 0 3.3007812,6.3574219 3.0431712,3.0431712 0 0 0 6.34375,3.3144531 3.0431712,3.0431712 0 0 0 3.3007812,0.27148438 Z m 0,0.63671874 a 2.4060707,2.4060707 0 0 1 2.40625,2.40624998 2.4060707,2.4060707 0 0 1 -2.40625,2.40625 2.4060707,2.4060707 0 0 1 -2.40624995,-2.40625 2.4060707,2.4060707 0 0 1 2.40624995,-2.40624998 z" />
         ),
      },
      warning: {
         width: 26,
         height: 26,
         viewBox: [0, 0, 26, 26],
         data: (
            <path d="M 2.9589005,4.757654 H 3.5612121 V 5.2535005 H 2.9589005 Z m 0,-1.9050685 H 3.5612121 V 4.6026261 H 2.9589005 Z M 3.28125,0.28515625 0.3125,6.1914062 H 6.25 Z m 0,1.34179685 1.9882812,3.9550781 H 1.2929688 Z" />
         ),
      },
      information: {
         width: 26,
         height: 26,
         viewBox: [0, 0, 26, 26],
         data: (
            <path d="M 2.8504579,1.9776707 H 3.6696547 V 1.3167453 H 2.8504579 Z m 0,3.2941754 H 3.6696547 V 2.3124347 H 2.8504579 Z M 3.3007812,6.3574219 A 3.0431712,-3.0431712 0 0 1 0.2578125,3.3144532 3.0431712,-3.0431712 0 0 1 3.3007812,0.27148438 3.0431712,-3.0431712 0 0 1 6.34375,3.3144532 3.0431712,-3.0431712 0 0 1 3.3007812,6.3574219 Z m 0,-0.6367187 a 2.4060707,-2.4060707 0 0 0 2.40625,-2.40625 2.4060707,-2.4060707 0 0 0 -2.40625,-2.40625002 2.4060707,-2.4060707 0 0 0 -2.40624995,2.40625002 2.4060707,-2.4060707 0 0 0 2.40624995,2.40625 z" />
         ),
      },
      success: {
         width: 26,
         height: 26,
         viewBox: [0, 0, 26, 26],
         data: (
            <path d="m 2.319352,2.6768057 -0.7089844,0.4101563 0.9247003,1.5187398 0.015625,-0.00781 0.00391,0.00781 L 5.1190523,3.1252331 4.708896,2.4162487 2.8397554,3.4963268 Z M 3.3007812,0.27148438 A 3.0431712,3.0431712 0 0 0 0.2578125,3.3144531 3.0431712,3.0431712 0 0 0 3.3007812,6.3574219 3.0431712,3.0431712 0 0 0 6.34375,3.3144531 3.0431712,3.0431712 0 0 0 3.3007812,0.27148438 Z m 0,0.63671874 a 2.4060707,2.4060707 0 0 1 2.40625,2.40624998 2.4060707,2.4060707 0 0 1 -2.40625,2.40625 2.4060707,2.4060707 0 0 1 -2.40624995,-2.40625 2.4060707,2.4060707 0 0 1 2.40624995,-2.40624998 z" />
         ),
      },
      plus: {
         width: 26,
         height: 26,
         viewBox: [0, 0, 8, 8],
         data: (
            <path d="M 0.22613819,2.9305425 0.22551443,3.6010817 H 2.9725423 L 2.9719185,6.3474858 3.6424577,6.3468621 V 3.6010817 l 2.7470279,-0.00124 V 2.9299225 H 3.6437053 L 3.6430815,0.18351838 H 2.973166 V 2.93179 Z" />
         ),
      },
      add: {
         width: 18,
         height: 19,
         viewBox: [0, 0, 18, 19],
         fill: 'none',
         data: (
            <>
               <path
                  d="M9 4.6731V14.3269"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  d="M13.8269 9.5H4.1731"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  d="M9 17.5C13.4183 17.5 17 13.9183 17 9.5C17 5.08172 13.4183 1.5 9 1.5C4.58172 1.5 1 5.08172 1 9.5C1 13.9183 4.58172 17.5 9 17.5Z"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
            </>
         ),
      },
      'excel-export': {
         width: 19,
         height: 19,
         viewBox: [0, 0, 19, 19],
         fill: 'none',
         data: (
            <>
               <path
                  d="M5.93408 4.88062H8.50125"
                  stroke="black"
                  strokeWidth="2"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
               />
               <path
                  d="M5.93408 7.91211H8.50125"
                  stroke="black"
                  strokeWidth="2"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
               />
               <path
                  d="M5.93408 10.9436H8.50125"
                  stroke="black"
                  strokeWidth="2"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
               />
               <path
                  d="M11.0884 4.88062H13.6555"
                  stroke="black"
                  strokeWidth="2"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
               />
               <path
                  d="M11.0884 7.91211H13.6555"
                  stroke="black"
                  strokeWidth="2"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
               />
               <path
                  d="M11.0884 10.9436H13.6555"
                  stroke="black"
                  strokeWidth="2"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
               />
               <path
                  d="M8.01758 16.6137L9.79536 18.0001L11.5731 16.6137L9.79536 18.0001V14.0996"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  d="M5.19797 14.3665H2.99565C2.26596 14.3665 1.66895 13.7695 1.66895 13.0398V2.3267C1.66895 1.59702 2.26596 1 2.99565 1H16.5943C17.324 1 17.921 1.59702 17.921 2.3267V13.0398C17.921 13.7695 17.324 14.3665 16.5943 14.3665H14.4583"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
            </>
         ),
      },
      export: {
         width: 26,
         height: 26,
         data: (
            <path d="M 3.0422787,4.5471422 4.4552234,3.141154 M 2.5387252,3.7577881 3.95167,2.3926286 M 2.6983966,0.69023005 C 2.4409284,0.70890216 2.2064656,0.88156842 1.8386425,1.0965814 L 1.620496,0.85704796 0.92114372,1.4943782 1.1221807,1.7937949 0.90189552,2.0333284 0.60247861,1.9541964 0.30520053,2.3712413 1.1221807,3.2887401 1.5199774,2.8909434 1.5606122,2.5915266 1.7381236,2.3926282 1.9584089,2.5508914 2.8652142,3.449142 0.94253026,5.3204973 1.6204956,6.0198495 3.5132382,4.0886113 5.5257471,6.0797334 6.143829,5.401768 4.1655391,3.4234781 4.6488835,2.9294403 C 5.7373545,3.548971 6.0308611,2.7467793 6.3619756,2.3327454 L 5.3433778,2.4093512 4.8477819,2.0140802 C 4.8314005,1.2890549 5.2581551,1.0299466 5.9834272,0.95756651 4.6171754,0.39246447 4.0020503,0.94626239 3.95167,2.3926286 L 3.5367638,2.7947028 2.4567244,1.7146633 2.9357913,1.0366981 3.4127196,0.97681525 C 3.1127668,0.75452708 2.8986496,0.6757078 2.6983966,0.69023005 Z" />
         ),
      },
      tasks: {
         width: 16,
         height: 17,
         viewBox: [0, 0, 16, 17],
         data: (
            <>
               <path
                  d="M10.76 1.4974C12.9133 1.4974 14.6667 3.25073 14.6667 5.40406V10.9241C14.6667 13.0774 12.9133 14.8307 10.76 14.8307H5.24C3.08667 14.8307 1.33333 13.0774 1.33333 10.9241V5.40406C1.33333 3.25073 3.08667 1.4974 5.24 1.4974H10.76ZM10.76 0.164062H5.24C2.34667 0.164062 0 2.51073 0 5.40406V10.9241C0 13.8174 2.34667 16.1641 5.24 16.1641H10.76C13.6533 16.1641 16 13.8174 16 10.9241V5.40406C16 2.51073 13.6533 0.164062 10.76 0.164062Z"
                  stroke="none"
               />
               <path
                  d="M3.80664 8.55781C4.70664 9.94448 5.69997 10.6978 6.14664 10.9911C6.28664 11.0845 6.46664 11.0711 6.59331 10.9578C7.29331 10.3578 9.66664 8.25115 12.2266 5.25781"
                  fill="none"
                  strokeWidth="1.33333"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
               />
            </>
         ),
      },
      lines: {
         width: 26,
         height: 26,
         viewBox: [0, 0, 7, 2],
         data: (
            <path d="M 0.46020411,4.5892389 H 6.1982622 V 4.9394492 H 0.46020411 Z m 0,-1.5355364 H 6.1982622 V 3.4039128 H 0.46020411 Z m 0,-1.4547191 H 6.1982622 V 1.9491935 H 0.46020411 Z" />
         ),
      },
      grid: {
         width: 26,
         height: 26,
         viewBox: [0, 0, 7, 2],
         data: (
            <path d="M 5.5517203,4.5892389 H 6.1982622 V 4.9394492 H 5.5517203 Z m -1.6971713,0 H 4.501091 V 4.9394492 H 3.854549 Z m -1.6971736,0 h 0.646542 v 0.3502103 h -0.646542 z m -1.69717129,0 H 1.1067461 V 4.9394492 H 0.46020411 Z M 5.5517203,3.0537025 H 6.1982622 V 3.4039128 H 5.5517203 Z m -1.6971713,0 H 4.501091 V 3.4039128 H 3.854549 Z m -1.6971736,0 h 0.646542 v 0.3502103 h -0.646542 z m -1.69717129,0 H 1.1067461 V 3.4039128 H 0.46020411 Z M 5.5517203,1.5989834 H 6.1982622 V 1.9491935 H 5.5517203 Z m -1.6971713,0 H 4.501091 V 1.9491935 H 3.854549 Z m -1.6971736,0 h 0.646542 v 0.3502101 h -0.646542 z m -1.69717129,0 H 1.1067461 V 1.9491935 H 0.46020411 Z" />
         ),
      },
      mapPin: {
         width: 14,
         height: 17,
         viewBox: [0, 0, 14, 17],
         data: (
            <>
               <path
                  d="M12.5049 7.32373C12.5049 11.763 6.56506 16.3335 6.56506 16.3335C6.56506 16.3335 0.625244 11.763 0.625244 7.32373C0.625244 4.49762 3.28253 1.58398 6.56506 1.58398C9.8476 1.58398 12.5049 4.49762 12.5049 7.32373Z"
                  fill="none"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  d="M6.56506 9.83691C7.80473 9.83691 8.80969 8.83196 8.80969 7.59228C8.80969 6.35261 7.80473 5.34766 6.56506 5.34766C5.32539 5.34766 4.32043 6.35261 4.32043 7.59228C4.32043 8.83196 5.32539 9.83691 6.56506 9.83691Z"
                  fill="none"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
            </>
         ),
      },
      map: {
         width: 25,
         height: 23,
         viewBox: [0, 0, 25, 23],
         fill: 'none',
         data: (
            <path
               d="M8.33317 17.7499L1.0415 21.9166V5.24992L8.33317 1.08325M8.33317 17.7499L16.6665 21.9166M8.33317 17.7499V1.08325M16.6665 21.9166L23.9582 17.7499V1.08325L16.6665 5.24992M16.6665 21.9166V5.24992M16.6665 5.24992L8.33317 1.08325"
               stroke="#6F7680"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
         ),
      },
      'map-trans': {
         width: 21,
         height: 29,
         viewBox: [0, 0, 21, 29],
         data: (
            <path
               fill="currentColor"
               fillRule="evenodd"
               d="m10.5 0c5.8 0 10.5 4.7 10.5 10.5q0 2.8-2.3 7l-0.4 0.6q-0.3 0.5-0.6 1l-0.5 0.7q-0.4 0.7-0.9 1.4l-0.6 0.8-0.5 0.7-0.6 0.8-0.6 0.8-0.7 0.8q-0.3 0.4-0.6 0.8l-0.7 0.9q-0.4 0.4-0.7 0.8l-0.8 1-0.8-1-0.7-0.8-0.7-0.9q-0.3-0.4-0.6-0.8l-0.7-0.8-0.6-0.8-0.6-0.8-0.5-0.7-0.6-0.8q-0.5-0.7-0.9-1.4l-0.5-0.7q-0.3-0.5-0.6-1l-0.4-0.6q-2.3-4.2-2.3-7c0-5.8 4.7-10.5 10.5-10.5zm0 2c-4.7 0-8.5 3.8-8.5 8.5q0 2.8 3.1 7.6l0.4 0.7q0.5 0.7 0.9 1.4l0.6 0.7 0.5 0.7q0.3 0.4 0.6 0.8l0.5 0.7 0.7 0.8q0.1 0.2 0.3 0.4l0.6 0.8 0.3 0.3 0.6-0.7 0.7-0.8 0.6-0.8q0.1-0.2 0.3-0.4l0.6-0.8 0.5-0.7q0.2-0.2 0.3-0.4l0.5-0.7q0.3-0.4 0.5-0.7l0.5-0.7q0.2-0.4 0.4-0.7l0.4-0.6 0.4-0.7q2.1-3.7 2.2-6v-0.2c0-4.7-3.8-8.5-8.5-8.5zm0 4c2.5 0 4.5 2 4.5 4.5 0 2.5-2 4.5-4.5 4.5-2.5 0-4.5-2-4.5-4.5 0-2.5 2-4.5 4.5-4.5zm0 2c-1.4 0-2.5 1.1-2.5 2.5 0 1.4 1.1 2.5 2.5 2.5 1.4 0 2.5-1.1 2.5-2.5 0-1.4-1.1-2.5-2.5-2.5z"
            />
         ),
      },
      location: {
         width: 21,
         height: 29,
         viewBox: [0, 0, 21, 29],
         data: (
            <path
               fill="currentColor"
               fillRule="evenodd"
               d="m10.5 0c5.8 0 10.5 4.7 10.5 10.5q0 2.8-2.3 7l-0.4 0.6q-0.3 0.5-0.6 1l-0.5 0.7q-0.4 0.7-0.9 1.4l-0.6 0.8-0.5 0.7-0.6 0.8-0.6 0.8-0.7 0.8q-0.3 0.4-0.6 0.8l-0.7 0.9q-0.4 0.4-0.7 0.8l-0.8 1-0.8-1-0.7-0.8-0.7-0.9q-0.3-0.4-0.6-0.8l-0.7-0.8-0.6-0.8-0.6-0.8-0.5-0.7-0.6-0.8q-0.5-0.7-0.9-1.4l-0.5-0.7q-0.3-0.5-0.6-1l-0.4-0.6q-2.3-4.2-2.3-7c0-5.8 4.7-10.5 10.5-10.5zm0 8c-1.4 0-2.5 1.1-2.5 2.5 0 1.4 1.1 2.5 2.5 2.5 1.4 0 2.5-1.1 2.5-2.5 0-1.4-1.1-2.5-2.5-2.5z"
            />
         ),
      },
      filters: {
         width: 21,
         height: 17,
         viewBox: [0, 0, 21, 17],
         fill: 'none',
         data: (
            <>
               <g clipPath="url(#clip0_7035_3737)">
                  <path
                     d="M17.8081 8.22754V15.2889"
                     fill="none"
                     stroke="#6F7680"
                     strokeWidth="2"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                  />
                  <path
                     d="M17.8083 4.89677C18.1474 4.89677 18.4139 5.16324 18.4139 5.50237C18.4139 5.84151 18.1474 6.10798 17.8083 6.10798C17.4691 6.10798 17.2027 5.84151 17.2027 5.50237C17.2027 5.16324 17.4691 4.89677 17.8083 4.89677ZM17.8083 2.47437C16.1368 2.47437 14.7803 3.83091 14.7803 5.50237C14.7803 7.17384 16.1368 8.53038 17.8083 8.53038C19.4797 8.53038 20.8363 7.17384 20.8363 5.50237C20.8363 3.83091 19.4797 2.47437 17.8083 2.47437Z"
                     fill="#6F7680"
                     stroke="none"
                  />
                  <path
                     d="M17.8081 1.71118V3.4432"
                     fill="none"
                     stroke="#6F7680"
                     strokeWidth="2"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                  />
                  <path
                     d="M10.4321 10.4197V15.2887"
                     fill="none"
                     stroke="#6F7680"
                     strokeWidth="2"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                  />
                  <path
                     d="M10.4318 7.86406C10.771 7.86406 11.0374 8.13052 11.0374 8.46966C11.0374 8.8088 10.771 9.07526 10.4318 9.07526C10.0927 9.07526 9.82622 8.8088 9.82622 8.46966C9.82622 8.13052 10.0927 7.86406 10.4318 7.86406ZM10.4318 5.44165C8.76036 5.44165 7.40381 6.7982 7.40381 8.46966C7.40381 10.1411 8.76036 11.4977 10.4318 11.4977C12.1033 11.4977 13.4598 10.1411 13.4598 8.46966C13.4598 6.7982 12.1033 5.44165 10.4318 5.44165Z"
                     fill="#6F7680"
                     stroke="none"
                  />
                  <path
                     d="M10.4321 1.71118V6.41065"
                     fill="none"
                     stroke="#6F7680"
                     strokeWidth="2"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                  />
                  <path
                     d="M3.04346 8.76039V1.71118"
                     fill="none"
                     stroke="#6F7680"
                     strokeWidth="2"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                  />
                  <path
                     d="M3.04363 10.8921C3.38277 10.8921 3.64924 11.1586 3.64924 11.4977C3.64924 11.8369 3.38277 12.1033 3.04363 12.1033C2.7045 12.1033 2.43803 11.8369 2.43803 11.4977C2.43803 11.1586 2.7045 10.8921 3.04363 10.8921ZM3.04363 8.46973C1.37217 8.46973 0.015625 9.82627 0.015625 11.4977C0.015625 13.1692 1.37217 14.5257 3.04363 14.5257C4.7151 14.5257 6.07164 13.1692 6.07164 11.4977C6.07164 9.82627 4.7151 8.46973 3.04363 8.46973Z"
                     fill="#6F7680"
                     stroke="none"
                  />
                  <path
                     d="M3.04346 15.2889V13.5569"
                     fill="none"
                     stroke="#6F7680"
                     strokeWidth="2"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                  />
               </g>
               <defs>
                  <clipPath id="clip0_7035_3737">
                     <rect
                        width="20.8206"
                        height="16"
                        fill="white"
                        transform="translate(0.015625 0.5)"
                     />
                  </clipPath>
               </defs>
            </>
         ),
      },
      sort: {
         width: 20,
         height: 17,
         viewBox: [0, 0, 20, 17],
         fill: 'none',
         data: (
            <>
               <g clipPath="url(#clip0_7035_3727)">
                  <path
                     d="M9.93848 2.73584H17.9898"
                     stroke="#6F7680"
                     strokeWidth="2"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                  />
                  <path
                     d="M9.93848 6.46924H16.1333"
                     stroke="#6F7680"
                     strokeWidth="2"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                  />
                  <path
                     d="M9.93848 10.4282H14.4513"
                     stroke="#6F7680"
                     strokeWidth="2"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                  />
                  <path
                     d="M9.93848 14.2744H12.7898"
                     stroke="#6F7680"
                     strokeWidth="2"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                  />
                  <path
                     d="M6.51306 3.66922L3.7746 1.52563L1.02588 3.66922L3.7746 1.52563V15.4744L6.51306 13.3308L3.7746 15.4744L1.02588 13.3308"
                     stroke="#6F7680"
                     strokeWidth="2"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                  />
               </g>
               <defs>
                  <clipPath id="clip0_7035_3727">
                     <rect
                        width="19.0154"
                        height="16"
                        fill="white"
                        transform="translate(0 0.5)"
                     />
                  </clipPath>
               </defs>
            </>
         ),
      },
      calendar: {
         width: 22,
         height: 23,
         viewBox: [0, 0, 7, 7],
         data: (
            <path d="m 4.3647676,4.7822293 h 0.3261795 c 0.1077275,0 0.194454,0.08673 0.194454,0.194454 v 0.06273 c 0,0.107728 -0.086727,0.194454 -0.194454,0.194454 H 4.3647676 c -0.1077275,0 -0.194454,-0.08673 -0.194454,-0.194454 v -0.06273 c 0,-0.107728 0.086727,-0.194454 0.194454,-0.194454 z m 0,-0.715088 h 0.3261795 c 0.1077275,0 0.194454,0.08673 0.194454,0.194454 v 0.06273 c 0,0.107728 -0.086727,0.194454 -0.194454,0.194454 H 4.3647676 c -0.1077275,0 -0.194454,-0.08673 -0.194454,-0.194454 v -0.06273 c 0,-0.107727 0.086727,-0.194454 0.194454,-0.194454 z m 0,-0.715088 h 0.3261795 c 0.1077275,0 0.194454,0.08673 0.194454,0.194454 v 0.06273 c 0,0.107728 -0.086727,0.194454 -0.194454,0.194454 H 4.3647676 c -0.1077275,0 -0.194454,-0.08673 -0.194454,-0.194454 v -0.06273 c 0,-0.107727 0.086727,-0.194454 0.194454,-0.194454 z M 3.135319,4.7822293 h 0.3261795 c 0.1077275,0 0.194454,0.08673 0.194454,0.194454 v 0.06273 c 0,0.107728 -0.086726,0.194454 -0.194454,0.194454 H 3.135319 c -0.1077275,0 -0.194454,-0.08673 -0.194454,-0.194454 v -0.06273 c 0,-0.107728 0.086726,-0.194454 0.194454,-0.194454 z m 0,-0.715088 h 0.3261795 c 0.1077275,0 0.194454,0.08673 0.194454,0.194454 v 0.06273 c 0,0.107728 -0.086726,0.194454 -0.194454,0.194454 H 3.135319 c -0.1077275,0 -0.194454,-0.08673 -0.194454,-0.194454 v -0.06273 c 0,-0.107727 0.086726,-0.194454 0.194454,-0.194454 z m 0,-0.715088 h 0.3261795 c 0.1077275,0 0.194454,0.08673 0.194454,0.194454 v 0.06273 c 0,0.107728 -0.086726,0.194454 -0.194454,0.194454 H 3.135319 c -0.1077275,0 -0.194454,-0.08673 -0.194454,-0.194454 v -0.06273 c 0,-0.107727 0.086726,-0.194454 0.194454,-0.194454 z m -1.2670848,1.430176 h 0.3261795 c 0.1077275,0 0.194454,0.08673 0.194454,0.194454 v 0.06273 c 0,0.107728 -0.086727,0.194454 -0.194454,0.194454 H 1.8682342 c -0.1077275,0 -0.194454,-0.08673 -0.194454,-0.194454 v -0.06273 c 0,-0.107728 0.086727,-0.194454 0.194454,-0.194454 z m 0,-0.715088 h 0.3261795 c 0.1077275,0 0.194454,0.08673 0.194454,0.194454 v 0.06273 c 0,0.107728 -0.086727,0.194454 -0.194454,0.194454 H 1.8682342 c -0.1077275,0 -0.194454,-0.08673 -0.194454,-0.194454 v -0.06273 c 0,-0.107727 0.086727,-0.194454 0.194454,-0.194454 z m 0,-0.715088 h 0.3261795 c 0.1077275,0 0.194454,0.08673 0.194454,0.194454 v 0.06273 c 0,0.107728 -0.086727,0.194454 -0.194454,0.194454 H 1.8682342 c -0.1077275,0 -0.194454,-0.08673 -0.194454,-0.194454 v -0.06273 c 0,-0.107727 0.086727,-0.194454 0.194454,-0.194454 z m 0.1365321,-2.690164 c -0.098293,0.0099 -0.1738282,0.09237 -0.1738282,0.193359 v 0.376953 H 1.3485163 c -0.3197069,0 -0.57812508,0.256465 -0.57812508,0.576172 v 3.613281 c 0,0.319707 0.25841828,0.578125 0.57812508,0.578125 h 3.8749999 c 0.3197068,0 0.578125,-0.258418 0.578125,-0.578125 v -3.613281 c 0,-0.319707 -0.2584182,-0.576172 -0.578125,-0.576172 H 4.7157037 v -0.376953 c 0,-0.107727 -0.085632,-0.193359 -0.1933594,-0.193359 -0.1077272,0 -0.1953124,0.08563 -0.1953124,0.193359 v 0.376953 H 2.21961 v -0.376953 c 0,-0.107727 -0.087585,-0.193359 -0.1953125,-0.193359 -0.00673,0 -0.012978,-6.62e-4 -0.019531,0 z m -0.3964844,0.890625 h 0.2226562 v 0.382812 c 0,0.107727 0.085632,0.193359 0.1933594,0.193359 0.1077273,0 0.1953125,-0.08563 0.1953125,-0.193359 v -0.382812 h 2.1074219 v 0.382812 c 0,0.107727 0.087585,0.193359 0.1953124,0.193359 0.1077273,0 0.1933594,-0.08563 0.1933594,-0.193359 v -0.382812 h 0.2480469 c 0.017291,0 0.033953,2.54e-4 0.050781,0.002 0.016828,0.0017 0.032545,0.0045 0.048828,0.0078 0.016283,0.0033 0.033172,0.0088 0.048828,0.01367 0.015656,0.0048 0.029976,0.0093 0.044922,0.01563 0.014946,0.0063 0.030768,0.01382 0.044922,0.02148 0.014154,0.0077 0.027736,0.01643 0.041016,0.02539 0.013279,0.009 0.024787,0.01718 0.037109,0.02734 0.012322,0.01016 0.025827,0.02192 0.037109,0.0332 0.011283,0.01128 0.021089,0.02283 0.03125,0.03516 0.010161,0.01232 0.02034,0.02578 0.029297,0.03906 0.00896,0.01328 0.017721,0.02686 0.025391,0.04102 0.00767,0.01415 0.013231,0.02802 0.019531,0.04297 0.0063,0.01495 0.012729,0.03122 0.017578,0.04687 0.00485,0.01566 0.0084,0.03059 0.011719,0.04687 0.00332,0.01628 0.00611,0.03395 0.00781,0.05078 0.0017,0.01683 0.00195,0.03349 0.00195,0.05078 v 0.470703 c -0.00198,-6e-5 -0.00386,0 -0.00586,0 H 1.1082754 v -0.470703 c 0,-0.01729 0.00221,-0.03395 0.00391,-0.05078 0.0017,-0.01683 0.0045,-0.0345 0.00781,-0.05078 0.00331,-0.01628 0.00687,-0.03122 0.011719,-0.04687 0.00485,-0.01566 0.011277,-0.03193 0.017578,-0.04687 0.0063,-0.01495 0.011861,-0.02882 0.019531,-0.04297 0.00767,-0.01415 0.016434,-0.02774 0.025391,-0.04102 0.00896,-0.01328 0.019136,-0.02674 0.029297,-0.03906 0.010161,-0.01232 0.019967,-0.02387 0.03125,-0.03516 0.011283,-0.01128 0.022834,-0.02304 0.035156,-0.0332 0.012322,-0.01016 0.025783,-0.01839 0.039063,-0.02734 0.013279,-0.009 0.026862,-0.01772 0.041016,-0.02539 0.014154,-0.0077 0.028023,-0.01518 0.042969,-0.02148 0.014946,-0.0063 0.031219,-0.01078 0.046875,-0.01563 0.015656,-0.0048 0.032545,-0.01036 0.048828,-0.01367 0.016283,-0.0033 0.032,-0.0061 0.048828,-0.0078 0.016828,-0.0017 0.03349,-0.002 0.050781,-0.002 z m -0.5,1.361328 h 4.3476562 c 0.002,0 0.00387,5.9e-5 0.00586,0 v 2.265625 c 0,0.01729 -2.543e-4,0.03395 -0.00195,0.05078 -0.0017,0.01683 -0.0045,0.03254 -0.00781,0.04883 -0.00332,0.01628 -0.00687,0.03317 -0.011719,0.04883 -0.00485,0.01566 -0.011277,0.02998 -0.017578,0.04492 -0.0063,0.01495 -0.011861,0.03077 -0.019531,0.04492 -0.00767,0.01415 -0.016434,0.02774 -0.025391,0.04102 -0.00896,0.01328 -0.019136,0.02479 -0.029297,0.03711 -0.010161,0.01232 -0.019967,0.02583 -0.03125,0.03711 -0.011283,0.01128 -0.024787,0.02109 -0.037109,0.03125 -0.012322,0.01016 -0.02383,0.02034 -0.037109,0.0293 -0.013279,0.009 -0.026862,0.01772 -0.041016,0.02539 -0.014154,0.0077 -0.029976,0.01323 -0.044922,0.01953 -0.014946,0.0063 -0.029266,0.01273 -0.044922,0.01758 -0.015656,0.0048 -0.032545,0.0084 -0.048828,0.01172 -0.016283,0.0033 -0.032,0.0061 -0.048828,0.0078 -0.016829,0.0017 -0.03349,0.002 -0.050781,0.002 H 1.6082884 c -0.017291,0 -0.033953,-2.55e-4 -0.050781,-0.002 -0.016828,-0.0017 -0.032545,-0.0045 -0.048828,-0.0078 -0.016283,-0.0033 -0.033172,-0.0069 -0.048828,-0.01172 -0.015656,-0.0048 -0.031929,-0.01128 -0.046875,-0.01758 -0.014946,-0.0063 -0.028815,-0.01186 -0.042969,-0.01953 -0.014154,-0.0077 -0.027736,-0.01643 -0.041016,-0.02539 -0.013279,-0.009 -0.02674,-0.01914 -0.039063,-0.0293 -0.012322,-0.01016 -0.023873,-0.01997 -0.035156,-0.03125 -0.011283,-0.01128 -0.021089,-0.02479 -0.03125,-0.03711 -0.010161,-0.01232 -0.02034,-0.02383 -0.029297,-0.03711 -0.00896,-0.01328 -0.017721,-0.02686 -0.025391,-0.04102 -0.00767,-0.01415 -0.013231,-0.02998 -0.019531,-0.04492 -0.0063,-0.01495 -0.012729,-0.02927 -0.017578,-0.04492 -0.00485,-0.01566 -0.0084,-0.03254 -0.011719,-0.04883 -0.00332,-0.01628 -0.00611,-0.032 -0.00781,-0.04883 -0.0017,-0.01683 -0.00391,-0.03349 -0.00391,-0.05078 z" />
         ),
      },
      portal: {
         width: 22,
         height: 23,
         viewBox: [0, 0, 7, 7],
         data: (
            <path d="M 2.3861819,1.6761474 A 0.1862386,0.1862386 0 0 1 2.1999433,1.862386 0.1862386,0.1862386 0 0 1 2.0137047,1.6761474 0.1862386,0.1862386 0 0 1 2.1999433,1.4899088 0.1862386,0.1862386 0 0 1 2.3861819,1.6761474 Z m -0.5470759,0 A 0.1862386,0.1862386 0 0 1 1.6528674,1.862386 0.1862386,0.1862386 0 0 1 1.4666288,1.6761474 0.1862386,0.1862386 0 0 1 1.6528674,1.4899088 0.1862386,0.1862386 0 0 1 1.839106,1.6761474 Z M 1.3984375,0.93907676 c -0.3197068,0 -0.578125,0.25646494 -0.578125,0.57617194 v 3.6132812 c 0,0.319707 0.2584182,0.578125 0.578125,0.578125 h 3.875 c 0.3197068,0 0.578125,-0.258418 0.578125,-0.578125 V 1.5152487 c 0,-0.319707 -0.2584182,-0.57617194 -0.578125,-0.57617194 z M 1.6582031,1.2593893 H 1.8808594 4.765625 5.0136719 c 0.017291,0 0.033953,2.071e-4 0.050781,0.00195 0.016828,0.0017 0.032545,0.00451 0.048828,0.00781 0.016283,0.0033 0.033172,0.0088 0.048828,0.013672 0.015656,0.0048 0.029976,0.0093 0.044922,0.015625 0.014946,0.0063 0.030768,0.013824 0.044922,0.021484 0.014154,0.0077 0.027736,0.016431 0.041016,0.025391 0.013279,0.009 0.024787,0.017184 0.037109,0.027344 0.012322,0.01016 0.025827,0.021923 0.037109,0.033203 0.011283,0.01128 0.021089,0.022826 0.03125,0.035156 0.010161,0.01232 0.02034,0.025783 0.029297,0.039063 0.00896,0.01328 0.017721,0.026856 0.025391,0.041016 0.00767,0.01415 0.013231,0.028019 0.019531,0.042969 0.0063,0.01495 0.012729,0.031225 0.017578,0.046875 0.00485,0.01566 0.0084,0.030595 0.011719,0.046875 0.00332,0.01628 0.00611,0.033951 0.00781,0.050781 0.0017,0.01683 0.00195,0.033491 0.00195,0.050781 v 0.2714844 c -0.00198,-6e-5 -0.00386,0 -0.00586,0 H 1.1582031 V 1.7593893 c 0,0 0.00221,-0.033951 0.00391,-0.050781 0.0017,-0.01683 0.0045,-0.034501 0.00781,-0.050781 0.00331,-0.01628 0.00687,-0.031225 0.011719,-0.046875 0.00485,-0.01566 0.011277,-0.031935 0.017578,-0.046875 0.0063,-0.01495 0.011861,-0.028819 0.019531,-0.042969 0.00767,-0.01415 0.016434,-0.027736 0.025391,-0.041016 0.00896,-0.01328 0.019136,-0.026742 0.029297,-0.039063 0.010161,-0.01232 0.019967,-0.023866 0.03125,-0.035156 0.011283,-0.01128 0.022834,-0.023043 0.035156,-0.033203 0.012322,-0.01016 0.025783,-0.018394 0.039062,-0.027344 0.013279,-0.009 0.026862,-0.017721 0.041016,-0.025391 0.014154,-0.0077 0.028023,-0.015184 0.042969,-0.021484 0.014946,-0.0063 0.031219,-0.010775 0.046875,-0.015625 0.015656,-0.0048 0.032545,-0.010362 0.048828,-0.013672 0.016283,-0.0033 0.032,-0.00611 0.048828,-0.00781 0.016828,-0.0017 0.03349,-0.00195 0.050781,-0.00195 z m -0.5,1.1738281 h 4.3476563 c 0.002,0 0.00387,5.9e-5 0.00586,0 v 2.453125 c 0,0.01729 -2.575e-4,0.033951 -0.00195,0.050781 -0.0017,0.01683 -0.0045,0.032538 -0.00781,0.048828 -0.00332,0.01628 -0.00687,0.033168 -0.011719,0.048828 -0.00485,0.01566 -0.011277,0.029982 -0.017578,0.044922 -0.0063,0.01495 -0.011861,0.030772 -0.019531,0.044922 -0.00767,0.01415 -0.016434,0.027736 -0.025391,0.041016 -0.00896,0.01328 -0.019136,0.024789 -0.029297,0.037109 -0.010161,0.01232 -0.019967,0.025829 -0.03125,0.037109 -0.011283,0.01128 -0.024787,0.02109 -0.037109,0.03125 -0.012322,0.01016 -0.02383,0.020337 -0.037109,0.029297 -0.013279,0.009 -0.026862,0.017721 -0.041016,0.025391 -0.014154,0.0077 -0.029976,0.013231 -0.044922,0.019531 -0.014946,0.0063 -0.029266,0.012728 -0.044922,0.017578 -0.015656,0.0048 -0.032545,0.0084 -0.048828,0.011719 -0.016283,0.0033 -0.032,0.00611 -0.048828,0.00781 -0.016829,0.0017 -0.03349,0.00195 -0.050781,0.00195 H 1.6582031 c -0.017291,0 -0.033953,-2.081e-4 -0.050781,-0.00195 -0.016828,-0.0017 -0.032545,-0.00451 -0.048828,-0.00781 -0.016283,-0.0033 -0.033172,-0.0069 -0.048828,-0.011719 -0.015656,-0.0048 -0.031929,-0.011278 -0.046875,-0.017578 -0.014946,-0.0063 -0.028815,-0.011861 -0.042969,-0.019531 -0.014154,-0.0077 -0.027736,-0.016431 -0.041016,-0.025391 -0.013279,-0.009 -0.026739,-0.019137 -0.039062,-0.029297 -0.012322,-0.01016 -0.023873,-0.01997 -0.035156,-0.03125 -0.011283,-0.01128 -0.021089,-0.024789 -0.03125,-0.037109 -0.010161,-0.01232 -0.02034,-0.023829 -0.029297,-0.037109 -0.00896,-0.01328 -0.017721,-0.026856 -0.025391,-0.041016 -0.00767,-0.01415 -0.013231,-0.029982 -0.019531,-0.044922 -0.0063,-0.01495 -0.012729,-0.029272 -0.017578,-0.044922 -0.00485,-0.01566 -0.0084,-0.032538 -0.011719,-0.048828 -0.00331,-0.01628 -0.00611,-0.031998 -0.00781,-0.048828 -0.0017,-0.01683 -0.00391,-0.033491 -0.00391,-0.050781 z" />
         ),
      },
      email: {
         width: 22,
         height: 23,
         viewBox: [0, 0, 7, 7],
         data: (
            <path d="m 1.1259274,1.3914533 c -0.25235826,0 -0.45507826,0.20272 -0.45507826,0.4550781 v 3.1171875 c 0,0.2523582 0.2027199,0.4550782 0.45507826,0.4550782 h 4.3398437 c 0.2523582,0 0.4550781,-0.20272 0.4550781,-0.4550782 V 1.8465314 c 0,-0.2523581 -0.2027199,-0.4550781 -0.4550781,-0.4550781 z M 1.4892086,1.7254377 H 5.104443 c 0.013144,0 0.02627,6.618e-4 0.039063,0.00195 0.00809,8.167e-4 0.015703,0.00256 0.023437,0.00391 L 3.2841305,3.2840314 1.3759274,1.7430158 c 0.011901,-0.00369 0.022778,-0.00725 0.035156,-0.00977 0.012378,-0.00252 0.026271,-0.00457 0.039063,-0.00586 0.012792,-0.00129 0.025919,-0.00195 0.039063,-0.00195 z m 3.9941406,0.4648437 v 2.5136719 c 0,0.013144 -6.618e-4,0.024317 -0.00195,0.037109 -0.00129,0.012792 -0.00139,0.026685 -0.00391,0.039063 -0.00252,0.012378 -0.00608,0.023255 -0.00977,0.035156 -0.00369,0.011901 -0.00888,0.023795 -0.013672,0.035156 -0.00479,0.011361 -0.00979,0.022444 -0.015625,0.033203 -0.00583,0.010759 -0.012723,0.021156 -0.019531,0.03125 -0.00681,0.010094 -0.013761,0.01993 -0.021484,0.029297 -0.00772,0.00937 -0.014861,0.018767 -0.023437,0.027344 -0.00858,0.00858 -0.017977,0.017667 -0.027344,0.025391 -0.00937,0.00772 -0.019203,0.014676 -0.029297,0.021484 -0.010094,0.00681 -0.020491,0.013701 -0.03125,0.019531 -0.010759,0.00583 -0.021842,0.010836 -0.033203,0.015625 -0.011361,0.00479 -0.023255,0.00803 -0.035156,0.011719 -0.011901,0.00369 -0.024731,0.00725 -0.037109,0.00977 -0.012378,0.00252 -0.024317,0.00457 -0.037109,0.00586 -0.012792,0.00129 -0.025919,0.00195 -0.039063,0.00195 H 1.4892086 c -0.013144,0 -0.026271,-6.617e-4 -0.039063,-0.00195 -0.012792,-0.00129 -0.026685,-0.00334 -0.039063,-0.00586 -0.012378,-0.00252 -0.023255,-0.00608 -0.035156,-0.00977 -0.011901,-0.00369 -0.023795,-0.00693 -0.035156,-0.011719 -0.011361,-0.00479 -0.022444,-0.00979 -0.033203,-0.015625 -0.010759,-0.00583 -0.021156,-0.012723 -0.03125,-0.019531 -0.010094,-0.00681 -0.01993,-0.013761 -0.029297,-0.021484 -0.00937,-0.00772 -0.018767,-0.016814 -0.027344,-0.025391 -0.00858,-0.00858 -0.015714,-0.017977 -0.023438,-0.027344 -0.00772,-0.00937 -0.016629,-0.019203 -0.023437,-0.029297 -0.00681,-0.010094 -0.011748,-0.020491 -0.017578,-0.03125 -0.00583,-0.010759 -0.012789,-0.021842 -0.017578,-0.033203 -0.00479,-0.011361 -0.00803,-0.023255 -0.011719,-0.035156 -0.00369,-0.011901 -0.00725,-0.022778 -0.00977,-0.035156 -0.00252,-0.012378 -0.00457,-0.02627 -0.00586,-0.039063 -0.00129,-0.012792 -0.00195,-0.023966 -0.00195,-0.037109 v -2.375 l 2.1035182,1.6035156 z" />
         ),
      },
      'tick-circle': {
         width: 22,
         height: 23,
         viewBox: [0, 0, 7, 7],
         data: (
            <path d="M 2.6105077,2.6707502 2.1888103,3.15269 3.3534984,4.1567315 5.964006,1.3454155 5.5222278,0.90363727 3.2932558,3.273175 Z M 4.4570312,0.9375 A 2.6105077,2.6105077 0 0 0 3.2539062,0.64257812 2.6105077,2.6105077 0 0 0 0.64257812,3.2539062 2.6105077,2.6105077 0 0 0 3.2539062,5.8632812 2.6105077,2.6105077 0 0 0 5.8632812,3.2539062 2.6105077,2.6105077 0 0 0 5.8144531,2.75 L 5.3847656,2.9980469 a 2.1486487,2.1486487 0 0 1 0.00391,0.023437 2.1486487,2.1486487 0 0 1 0.00977,0.1152344 2.1486487,2.1486487 0 0 1 0.00391,0.1171874 A 2.1486487,2.1486487 0 0 1 5.375,3.5898438 2.1486487,2.1486487 0 0 1 5.296875,3.9179688 2.1486487,2.1486487 0 0 1 5.1679688,4.2285156 2.1486487,2.1486487 0 0 1 4.9921875,4.515625 2.1486487,2.1486487 0 0 1 4.7714844,4.7714844 2.1486487,2.1486487 0 0 1 4.515625,4.9921875 2.1486487,2.1486487 0 0 1 4.2285156,5.1679688 2.1486487,2.1486487 0 0 1 3.9179688,5.296875 2.1486487,2.1486487 0 0 1 3.5898438,5.375 2.1486487,2.1486487 0 0 1 3.2539062,5.4023438 2.1486487,2.1486487 0 0 1 2.9160156,5.375 2.1486487,2.1486487 0 0 1 2.5898438,5.296875 2.1486487,2.1486487 0 0 1 2.2773438,5.1679688 2.1486487,2.1486487 0 0 1 1.9902344,4.9921875 2.1486487,2.1486487 0 0 1 1.734375,4.7714844 2.1486487,2.1486487 0 0 1 1.515625,4.515625 2.1486487,2.1486487 0 0 1 1.3378906,4.2285156 2.1486487,2.1486487 0 0 1 1.2089844,3.9179688 2.1486487,2.1486487 0 0 1 1.1308594,3.5898438 2.1486487,2.1486487 0 0 1 1.1035156,3.2539062 2.1486487,2.1486487 0 0 1 1.1308594,2.9160156 2.1486487,2.1486487 0 0 1 1.2089844,2.5898438 2.1486487,2.1486487 0 0 1 1.3378906,2.2773438 2.1486487,2.1486487 0 0 1 1.515625,1.9902344 2.1486487,2.1486487 0 0 1 1.734375,1.734375 2.1486487,2.1486487 0 0 1 1.9902344,1.515625 2.1486487,2.1486487 0 0 1 2.2773438,1.3378906 a 2.1486487,2.1486487 0 0 1 0.3125,-0.1289062 2.1486487,2.1486487 0 0 1 0.3261718,-0.078125 2.1486487,2.1486487 0 0 1 0.3378906,-0.027344 2.1486487,2.1486487 0 0 1 0.1152344,0.00391 2.1486487,2.1486487 0 0 1 0.1171875,0.00977 2.1486487,2.1486487 0 0 1 0.1152344,0.015625 2.1486487,2.1486487 0 0 1 0.1132813,0.021484 2.1486487,2.1486487 0 0 1 0.1132812,0.029297 2.1486487,2.1486487 0 0 1 0.1113281,0.033203 2.1486487,2.1486487 0 0 1 0.109375,0.041016 2.1486487,2.1486487 0 0 1 0.1074219,0.044922 2.1486487,2.1486487 0 0 1 0.080078,0.041016 z" />
         ),
      },
      face: {
         width: 22,
         height: 23,
         viewBox: [0, 0, 7, 7],
         data: (
            <path d="M 3.2957632,0.25406215 A 3.0580102,3.0580102 0 0 0 0.23846229,3.3113628 3.0580102,3.0580102 0 0 0 3.2957632,6.3686635 3.0580102,3.0580102 0 0 0 6.3547062,3.3113628 3.0580102,3.0580102 0 0 0 3.2957632,0.25406215 Z m 0,0.61408725 a 2.4437375,2.4437375 0 0 1 0.1379227,0.003281 2.4437375,2.4437375 0 0 1 0.1362823,0.0114938 2.4437375,2.4437375 0 0 1 0.1362812,0.0197036 2.4437375,2.4437375 0 0 1 0.1346386,0.0262707 2.4437375,2.4437375 0 0 1 0.1313556,0.034481 2.4437375,2.4437375 0 0 1 0.1313556,0.041049 2.4437375,2.4437375 0 0 1 0.1280715,0.049258 2.4437375,2.4437375 0 0 1 0.1247884,0.055826 2.4437375,2.4437375 0 0 1 0.1215044,0.062394 2.4437375,2.4437375 0 0 1 0.1182191,0.070603 2.4437375,2.4437375 0 0 1 0.1149373,0.075529 2.4437375,2.4437375 0 0 1 0.1083657,0.082097 2.4437375,2.4437375 0 0 1 0.1050849,0.088665 2.4437375,2.4437375 0 0 1 0.1001637,0.095233 2.4437375,2.4437375 0 0 1 0.093591,0.098517 2.4437375,2.4437375 0 0 1 0.088659,0.1050849 2.4437375,2.4437375 0 0 1 0.082097,0.1100103 2.4437375,2.4437375 0 0 1 0.077176,0.1132942 2.4437375,2.4437375 0 0 1 0.068963,0.1182199 2.4437375,2.4437375 0 0 1 0.06239,0.1215039 2.4437375,2.4437375 0 0 1 0.055829,0.1247878 2.4437375,2.4437375 0 0 1 0.049256,0.1280717 2.4437375,2.4437375 0 0 1 0.042694,0.1313555 2.4437375,2.4437375 0 0 1 0.032841,0.1329975 2.4437375,2.4437375 0 0 1 0.027909,0.1346395 2.4437375,2.4437375 0 0 1 0.018066,0.1346395 2.4437375,2.4437375 0 0 1 0.011494,0.1362813 2.4437375,2.4437375 0 0 1 0.00489,0.1379233 2.4437375,2.4437375 0 0 1 -0.031201,0.3825732 2.4437375,2.4437375 0 0 1 -0.08867,0.3727213 2.4437375,2.4437375 0 0 1 -0.147775,0.35466 2.4437375,2.4437375 0 0 1 -0.05911,0.095233 C 5.3460943,4.0335422 5.0360629,3.8553566 4.3466079,3.7431943 4.2650973,3.6579793 4.1834694,3.5722659 4.1019577,3.4870509 4.0463821,3.442591 3.9916984,3.3985134 3.9361217,3.3540534 L 3.9032806,3.1094036 c 0.044454,-0.077805 0.088529,-0.1553515 0.1329971,-0.2331561 0.00369,-0.048165 0.00782,-0.096326 0.011494,-0.1444911 C 4.176182,2.5842488 4.3421788,2.327785 4.157781,2.0979658 4.1204749,1.8456201 4.2961013,1.6510774 3.9689584,1.3196842 3.7967422,1.2223451 3.6015871,1.2983728 3.5141395,1.086528 2.811207,1.037651 2.2227641,1.5851166 2.5355408,2.6315979 c 0.052407,0.072557 0.025595,0.1865822 0.1444909,0.2003171 0.022227,0.077805 0.043455,0.1553517 0.065682,0.2331562 l 0.078816,0.17733 -0.032841,0.1444911 C 2.6450158,3.4859956 2.4811798,3.5063288 2.3795615,3.6660228 1.6291023,3.8536376 1.2481676,3.7783558 1.1398932,4.4541562 A 2.4437375,2.4437375 0 0 1 1.1185459,4.4213173 2.4437375,2.4437375 0 0 1 0.97241238,4.0666573 2.4437375,2.4437375 0 0 1 0.88210216,3.693936 2.4437375,2.4437375 0 0 1 0.85254194,3.3113628 2.4437375,2.4437375 0 0 1 0.88210216,2.9287898 2.4437375,2.4437375 0 0 1 0.97241238,2.5560684 2.4437375,2.4437375 0 0 1 1.1185459,2.2014083 2.4437375,2.4437375 0 0 1 1.3188623,1.8746614 2.4437375,2.4437375 0 0 1 1.5684381,1.5840372 2.4437375,2.4437375 0 0 1 1.8607052,1.3344617 2.4437375,2.4437375 0 0 1 2.1874516,1.1341445 2.4437375,2.4437375 0 0 1 2.5404697,0.98636937 2.4437375,2.4437375 0 0 1 2.9148329,0.8977039 2.4437375,2.4437375 0 0 1 3.2957643,0.86814911 Z" />
         ),
      },
      clock: {
         width: 22,
         height: 23,
         viewBox: [0, 0, 7, 7],
         data: (
            <path d="m 4.6890902,5.4749289 h 0.086535 c 0.081496,0 0.147107,0.065609 0.147107,0.147107 v 0.1038408 c 0,0.081498 -0.065609,0.1471071 -0.147107,0.1471071 h -0.086535 c -0.081496,0 -0.147107,-0.065609 -0.147107,-0.1471071 V 5.6220359 c 0,-0.081498 0.065608,-0.147107 0.147107,-0.147107 z m 0,-0.5018948 h 0.086535 c 0.081496,0 0.147107,0.065609 0.147107,0.1471071 V 5.223982 c 0,0.081498 -0.065609,0.147107 -0.147107,0.147107 h -0.086535 c -0.081496,0 -0.147107,-0.065609 -0.147107,-0.147107 V 5.1201412 c 0,-0.081497 0.065608,-0.1471071 0.147107,-0.1471071 z m 0.5884313,0.5018948 h 0.086534 c 0.081496,0 0.1471071,0.065609 0.1471071,0.147107 v 0.1038408 c 0,0.081498 -0.065609,0.1471071 -0.1471071,0.1471071 h -0.086534 c -0.081496,0 -0.1471069,-0.065609 -0.1471069,-0.1471071 V 5.6220359 c 0,-0.081498 0.065608,-0.147107 0.1471069,-0.147107 z m 0,-0.5018948 h 0.086534 c 0.081496,0 0.1471071,0.065609 0.1471071,0.1471071 V 5.223982 c 0,0.081498 -0.065609,0.147107 -0.1471071,0.147107 h -0.086534 c -0.081496,0 -0.1471069,-0.065609 -0.1471069,-0.147107 V 5.1201412 c 0,-0.081497 0.065608,-0.1471071 0.1471069,-0.1471071 z m 0.5711221,0.5018948 h 0.086535 c 0.081496,0 0.147107,0.065609 0.147107,0.147107 v 0.1038408 c 0,0.081498 -0.065608,0.1471071 -0.147107,0.1471071 h -0.086535 c -0.081496,0 -0.1471071,-0.065609 -0.1471071,-0.1471071 V 5.6220359 c 0,-0.081498 0.065608,-0.147107 0.1471071,-0.147107 z m 0,-0.5018948 h 0.086535 c 0.081496,0 0.147107,0.065609 0.147107,0.1471071 V 5.223982 c 0,0.081498 -0.065608,0.147107 -0.147107,0.147107 h -0.086535 c -0.081496,0 -0.1471071,-0.065609 -0.1471071,-0.147107 V 5.1201412 c 0,-0.081497 0.065608,-0.1471071 0.1471071,-0.1471071 z m 0,-0.5018947 h 0.086535 c 0.081496,0 0.147107,0.065609 0.147107,0.147107 v 0.1038409 c 0,0.081498 -0.065608,0.147107 -0.147107,0.147107 h -0.086535 c -0.081496,0 -0.1471071,-0.065609 -0.1471071,-0.147107 V 4.6182464 c 0,-0.081498 0.065608,-0.147107 0.1471071,-0.147107 z M 4.8095256,3.5535226 c -0.081496,0 -0.1459371,0.066098 -0.1459371,0.1475953 v 0.094526 H 4.5325769 c -0.3211954,0 -0.5787729,0.2592358 -0.5787729,0.580431 v 1.3316748 c 0,0.3211952 0.2575775,0.5804311 0.5787729,0.5804311 h 1.4543949 c 0.3211938,0 0.5804304,-0.2592359 0.5804304,-0.5804311 V 4.3760763 c 0,-0.3211951 -0.2592366,-0.580431 -0.5804304,-0.580431 h -0.059699 v -0.094526 c 0,-0.081497 -0.066102,-0.1475952 -0.1475951,-0.1475952 -0.081496,0 -0.1475953,0.066098 -0.1475953,0.1475952 v 0.094526 H 5.4247822 v -0.094526 c 0,-0.081497 -0.066103,-0.1475952 -0.1475953,-0.1475952 -0.081496,0 -0.1459368,0.066098 -0.1459368,0.1475952 v 0.094526 H 4.9571208 v -0.094526 c 0,-0.081497 -0.066103,-0.1475952 -0.1475952,-0.1475967 z m 0.1475952,0.509121 h 0.1741293 v 0.1061356 c 0,0.081497 0.064438,0.145937 0.1459368,0.145937 0.081496,0 0.1475953,-0.06444 0.1475953,-0.145937 V 4.0626436 h 0.2072972 v 0.1061356 c 0,0.081497 0.066101,0.145937 0.1475952,0.145937 0.081496,0 0.1475953,-0.06444 0.1475953,-0.145937 v -0.094526 c 0.013517,0.00294 0.026686,0.00589 0.039796,0.00994 0.014274,0.00443 0.027833,0.00918 0.04146,0.014925 0.013627,0.00575 0.026891,0.012905 0.039797,0.0199 0.012906,0.00699 0.026033,0.013392 0.038141,0.02156 0.012108,0.00817 0.023588,0.017267 0.034829,0.026534 0.011233,0.00925 0.021218,0.019562 0.03151,0.029852 0.010288,0.010287 0.020583,0.020271 0.029854,0.031509 0.00925,0.011237 0.018366,0.022716 0.026534,0.034826 0.00815,0.012111 0.016227,0.025236 0.023214,0.038143 0.00697,0.012908 0.012498,0.026171 0.018238,0.039801 0.00577,0.013631 0.010508,0.027183 0.014926,0.04146 0.00442,0.014278 0.00859,0.029927 0.011608,0.044776 0.00306,0.014849 0.0051,0.029429 0.00661,0.044776 0.00152,0.015347 0.00331,0.030665 0.00331,0.046435 v 1.046432 c 0,0.015769 -0.00179,0.031087 -0.00331,0.046435 -0.00152,0.015347 -0.00365,0.031585 -0.00661,0.046435 -0.00306,0.014849 -0.00722,0.028839 -0.011608,0.043117 -0.00442,0.014278 -0.00918,0.027829 -0.014926,0.04146 -0.00577,0.013631 -0.01125,0.026892 -0.018238,0.039801 -0.00697,0.012908 -0.015046,0.026032 -0.023214,0.038143 -0.00815,0.012111 -0.017271,0.023588 -0.026534,0.034825 -0.00925,0.011238 -0.019563,0.022877 -0.029854,0.033168 -0.010287,0.010287 -0.020276,0.018926 -0.03151,0.028192 -0.011234,0.00925 -0.022712,0.018366 -0.034829,0.026535 -0.012108,0.00817 -0.025236,0.016223 -0.038141,0.023217 -0.012906,0.00699 -0.026169,0.012496 -0.039797,0.018241 -0.013627,0.00575 -0.027179,0.012162 -0.04146,0.016584 -0.014274,0.00443 -0.028266,0.00694 -0.043116,0.00994 -0.01485,0.00302 -0.031085,0.00675 -0.046437,0.00829 -0.015343,0.00154 -0.030669,0.00166 -0.046437,0.00166 H 4.6884567 c -0.015767,0 -0.031085,-1.092e-4 -0.046437,-0.00166 -0.015343,-0.00154 -0.029931,-0.00527 -0.044772,-0.00829 -0.01485,-0.00302 -0.028843,-0.00553 -0.043116,-0.00994 -0.014282,-0.00443 -0.029489,-0.01084 -0.043116,-0.016584 -0.013627,-0.00575 -0.026891,-0.011247 -0.039797,-0.018241 -0.012906,-0.00699 -0.024377,-0.015048 -0.036485,-0.023217 -0.012108,-0.00817 -0.023587,-0.017267 -0.034829,-0.026535 -0.011233,-0.00925 -0.022874,-0.017904 -0.033165,-0.028192 -0.010288,-0.010288 -0.020582,-0.02193 -0.029854,-0.033168 -0.00925,-0.011237 -0.01671,-0.022716 -0.024879,-0.034825 -0.00815,-0.012111 -0.016226,-0.025236 -0.023214,-0.038143 -0.00697,-0.012908 -0.014154,-0.02617 -0.019903,-0.039801 -0.00577,-0.013631 -0.010509,-0.027183 -0.014926,-0.04146 -0.00442,-0.014278 -0.00859,-0.028268 -0.011607,-0.043117 -0.00306,-0.014849 -0.0051,-0.031087 -0.00661,-0.046435 -0.00152,-0.015347 -0.0017,-0.030665 -0.0017,-0.046435 V 4.5186965 c 0,-0.015769 1.095e-4,-0.031087 0.0017,-0.046434 0.00152,-0.015347 0.00365,-0.029927 0.00661,-0.044776 0.00306,-0.014849 0.00722,-0.030497 0.011607,-0.044776 0.00442,-0.014278 0.00918,-0.027829 0.014926,-0.041459 0.00577,-0.013631 0.012905,-0.026893 0.019903,-0.039801 0.00697,-0.012908 0.015045,-0.026032 0.023214,-0.038143 0.00815,-0.012111 0.015607,-0.023588 0.024879,-0.034826 0.00925,-0.011238 0.019563,-0.02122 0.029854,-0.031509 0.010287,-0.010287 0.021931,-0.020585 0.033165,-0.029852 0.011234,-0.00925 0.022712,-0.018366 0.034829,-0.026534 0.012108,-0.00817 0.023579,-0.014565 0.036485,-0.02156 0.012906,-0.00699 0.026169,-0.014153 0.039797,-0.0199 0.013627,-0.00575 0.028835,-0.010509 0.043116,-0.014925 0.014282,-0.00443 0.028266,-0.00859 0.043116,-0.011608 0.01485,-0.00302 0.02943,-0.00509 0.044772,-0.00664 0.00713,-7.196e-4 0.014393,-0.00105 0.021558,-0.00166 v 0.1044776 c 0,0.081497 0.064438,0.145937 0.145937,0.145937 0.081496,0 0.1475951,-0.06444 0.1475951,-0.145937 z M 3.4007131,1.5987934 C 3.2739053,1.6119389 3.1742852,1.721402 3.1742852,1.8551992 V 3.1611161 H 2.1801716 c -0.1389804,0 -0.2512427,0.1136889 -0.2512427,0.2564057 0,0.1427169 0.1122623,0.2579983 0.2512427,0.2579983 h 1.1569559 c 0.027562,0.01064 0.057127,0.017518 0.0884,0.017518 0.1389805,0 0.2512426,-0.1152814 0.2512426,-0.2579982 V 1.8551988 c 0,-0.142717 -0.1122621,-0.2564057 -0.2512426,-0.2564057 -0.00868,0 -0.016361,-8.746e-4 -0.02481,0 z M 3.210852,0.22516467 A 3.0886102,3.0886102 0 0 0 0.12295911,3.3130583 3.0886102,3.0886102 0 0 0 3.210852,6.4009518 3.0886102,3.0886102 0 0 0 4.0997408,6.264965 c -0.00263,-0.0023 -0.00577,-0.00433 -0.00831,-0.00664 C 4.0713328,6.240168 4.0524498,6.220997 4.0350428,6.201941 4.0176368,6.182883 4.0018688,6.163788 3.9869508,6.143898 3.9720318,6.124009 3.9581328,6.10319 3.9454908,6.082538 3.9328488,6.061886 3.9212318,6.040866 3.9106618,6.019518 3.9000988,5.998172 3.8911668,5.976814 3.8824718,5.954842 3.8737818,5.932868 3.8662878,5.911036 3.8592578,5.888508 3.8522178,5.865978 3.8449348,5.843533 3.8393548,5.820515 3.8337448,5.797497 3.8287478,5.774301 3.8244288,5.750863 3.8216288,5.735594 3.8201788,5.719851 3.8178188,5.704428 A 2.4681909,2.4681909 0 0 1 3.5972533,5.7508688 2.4681909,2.4681909 0 0 1 3.210852,5.7807197 2.4681909,2.4681909 0 0 1 2.8261092,5.7508688 2.4681909,2.4681909 0 0 1 2.4480001,5.6596582 2.4681909,2.4681909 0 0 1 2.0914495,5.512063 2.4681909,2.4681909 0 0 1 1.7614328,5.3097413 2.4681909,2.4681909 0 0 1 1.4662424,5.0576683 2.4681909,2.4681909 0 0 1 1.2141694,4.764136 2.4681909,2.4681909 0 0 1 1.011847,4.4341194 2.4681909,2.4681909 0 0 1 0.8642518,4.0759105 2.4681909,2.4681909 0 0 1 0.77304107,3.6994595 2.4681909,2.4681909 0 0 1 0.74318722,3.3130583 2.4681909,2.4681909 0 0 1 0.77304107,2.9266569 2.4681909,2.4681909 0 0 1 0.8642518,2.5502059 2.4681909,2.4681909 0 0 1 1.011847,2.1919969 2.4681909,2.4681909 0 0 1 1.2141694,1.8619804 2.4681909,2.4681909 0 0 1 1.4662424,1.5684481 2.4681909,2.4681909 0 0 1 1.7614328,1.3163752 2.4681909,2.4681909 0 0 1 2.0914495,1.1140534 2.4681909,2.4681909 0 0 1 2.4480001,0.96479967 a 2.4681909,2.4681909 0 0 1 0.3781091,-0.089552 2.4681909,2.4681909 0 0 1 0.3847428,-0.029851 2.4681909,2.4681909 0 0 1 0.1393039,0.00332 2.4681909,2.4681909 0 0 1 0.1376449,0.011609 2.4681909,2.4681909 0 0 1 0.1376455,0.0199 2.4681909,2.4681909 0 0 1 0.1359865,0.0265344 2.4681909,2.4681909 0 0 1 0.1326699,0.034826 2.4681909,2.4681909 0 0 1 0.13267,0.041459 2.4681909,2.4681909 0 0 1 0.1293536,0.049751 2.4681909,2.4681909 0 0 1 0.1260359,0.056385 2.4681909,2.4681909 0 0 1 0.1227196,0.063019 2.4681909,2.4681909 0 0 1 0.1194029,0.071309 2.4681909,2.4681909 0 0 1 0.1160865,0.076286 2.4681909,2.4681909 0 0 1 0.1094525,0.082919 2.4681909,2.4681909 0 0 1 0.1061357,0.089552 2.4681909,2.4681909 0 0 1 0.1011608,0.096186 2.4681909,2.4681909 0 0 1 0.094527,0.099503 2.4681909,2.4681909 0 0 1 0.089552,0.1061357 2.4681909,2.4681909 0 0 1 0.082921,0.1111109 2.4681909,2.4681909 0 0 1 0.077947,0.1144281 2.4681909,2.4681909 0 0 1 0.069651,0.1194028 2.4681909,2.4681909 0 0 1 0.063014,0.1227165 2.4681909,2.4681909 0 0 1 0.056387,0.1260365 2.4681909,2.4681909 0 0 1 0.049748,0.1293531 2.4681909,2.4681909 0 0 1 0.043116,0.1326699 2.4681909,2.4681909 0 0 1 0.033165,0.1343285 2.4681909,2.4681909 0 0 1 0.02819,0.1359868 2.4681909,2.4681909 0 0 1 0.018239,0.1359867 2.4681909,2.4681909 0 0 1 0.011607,0.137645 2.4681909,2.4681909 0 0 1 0.00501,0.1393035 2.4681909,2.4681909 0 0 1 -0.00331,0.059701 c 0.019937,0.00764 0.040459,0.014678 0.059699,0.023217 0.042098,0.018682 0.082269,0.038276 0.1194031,0.059701 0.03713,0.021426 0.071273,0.04436 0.1011608,0.066334 0.029887,0.021975 0.055929,0.04269 0.076282,0.063019 0.010176,0.010166 0.019164,0.020509 0.026534,0.029852 0.00739,0.00934 0.013967,0.018291 0.018239,0.026534 L 6.270574,3.7193628 A 3.0886102,3.0886102 0 0 0 6.3004041,3.3130582 3.0886102,3.0886102 0 0 0 3.210852,0.22516467 Z" />
         ),
      },
      placeholder: {
         width: 22,
         height: 23,
         fill: '#BABABA',
         data: (
            <g>
               <path d="M6.002 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"></path>
               <path d="M2.002 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2h-12zm12 1a1 1 0 0 1 1 1v6.5l-3.777-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12V3a1 1 0 0 1 1-1h12z"></path>
            </g>
         ),
      },
      chevron: {
         width: 18,
         height: 18,
         viewBox: [0, 0, 7, 7],
         data: (
            <path d="M 2.1298167,5.1856129 2.6035184,5.6601968 4.9916354,3.2711152 2.6035211,0.82702975 2.1298193,1.3007315 4.0731408,3.244053 Z"></path>
         ),
      },
      'assigned to': {
         width: 30,
         height: 26,
         viewBox: [0, 0, 1, 8],
         data: (
            <path d="m 1.2903394,4.1117794 h 4.008585 c 0.4460348,0 0.8051157,0.3590814 0.8051157,0.8051153 V 6.1402919 C 4.5286247,6.1443118 1.285221,6.1650046 0.48522405,6.1287693 V 4.9168947 c 0,-0.4460339 0.35908155,-0.8051153 0.80511535,-0.8051153 z M 4.8041652,2.201333 A 1.5933957,1.5933957 0 0 1 3.2107692,3.7947286 1.5933957,1.5933957 0 0 1 1.6173733,2.201333 1.5933957,1.5933957 0 0 1 3.2107692,0.60793731 1.5933957,1.5933957 0 0 1 4.8041652,2.201333 Z" />
         ),
      },
      tick: {
         width: 27,
         height: 27,
         viewBox: [0, 0, 7, 7],
         data: (
            <path d="M 4.1648989,1.487276 2.8797426,3.713838 1.8523989,3.120088 1.3289614,4.026338 3.2645083,5.143526 3.7879457,4.237276 3.7859957,4.235276 5.071152,2.010666 Z" />
         ),
      },
      warehouse: {
         width: 30,
         height: 26,
         viewBox: [0, 0, 8, 8],
         data: (
            <path d="M 2.5567827,1.5974447 0.87597567,2.7997673 V 5.0882727 H 1.3385457 V 2.7997673 L 2.7257827,1.7528978 Z M 3.3690991,1.5815299 1.7280784,2.7997673 V 5.0882727 H 2.1906486 V 2.7997673 L 3.5540136,1.7528978 Z M 4.2600418,1.2416359 6.1346686,2.7023841 V 5.3560766 H 5.2095281 V 3.1893001 H 3.1401349 V 5.307385 H 0.63251717 L 0.60864507,2.6326623 2.5577303,1.2425832 2.9383584,1.5749935 3.4322845,1.2416359 3.8222911,1.598392 Z" />
         ),
      },
      'warehouse loaned': {
         width: 30,
         height: 26,
         viewBox: [0, 0, 8, 8],
         data: (
            <path d="m 6.0637284,3.609375 -0.2714844,0.2363281 0.2148437,0.25 H 4.2063065 V 4.4570312 H 6.042244 l -0.25,0.2890626 L 6.0637284,4.9824219 6.542244,4.4277344 V 4.1640625 Z M 2.9824219,1.21875 2.4882812,1.5527344 2.1074219,1.2207031 0.15820312,2.609375 0.18164062,5.2851562 H 2.6894531 V 3.1660156 H 4.7597656 V 3.8710938 H 5.6835938 V 2.6796875 L 3.8105469,1.21875 l -0.4375,0.3574219 z m -0.0625,0.3398438 0.1835937,0.171875 -1.3632812,1.046875 V 5.0664062 H 1.2773438 V 2.7773438 Z m -0.8125,0.015625 0.1679687,0.15625 -1.38671872,1.046875 V 5.0664062 H 0.42578125 V 2.7773438 Z M 4.7597656,4.6816406 V 5.3339844 H 5.6835938 V 4.6816406 Z" />
         ),
      },
      'warehouse-arrow': {
         width: 33,
         height: 20,
         viewBox: [0, 0, 33, 22],
         data: (
            <>
               <g clipPath="url(#clip0_3125_2457)">
                  <path d="M13.9957 20.8424C18.1776 20.8424 22.3596 20.8424 26.5336 20.8424C27.2199 20.8424 27.3716 20.7067 27.3795 20.0124C27.3875 19.1026 27.3795 18.1928 27.3795 17.2829C27.3795 17.0276 27.2997 16.9158 27.0364 16.9318C26.7969 16.9478 26.5495 16.9557 26.3101 16.9318C26.0388 16.9079 25.935 16.9956 25.943 17.2829C25.959 17.8496 25.951 18.4162 25.943 18.9749C25.943 19.5016 25.9031 19.5335 25.3764 19.5415C25.0332 19.5415 24.69 19.5256 24.3468 19.5415C24.0675 19.5575 23.9877 19.4378 23.9877 19.1664C23.9957 18.5359 23.9877 17.9055 23.9877 17.275C23.9877 17.0196 23.9079 16.9079 23.6445 16.9238C23.3732 16.9398 23.0938 16.9398 22.8145 16.9238C22.591 16.9158 22.5352 17.0036 22.5432 17.2191C22.5591 17.8656 22.5432 18.504 22.5591 19.1505C22.5591 19.4298 22.4793 19.5495 22.184 19.5495C19.1593 19.5415 16.1425 19.5335 13.1178 19.5415C12.8305 19.5415 12.7347 19.4537 12.7347 19.1584C12.7347 16.4529 12.7347 13.7474 12.7347 11.0419C12.7347 10.7387 12.8464 10.6349 13.1417 10.6349C15.8792 10.6349 18.6086 10.611 21.346 10.603C21.6333 10.603 21.9207 10.6349 22.208 10.6349C22.4554 10.6349 22.5671 10.7227 22.5591 10.9861C22.5432 11.5527 22.5591 12.1193 22.5432 12.678C22.5352 12.9094 22.607 13.0052 22.8384 12.9972C23.1178 12.9893 23.3891 12.9972 23.6685 12.9972C23.8839 12.9972 23.9957 12.9254 23.9877 12.694C23.9797 11.848 23.9877 11.01 23.9797 10.164C23.9797 9.99644 23.9478 9.82884 23.8999 9.6772C23.7802 9.27018 23.6605 9.19037 23.2295 9.19037C19.686 9.19835 16.1505 9.21431 12.607 9.22229C12.4075 9.22229 12.208 9.22229 12.0084 9.22229C11.6413 9.22229 11.4657 9.35797 11.3859 9.72509C11.346 9.93259 11.3221 10.1401 11.3221 10.3476C11.3221 13.2207 11.3221 16.0858 11.3221 18.9589C11.3221 19.3473 11.1252 19.5415 10.7315 19.5415C10.4043 19.5415 10.0691 19.5256 9.74188 19.5415C9.47053 19.5495 9.36678 19.4537 9.36678 19.1744C9.38274 18.6397 9.36678 18.113 9.36678 17.5782C9.36678 14.8488 9.36678 12.1273 9.36678 9.39787C9.36678 9.12652 9.40668 8.91104 9.64611 8.73546C11.6254 7.2191 13.5966 5.69476 15.5679 4.17042C16.1984 3.68359 16.8209 3.19676 17.4354 2.70194C17.5791 2.58223 17.6748 2.56627 17.8345 2.69396C19.6222 4.12253 21.4019 5.54312 23.2056 6.95573C23.9717 7.5543 24.7539 8.12892 25.544 8.68758C25.8313 8.8871 25.943 9.12652 25.943 9.46172C25.935 10.5391 25.943 11.6086 25.943 12.686C25.943 12.9174 25.9989 13.0052 26.2383 12.9893C26.5256 12.9733 26.8129 12.9893 27.1002 12.9893C27.2678 12.9893 27.3636 12.9414 27.3636 12.7418C27.3636 11.5128 27.3476 10.2837 27.3875 9.0547C27.4035 8.38431 27.1401 7.93738 26.6214 7.54632C25.1689 6.4689 23.7483 5.35158 22.3117 4.25023C21.1226 3.33243 19.9414 2.41463 18.7523 1.49684C18.5048 1.3053 18.2574 1.10577 18.01 0.906253C17.8504 0.77856 17.3716 0.834426 17.212 0.9701C16.8289 1.29731 16.4458 1.63251 16.0308 1.91184C15.9191 1.99165 15.6477 1.95972 15.52 1.87194C15.097 1.57664 14.7139 1.23347 14.3149 0.906253C14.1473 0.770579 13.6844 0.826445 13.5088 0.9701C13.1417 1.28135 12.7826 1.61655 12.3835 1.87992C12.2399 1.97569 11.9286 1.98367 11.785 1.87992C11.362 1.60857 10.9789 1.27337 10.5878 0.954138C10.3883 0.794521 9.99727 0.786541 9.82169 0.930196C9.32688 1.33722 8.83206 1.73626 8.33725 2.12732C7.24387 2.98127 6.1505 3.8432 5.04914 4.68917C3.78817 5.65486 2.53517 6.62852 1.25026 7.56228C0.731503 7.93738 0.476116 8.37633 0.484097 9.03076C0.508039 12.6301 0.492079 16.2375 0.500059 19.8368C0.500059 20.7147 0.619772 20.8264 1.49767 20.8264C5.66367 20.8264 9.83765 20.8264 14.0037 20.8264L13.9957 20.8424ZM4.25106 13.9709C4.25106 15.6788 4.25106 17.3867 4.25106 19.0866C4.25106 19.5495 4.22711 19.5575 3.78817 19.5575C3.32528 19.5575 2.86239 19.5575 2.3995 19.5575C1.90469 19.5575 1.90469 19.5575 1.89671 19.0547C1.89671 17.0834 1.88873 15.1122 1.88873 13.1409C1.88873 11.9039 1.88873 10.6588 1.90469 9.42182C1.90469 9.22229 1.97651 8.95095 2.12017 8.83921C2.91027 8.20873 3.74028 7.62613 4.55433 7.0116C5.90309 5.98207 7.25186 4.95254 8.60062 3.91503C9.06351 3.55589 9.51842 3.18878 9.97332 2.82964C10.1569 2.68598 10.4841 2.76579 10.6597 3.0132C10.8353 3.25262 10.5799 3.32445 10.4602 3.41224C9.99727 3.77138 9.51842 4.09859 9.05553 4.45773C7.67484 5.51918 6.3181 6.62054 4.91347 7.64209C4.39471 8.01719 4.2351 8.45613 4.2351 9.04672C4.24308 10.6828 4.2351 12.3268 4.2351 13.9629L4.25106 13.9709ZM7.94619 13.931C7.94619 15.6788 7.94619 17.4346 7.94619 19.1824C7.94619 19.4537 7.85042 19.5655 7.57907 19.5655C7.06031 19.5575 6.54156 19.5495 6.0228 19.5655C5.79934 19.5655 5.68761 19.4697 5.68761 19.2542C5.68761 18.911 5.70357 18.5679 5.70357 18.2247C5.69559 15.3755 5.67963 12.5264 5.66367 9.6772C5.66367 9.29412 5.70357 8.99883 6.09463 8.73546C7.00445 8.11296 7.83446 7.3867 8.70437 6.71631C10.2048 5.55909 11.7131 4.40186 13.2135 3.24464C13.3971 3.10099 13.5807 2.95733 13.7642 2.82166C14.0356 2.63012 14.2191 2.8456 14.3548 3.00522C14.5304 3.20474 14.291 3.28455 14.1712 3.37233C13.3492 4.00282 12.5192 4.61735 11.6972 5.25581C10.6437 6.06986 9.61419 6.92381 8.53677 7.71391C8.09782 8.03315 7.92225 8.40027 7.93023 8.91104C7.93821 10.587 7.93023 12.255 7.93023 13.931H7.94619Z" />
                  <path d="M31.5376 15.7986C31.4578 15.8943 31.378 15.9981 31.2902 16.0939C30.6916 16.7323 30.093 17.3628 29.5025 18.0093C29.2391 18.3046 29.1832 18.6557 29.3588 19.0308C29.5583 19.4538 30.1569 19.5576 30.4841 19.2144C31.6254 18.0252 32.7586 16.8361 33.8919 15.639C34.4905 15.0085 34.4905 14.5935 33.8919 13.947C32.7986 12.7818 31.6892 11.6246 30.5879 10.4594C30.5719 10.4434 30.5559 10.4275 30.54 10.4115C30.3165 10.2758 30.1569 9.93265 29.8137 10.1641C29.3189 10.4993 29.1513 10.8824 29.3508 11.2894C29.4386 11.473 29.5823 11.6406 29.7179 11.7922C30.2766 12.4067 30.8512 13.0053 31.4099 13.6118C31.4897 13.6916 31.5296 13.8034 31.5934 13.9071C31.4737 13.939 31.354 14.0029 31.2343 14.0029C30.2287 14.0109 29.2231 14.0029 28.2255 14.0029C25.5041 14.0029 22.7746 14.0029 20.0531 14.0029C19.5743 14.0029 19.3987 14.1146 19.2471 14.4897C19.1114 14.8249 19.1832 15.2 19.4945 15.4474C19.6461 15.5671 19.8776 15.615 20.0691 15.623C22.3756 15.631 24.682 15.623 26.9885 15.623C28.3133 15.623 29.6381 15.623 30.963 15.639C31.1465 15.639 31.3221 15.6629 31.5057 15.6789C31.5216 15.7188 31.5296 15.7507 31.5456 15.7906L31.5376 15.7986Z" />
               </g>
               <defs>
                  <clipPath id="clip0_3125_2457">
                     <rect
                        width="33.8707"
                        height="20"
                        fill="white"
                        transform="matrix(-1 0 0 1 34.3468 0.842773)"
                     />
                  </clipPath>
               </defs>
            </>
         ),
      },
      'warehouse-outlined': {
         width: 29,
         height: 20,
         viewBox: [0, 0, 29, 22],
         data: (
            <path d="M15.2666 22.1942C19.819 22.1942 24.3713 22.1942 28.915 22.1942C29.6622 22.1942 29.8272 22.0465 29.8359 21.2906C29.8446 20.3002 29.8359 19.3098 29.8359 18.3194C29.8359 18.0414 29.749 17.9198 29.4623 17.9372C29.2017 17.9546 28.9324 17.9632 28.6718 17.9372C28.3764 17.9111 28.2634 18.0067 28.2721 18.3194C28.2895 18.9363 28.2808 19.5531 28.2721 20.1612C28.2721 20.7346 28.2287 20.7694 27.6553 20.7781C27.2817 20.7781 26.9081 20.7607 26.5346 20.7781C26.2305 20.7954 26.1436 20.6651 26.1436 20.3697C26.1523 19.6834 26.1436 18.9971 26.1436 18.3108C26.1436 18.0327 26.0568 17.9111 25.7701 17.9285C25.4747 17.9459 25.1706 17.9459 24.8665 17.9285C24.6233 17.9198 24.5625 18.0154 24.5712 18.2499C24.5885 18.9536 24.5712 19.6487 24.5885 20.3524C24.5885 20.6564 24.5017 20.7867 24.1802 20.7867C20.8876 20.7781 17.6036 20.7694 14.311 20.7781C13.9982 20.7781 13.894 20.6825 13.894 20.361C13.894 17.4159 13.894 14.4708 13.894 11.5257C13.894 11.1955 14.0156 11.0826 14.337 11.0826C17.3169 11.0826 20.2881 11.0565 23.268 11.0478C23.5808 11.0478 23.8935 11.0826 24.2063 11.0826C24.4756 11.0826 24.5972 11.1781 24.5885 11.4648C24.5712 12.0817 24.5885 17.6852 24.5712 18.2934C24.5625 18.5453 24.6407 18.6496 24.8926 18.6409C25.1967 18.6322 25.4921 18.6409 25.7961 18.6409C26.0307 18.6409 26.1523 18.5627 26.1436 18.3108C26.1349 17.3899 26.1436 11.4909 26.1349 10.57C26.1349 10.3876 26.1002 10.2051 26.0481 10.0401C25.9178 9.59699 25.7874 9.51011 25.3183 9.51011C21.461 9.5188 17.6123 9.53617 13.755 9.54486C13.5378 9.54486 13.3206 9.54486 13.1034 9.54486C12.7038 9.54486 12.5126 9.69255 12.4257 10.0922C12.3823 10.3181 12.3562 10.5439 12.3562 10.7698C12.3562 13.8974 12.3562 17.0163 12.3562 20.1439C12.3562 20.5667 12.142 20.7781 11.7134 20.7781C11.3572 20.7781 10.9923 20.7607 10.6361 20.7781C10.3407 20.7867 10.2278 20.6825 10.2278 20.3784C10.2451 19.7963 10.2278 19.223 10.2278 18.6409C10.2278 15.6697 10.2278 12.7072 10.2278 9.73599C10.2278 9.44061 10.2712 9.20604 10.5318 9.01491C12.6864 7.36425 14.8322 5.7049 16.9781 4.04554C17.6644 3.51559 18.3421 2.98564 19.011 2.44701C19.1674 2.31669 19.2717 2.29932 19.4454 2.43832C21.3915 3.99342 23.3288 5.53983 25.2922 7.07755C26.1263 7.72913 26.9777 8.35464 27.8377 8.96278C28.1505 9.17998 28.2721 9.44061 28.2721 9.80549C28.2634 10.9783 28.2721 16.8686 28.2721 18.0414C28.2721 18.2934 28.3329 18.3889 28.5936 18.3716C28.9063 18.3542 29.2191 18.3716 29.5318 18.3716C29.7143 18.3716 29.8185 18.3194 29.8185 18.1022C29.8185 16.7643 29.8012 10.7003 29.8446 9.36242C29.862 8.63265 29.5753 8.14614 29.0106 7.72044C27.4294 6.5476 25.883 5.33132 24.3192 4.13242C23.0247 3.13334 21.739 2.13425 20.4445 1.13516C20.1752 0.92666 19.9059 0.709467 19.6365 0.492275C19.4628 0.353271 18.9415 0.414085 18.7678 0.561776C18.3508 0.917972 17.9338 1.28286 17.482 1.58693C17.3604 1.6738 17.065 1.63905 16.926 1.54349C16.4655 1.22204 16.0485 0.84847 15.6141 0.492275C15.4317 0.344584 14.9278 0.405398 14.7367 0.561776C14.337 0.900597 13.9461 1.26548 13.5117 1.55217C13.3553 1.65643 13.0165 1.66511 12.8601 1.55217C12.3997 1.25679 11.9827 0.891909 11.557 0.544401C11.3398 0.370647 10.9141 0.361959 10.723 0.518338C10.1843 0.961411 9.64568 1.3958 9.10705 1.82149C7.91683 2.75108 6.72662 3.68935 5.52772 4.61025C4.15506 5.66146 2.79109 6.72136 1.39237 7.73782C0.827665 8.14614 0.54966 8.62396 0.558348 9.33636C0.584412 13.2545 0.567036 17.1814 0.575724 21.0995C0.575724 22.0552 0.706041 22.1768 1.66169 22.1768C6.19667 22.1768 10.7403 22.1768 15.2753 22.1768L15.2666 22.1942ZM4.65895 14.714C4.65895 16.5732 4.65895 18.4324 4.65895 20.2829C4.65895 20.7867 4.63288 20.7954 4.15506 20.7954C3.65117 20.7954 3.14729 20.7954 2.6434 20.7954C2.10476 20.7954 2.10476 20.7954 2.09607 20.2481C2.09607 18.1022 2.08739 15.9564 2.08739 13.8105C2.08739 12.4639 2.08738 11.1086 2.10476 9.76205C2.10476 9.54486 2.18295 9.24948 2.33933 9.12785C3.19941 8.44152 4.10293 7.80732 4.98907 7.13837C6.4573 6.01765 7.92552 4.89694 9.39374 3.76754C9.89763 3.37659 10.3928 2.97696 10.888 2.58601C11.0878 2.42963 11.444 2.51651 11.6352 2.78583C11.8263 3.04646 11.5483 3.12465 11.418 3.22021C10.9141 3.61116 10.3928 3.96736 9.88894 4.3583C8.38597 5.51377 6.90906 6.71267 5.38002 7.8247C4.81532 8.23302 4.64157 8.71084 4.64157 9.35373C4.65026 11.1347 4.64157 12.9244 4.64157 14.7054L4.65895 14.714ZM8.68135 14.6706C8.68135 16.5732 8.68135 18.4845 8.68135 20.3871C8.68135 20.6825 8.5771 20.8041 8.28172 20.8041C7.71701 20.7954 7.15232 20.7867 6.58761 20.8041C6.34436 20.8041 6.22273 20.6999 6.22273 20.4653C6.22273 20.0917 6.24011 19.7182 6.24011 19.3446C6.23142 16.2431 6.21404 13.1416 6.19667 10.0401C6.19667 9.62305 6.2401 9.30161 6.6658 9.01491C7.6562 8.33727 8.55972 7.54669 9.50668 6.81692C11.14 5.55721 12.7819 4.29749 14.4152 3.03777C14.6151 2.88139 14.8149 2.72501 15.0147 2.57732C15.3101 2.36882 15.5099 2.60339 15.6576 2.77714C15.8487 2.99433 15.5881 3.08121 15.4578 3.17677C14.5629 3.8631 13.6594 4.53206 12.7646 5.22707C11.6178 6.11322 10.4971 7.0428 9.32424 7.90288C8.84642 8.25039 8.65529 8.65003 8.66398 9.20604C8.67266 11.0305 8.66398 12.8462 8.66398 14.6706H8.68135Z" />
         ),
      },
      'warehouse-yellow-bg': {
         width: 30,
         height: 30,
         viewBox: [0, 0, 30, 30],
         fill: 'none',
         data: (
            <>
               <g clipPath="url(#clip0_5426_4196)">
                  <circle cx="15" cy="15" r="15" fill="#FFD600" />
                  <g clipPath="url(#clip1_5426_4196)">
                     <path
                        d="M14.8511 6.61767L8.0195 11.9088C7.72183 12.2065 7.55811 12.6158 7.55811 13.04V21.2335C7.55811 21.3451 7.64741 21.4419 7.76648 21.4419H11.0409V14.2605C11.0409 13.9702 11.2716 13.7395 11.5618 13.7395H18.4307C18.7209 13.7395 18.9516 13.9702 18.9516 14.2605V21.4419H22.2335C22.3451 21.4419 22.4418 21.3526 22.4418 21.2335V13.04C22.4418 12.6158 22.2781 12.2139 21.9804 11.9088L15.1488 6.61767C15.0669 6.53581 14.9404 6.53581 14.8586 6.61767H14.8511Z"
                        stroke="black"
                        strokeWidth="1.5"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                     />
                     <path
                        d="M11.041 21.4419H19.495"
                        stroke="black"
                        strokeWidth="1.5"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                     />
                     <path
                        d="M11.041 18.8967H18.9517"
                        stroke="black"
                        strokeWidth="1.5"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                     />
                     <path
                        d="M11.041 16.2846H18.9517"
                        stroke="black"
                        strokeWidth="1.5"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                     />
                  </g>
               </g>
               <defs>
                  <clipPath id="clip0_5426_4196">
                     <rect width="30" height="30" fill="white" />
                  </clipPath>
                  <clipPath id="clip1_5426_4196">
                     <rect
                        width="16"
                        height="16"
                        fill="white"
                        transform="translate(7 6)"
                     />
                  </clipPath>
               </defs>
            </>
         ),
      },
      'home-warehouse': {
         width: 14,
         height: 15,
         viewBox: [0, 0, 14, 15],
         fill: 'none',
         data: (
            <>
               <g clipPath="url(#clip0_7035_4140)">
                  <path
                     d="M6.8806 1.54876L1.3781 5.81423C1.13834 6.0542 1.00647 6.38416 1.00647 6.72611V13.3313C1.00647 13.4213 1.0784 13.4993 1.1743 13.4993H3.64983C3.73974 13.4993 3.81766 13.4273 3.81766 13.3313V7.45202C3.81766 7.36203 3.88959 7.28404 3.98549 7.28404H10.0274C10.1174 7.28404 10.1953 7.35604 10.1953 7.45202V13.3313C10.1953 13.4213 10.2672 13.4993 10.3631 13.4993H12.8386C12.9285 13.4993 13.0065 13.4273 13.0065 13.3313V6.72611C13.0065 6.38416 12.8746 6.0602 12.6348 5.81423L7.12036 1.54876C7.05442 1.48277 6.95252 1.48277 6.88659 1.54876H6.8806Z"
                     stroke="#6F7680"
                     strokeWidth="1.5"
                     strokeMiterlimit="10"
                     strokeLinecap="round"
                  />
                  <path
                     d="M4.00647 13.4993H11.0065"
                     stroke="#6F7680"
                     strokeWidth="1.5"
                     strokeMiterlimit="10"
                     strokeLinecap="round"
                  />
                  <path
                     d="M4.00647 11.4993H10.0065"
                     stroke="#6F7680"
                     strokeWidth="1.5"
                     strokeMiterlimit="10"
                     strokeLinecap="round"
                  />
                  <path
                     d="M4.00647 9.49927H10.0065"
                     stroke="#6F7680"
                     strokeWidth="1.5"
                     strokeMiterlimit="10"
                     strokeLinecap="round"
                  />
               </g>
               <defs>
                  <clipPath id="clip0_7035_4140">
                     <rect
                        width="14"
                        height="14"
                        fill="white"
                        transform="translate(0 0.5)"
                     />
                  </clipPath>
               </defs>
            </>
         ),
      },
      'return tool': {
         width: 27,
         height: 20,
         viewBox: [0, 0, 150, 152],
         data: (
            <path d="M40.88,97.05l-7.11,7.15-3.41,3.4L.68,137.36c-.91,.93-.91,2.45,0,3.4l10.52,10.53c.94,.95,2.47,.95,3.37,0l29.68-29.76,13.94-13.95,4.19-4.23c1.89,.74,3.91,1.24,5.96,1.42,2.55,.22,5.18,.04,7.81-.66,3.41-.9,6.46-2.62,8.96-4.86,2.59-2.31,4.6-5.22,5.88-8.43,.45-1.24-.13-2.62-1.36-3.09-.49-.21-1.03-.23-1.48-.1l-6.41,1.71-5.18,1.4-3.78-3.81-3.83-3.79,1.4-5.22,1.4-5.19,5.18-1.4,6.37-1.71c1.27-.33,2.05-1.67,1.68-2.93-.12-.53-.41-.97-.82-1.28-2.68-2.14-5.84-3.67-9.25-4.37-3.29-.68-6.78-.64-10.2,.31-5.88,1.56-10.61,5.4-13.4,10.3-2.84,4.93-3.82,10.92-2.22,16.81l.04,.2,.04,.06-4.93,4.91-3.37,3.4ZM19.25,21.83C33.89,7.58,53.59-.27,74.01,0c20.43,.28,39.91,8.65,54.16,23.29,14.25,14.64,22.1,34.34,21.82,54.76-.28,20.43-8.66,39.91-23.29,54.16-2.43,2.43-5.98,3.38-9.3,2.49-3.32-.89-5.92-3.49-6.81-6.81-.89-3.32,.06-6.87,2.49-9.3,14.61-14.59,20.33-35.86,15.01-55.81-5.33-19.95-20.89-35.54-40.83-40.9-19.94-5.36-41.22,.32-55.84,14.91h14.29c3.44,0,6.62,1.83,8.34,4.81,1.72,2.98,1.72,6.65,0,9.62-1.72,2.98-4.9,4.81-8.34,4.81H9.62c-2.55,0-5-1.02-6.8-2.82C1.01,51.42,0,48.97,0,46.42V10.33C0,6.89,1.83,3.71,4.81,1.99,7.79,.28,11.46,.28,14.44,1.99c2.98,1.72,4.81,4.9,4.81,8.33v11.5h0Z" />
         ),
      },
      forward: {
         width: 26,
         height: 26,
         viewBox: [0, 0, 26, 26],
         data: (
            <path
               xmlns="http://www.w3.org/2000/svg"
               d="M2.398 1.088V5.72l2.317-2.316Z"
            />
         ),
      },
      loaned: {
         width: 20,
         height: 20,
         viewBox: [0, 0, 512, 512],
         data: (
            <path d="M 164.05,85.049999 V 200.5 H 200.5 V 126.2 H 447.10001 V 404.75 H 200.5 v -74.25001 h -36.45 v 115.40002 h 319.5 V 85.049999 Z m -52.80836,81.746181 c 16.38565,-11.77498 41.92238,0.51333 30.56717,29.61194 L 98.823726,241.30364 H 319.48045 c 25.83843,6.25453 26.00793,38.88704 1.91045,44.89554 H 97.868506 l 44.895524,47.76118 c 10.15617,22.57845 -11.1953,39.51062 -31.52239,29.61195 L 25.749098,278.07975 c -8.29262,-11.28798 -3.38092,-22.48065 4.29851,-30.08954 z" />
         ),
      },
      pin: {
         width: 42,
         height: 61,
         viewBox: [0, 0, 42, 61],
         data: (
            <>
               <ellipse
                  style={{ opacity: '0.3', fill: '#231f20' }}
                  cx="21.5"
                  cy="53"
                  rx="19.5"
                  ry="8"
               />
               <circle style={{ fill: '#FFF' }} cx="21" cy="20" r="15" />
               <path
                  fillRule="evenodd"
                  style={{
                     stroke: '#000',
                     paintOrder: 'stroke fill markers',
                     strokeLinejoin: 'round',
                     strokeOpacity: '.6',
                     strokeWidth: 3,
                  }}
                  d="m40 20.2c0.1 1.9-0.4 13.3-19 31.3q-20.4-19.8-18.9-31.6c0-9.9 8.5-17.9 18.9-17.9 10.5 0 19 8 19 17.9q0 0.1 0 0.3zm-7.3-0.6c0-6.4-5.3-11.6-11.7-11.6-6.5 0-11.7 5.2-11.7 11.6 0 6.4 5.2 11.6 11.7 11.6 6.4 0 11.7-5.2 11.7-11.6z"
               />
            </>
         ),
      },
      pinNoShadow: {
         width: 42,
         height: 28,
         viewBox: [0, 0, 42, 28],
         data: (
            <>
               <circle style={{ fill: 'none' }} cx="21" cy="20" r="15" />
               <path
                  fillRule="evenodd"
                  style={{
                     stroke: '#000',
                     paintOrder: 'stroke fill markers',
                     strokeLinejoin: 'round',
                     strokeOpacity: '.6',
                     strokeWidth: 3,
                  }}
                  d="m40 20.2c0.1 1.9-0.4 13.3-19 31.3q-20.4-19.8-18.9-31.6c0-9.9 8.5-17.9 18.9-17.9 10.5 0 19 8 19 17.9q0 0.1 0 0.3zm-7.3-0.6c0-6.4-5.3-11.6-11.7-11.6-6.5 0-11.7 5.2-11.7 11.6 0 6.4 5.2 11.6 11.7 11.6 6.4 0 11.7-5.2 11.7-11.6z"
               />
            </>
         ),
      },
      lastSeenArea: {
         width: 45,
         height: 45,
         viewBox: [-3, -5, 48, 45],
         data: (
            <ellipse
               style={{ opacity: '0.8', fill: '#b2fbb9' }}
               cx="22"
               cy="22"
               rx="25"
               ry="25"
            />
         ),
      },
      returned: {
         width: 20,
         height: 20,
         viewBox: [0, 0, 512, 512],
         data: (
            <path d="M 340.93846,85.049999 V 200.5 h -36.45 c -1.215,-20.65504 0,-74.3 0,-74.3 H 57.88845 v 278.55 h 246.60001 v -74.25001 h 36.45 v 115.40002 h -319.5 V 85.049999 Z m 52.80836,81.746181 c -16.38565,-11.77498 -41.92238,0.51333 -30.56717,29.61194 l 42.98508,44.89552 H 185.50801 c -25.83843,6.25453 -26.00793,38.88704 -1.91045,44.89554 h 223.52239 l -44.89552,47.76118 c -10.15617,22.57845 11.1953,39.51062 31.52239,29.61195 l 85.49254,-85.49256 c 8.29262,-11.28798 3.38092,-22.48065 -4.29851,-30.08954 z" />
         ),
      },
      'returned to owner': {
         width: 20,
         height: 20,
         viewBox: [0, 0, 512, 512],
         data: (
            <path d="M 340.93846,85.049999 V 200.5 h -36.45 c -1.215,-20.65504 0,-74.3 0,-74.3 H 57.88845 v 278.55 h 246.60001 v -74.25001 h 36.45 v 115.40002 h -319.5 V 85.049999 Z m 52.80836,81.746181 c -16.38565,-11.77498 -41.92238,0.51333 -30.56717,29.61194 l 42.98508,44.89552 H 185.50801 c -25.83843,6.25453 -26.00793,38.88704 -1.91045,44.89554 h 223.52239 l -44.89552,47.76118 c -10.15617,22.57845 11.1953,39.51062 31.52239,29.61195 l 85.49254,-85.49256 c 8.29262,-11.28798 3.38092,-22.48065 -4.29851,-30.08954 z" />
         ),
      },
      copy: {
         width: 30,
         height: 30,
         viewBox: [0, 0, 30, 30],
         fill: 'none',
         data: (
            <>
               <rect fill="none" width="30" height="30" rx="5.02" ry="5.02" />
               <rect
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeMiterlimit="10"
                  strokeWidth="1.5px"
                  x="10.69"
                  y="8"
                  width="11.38"
                  height="11.38"
                  rx="2.33"
                  ry="2.33"
               />
               <path
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeMiterlimit="10"
                  strokeWidth="1.5px"
                  d="M19.31,19.38v.78c0,1.01-.82,1.83-1.83,1.83h-6.82c-1.51,0-2.73-1.22-2.73-2.73v-6.82c0-1.01.82-1.83,1.83-1.83h.92"
               />
               <path
                  stroke="none"
                  fill="#000"
                  d="M15.77,14.09v1.67h-1.67v-1.67h1.67M16.62,12.59h-3.37c-.36,0-.65.29-.65.65v3.37c0,.36.29.65.65.65h3.37c.36,0,.65-.29.65-.65v-3.37c0-.36-.29-.65-.65-.65h0Z"
               />
               <line
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeMiterlimit="10"
                  strokeWidth="1.5px"
                  x1="13.26"
                  y1="10.82"
                  x2="19.03"
                  y2="10.82"
               />
            </>
         ),
      },
      remove: {
         width: 30,
         height: 30,
         viewBox: [0, 0, 30, 30],
         fill: 'none',
         data: (
            <>
               <rect x="0" width="30" height="30" rx="5.02" ry="5.02" />
               <path
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5px"
                  d="M16.7,21.3h-3.39c-.69,0-1.29-.49-1.42-1.18l-1.64-8.78h9.48l-1.62,8.78c-.13.68-.72,1.18-1.42,1.18Z"
               />
               <line
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5px"
                  x1="16.48"
                  y1="13.96"
                  x2="13.52"
                  y2="16.92"
               />
               <line
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5px"
                  x1="16.48"
                  y1="16.92"
                  x2="13.52"
                  y2="13.96"
               />
               <path
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5px"
                  d="M11.19,8.8h7.62c.94,0,1.7.76,1.7,1.7v.58c0,.14-.11.26-.26.26h-10.51c-.14,0-.26-.11-.26-.26v-.58c0-.94.76-1.7,1.7-1.7Z"
               />
               <path
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5px"
                  d="M14.99,6.92h.03c.8,0,1.45.65,1.45,1.45v.44h-2.92v-.44c0-.8.65-1.45,1.45-1.45Z"
               />
            </>
         ),
      },
      text: {
         width: 26,
         height: 26,
         viewBox: [0, 0, 26, 26],
         data: (
            <path d="m 2.1890738,4.3454738 h 1.061864 v 0.2940547 h -1.061864 z m 0,-0.8168183 h 2.20541 v 0.2940546 h -2.20541 z m 0,-0.7841458 h 2.20541 v 0.2940546 h -2.20541 z m 0,-0.8168183 h 2.20541 v 0.2940547 h -2.20541 z M 1.6510428,1.1280265 c -0.156897,0.015839 -0.279297,0.1493375 -0.279297,0.3105469 v 3.625 c 0,0.1719566 0.13859,0.3105468 0.310547,0.3105468 h 3.283203 c 0.171957,0 0.310547,-0.1385902 0.310547,-0.3105468 v -3.625 c 0,-0.1719567 -0.13859,-0.3105469 -0.310547,-0.3105469 h -3.283203 c -0.01075,0 -0.02079,-0.00106 -0.03125,0 z m 0.251953,0.2832031 h 2.84375 c 0.148934,0 0.267578,0.1205981 0.267578,0.2695312 v 3.140625 c 0,0.1489332 -0.118644,0.2695313 -0.267578,0.2695313 h -2.84375 c -0.148933,0 -0.269531,-0.1205981 -0.269531,-0.2695313 v -3.140625 c 0,-0.1489331 0.120598,-0.2695312 0.269531,-0.2695312 z" />
         ),
      },
      'add-note': {
         width: 30,
         height: 30,
         viewBox: [0, 0, 30, 30],
         fill: 'none',
         data: (
            <>
               <rect width="30" height="30" rx="5.02" ry="5.02" />
               <path
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5px"
                  d="M8.99,15.76v-5.4c0-.98.77-1.77,1.73-1.77h8.65c.95,0,1.73.79,1.73,1.77v8.99c0,.98-.77,1.77-1.73,1.77h-5"
               />
               <line
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5px"
                  x1="12.19"
                  y1="12.04"
                  x2="17.43"
                  y2="12.04"
               />
               <line
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5px"
                  x1="12.19"
                  y1="14.85"
                  x2="17.43"
                  y2="14.85"
               />
               <line
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5px"
                  x1="12.19"
                  y1="17.66"
                  x2="17.43"
                  y2="17.66"
               />
               <line
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5px"
                  x1="8.99"
                  y1="19.33"
                  x2="8.99"
                  y2="22.92"
               />
               <line
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5px"
                  x1="10.78"
                  y1="21.12"
                  x2="7.2"
                  y2="21.12"
               />
            </>
         ),
      },
      import: {
         width: 21,
         height: 19,
         viewBox: [0, 0, 21, 19],
         fill: 'none',
         data: (
            <>
               <path
                  d="M14.2807 14.3478H15.6549C20.4857 14.3478 21.1941 7.22902 16.4765 6.56318C15.6549 0.478566 6.46064 -0.378521 4.48438 5.39443C-0.445642 6.28693 -0.0277229 14.0078 5.00147 14.3407L6.59523 14.362"
                  stroke="black"
                  strokeWidth="2"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
               />
               <path
                  d="M13.3882 11.472L10.4416 9.16284L7.48779 11.472L10.4416 9.16284V17.5"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
            </>
         ),
      },
      toolbox: {
         width: 18,
         height: 18,
         viewBox: [0, 0, 7, 7],
         data: (
            <path d="m 2.3893739,0.72389945 c -0.252642,0.04139 -0.48295,0.11693925 -0.609375,0.34765625 v 1.0468749 h -0.378907 c -0.47498597,0 -0.85742097,0.3824349 -0.85742097,0.8574219 V 3.952415 H 1.9479679 V 3.6340556 c 0,-0.1489966 0.118581,-0.2675781 0.267578,-0.2675781 h 0.11914 c 0.148997,0 0.269532,0.1185815 0.269532,0.2675781 V 3.952415 h 1.339843 V 3.6340556 c 0,-0.1489966 0.118582,-0.2675781 0.267578,-0.2675781 h 0.119141 c 0.148997,0 0.269531,0.1185815 0.269531,0.2675781 V 3.952415 h 1.451172 V 2.9758525 c 0,-0.474987 -0.382434,-0.8574219 -0.857422,-0.8574219 H 4.7350769 V 1.24929 1.0090557 C 4.5932899,0.82334171 4.4642849,0.72393143 4.0749209,0.72389945 h -0.873047 z m 0.179687,0.69335925 h 1.279297 V 2.1184306 H 2.5690609 Z M 0.54367093,4.4895244 v 1.4746093 c 1.28222497,0.0074 4.77475497,0.0076 5.50781197,-0.037109 v -1.4375 h -1.451172 v 0.3046875 c 0,0.1489966 -0.120534,0.2695312 -0.269531,0.2695312 h -0.119141 c -0.148996,0 -0.267578,-0.1205346 -0.267578,-0.2695312 V 4.4895244 h -1.339843 v 0.3046875 c 0,0.1489966 -0.120535,0.2695312 -0.269532,0.2695312 h -0.11914 c -0.148997,0 -0.267578,-0.1205346 -0.267578,-0.2695312 V 4.4895244 Z" />
         ),
      },
      'manage-kit': {
         width: 30,
         height: 30,
         viewBox: [0, 0, 30, 30],
         // fill: 'none',
         data: (
            <>
               <rect fill="none" width="30" height="30" rx="5.02" ry="5.02" />
               <path d="M20.82,15.58c.4,0,.72.32.72.72v3.52c0,.4-.32.72-.72.72h-11.58c-.4,0-.72-.32-.72-.72v-3.52c0-.4.32-.72.72-.72h11.58M20.82,14.08h-11.58c-1.22,0-2.22.99-2.22,2.22v3.52c0,1.22.99,2.22,2.22,2.22h11.58c1.22,0,2.22-.99,2.22-2.22v-3.52c0-1.22-.99-2.22-2.22-2.22h0Z" />
               <path d="M14.37,14.53l1.63-1.84c.12-.13.29-.21.46-.21.09,0,.18.02.26.06.4.19.84.28,1.28.28.7,0,1.39-.24,1.93-.67.78-.63,1.2-1.57,1.15-2.56v-.17s-1.4,1.39-1.4,1.39c-.19.19-.46.3-.74.3s-.55-.11-.74-.3l-1.25-1.25c-.2-.2-.31-.46-.31-.74s.11-.54.31-.74l1.39-1.39h-.16c-.06-.01-.12-.01-.17-.01-.81,0-1.58.32-2.16.9-.91.91-1.15,2.3-.62,3.46.12.25.05.54-.15.72l-3.13,2.77h-1.86s1.06-.95,1.06-.95l-2.02-1.71c-.17.02-.28.05-.4.05-.04,0-.08,0-.11,0-.29-.04-.54-.2-.69-.44l-1.08-1.76c-.29-.46-.22-1.06.17-1.44l.77-.76c.22-.22.52-.35.83-.35.21,0,.43.06.61.17l1.76,1.08c.25.15.41.4.44.69.02.15,0,.3-.05.44l2.19,1.82.33-.21c-.47-1.62-.07-3.31,1.08-4.46.82-.82,1.89-1.26,3.04-1.26.34,0,.68.04,1.02.12.36.09.64.35.75.72.1.36,0,.74-.26,1.01l-1.49,1.49.87.97,1.59-1.49c.2-.19.45-.3.73-.3.09,0,.19.01.28.04.36.1.63.38.72.75.39,1.63-.18,3.31-1.49,4.37-.73.59-1.6.88-2.65.88-.15,0-.3,0-.46-.02-.43-.03-1.19-.27-1.19-.28l-.9.84h-1.14ZM12.09,12.7l.52-.37-2.79-2.48c.09-.08.24-.27.26-.32l-1.41-1.04-.7.62.88,1.53c.16-.02.36-.17.46-.25l2.79,2.32Z" />
            </>
         ),
      },
      'add-to-kit': {
         width: 30,
         height: 30,
         viewBox: [0, 0, 30, 30],
         data: (
            <>
               <rect fill="none" width="30" height="30" rx="5.02" ry="5.02" />
               <path d="M20.82,15.58c.4,0,.72.32.72.72v3.52c0,.4-.32.72-.72.72h-11.58c-.4,0-.72-.32-.72-.72v-3.52c0-.4.32-.72.72-.72h11.58M20.82,14.08h-11.58c-1.22,0-2.22.99-2.22,2.22v3.52c0,1.22.99,2.22,2.22,2.22h11.58c1.22,0,2.22-.99,2.22-2.22v-3.52c0-1.22-.99-2.22-2.22-2.22h0Z" />
               <path d="M14.37,14.53l1.63-1.84c.12-.13.29-.21.46-.21.09,0,.18.02.26.06.4.19.84.28,1.28.28.7,0,1.39-.24,1.93-.67.78-.63,1.2-1.57,1.15-2.56v-.17s-1.4,1.39-1.4,1.39c-.19.19-.46.3-.74.3s-.55-.11-.74-.3l-1.25-1.25c-.2-.2-.31-.46-.31-.74s.11-.54.31-.74l1.39-1.39h-.16c-.06-.01-.12-.01-.17-.01-.81,0-1.58.32-2.16.9-.91.91-1.15,2.3-.62,3.46.12.25.05.54-.15.72l-3.13,2.77h-1.86s1.06-.95,1.06-.95l-2.02-1.71c-.17.02-.28.05-.4.05-.04,0-.08,0-.11,0-.29-.04-.54-.2-.69-.44l-1.08-1.76c-.29-.46-.22-1.06.17-1.44l.77-.76c.22-.22.52-.35.83-.35.21,0,.43.06.61.17l1.76,1.08c.25.15.41.4.44.69.02.15,0,.3-.05.44l2.19,1.82.33-.21c-.47-1.62-.07-3.31,1.08-4.46.82-.82,1.89-1.26,3.04-1.26.34,0,.68.04,1.02.12.36.09.64.35.75.72.1.36,0,.74-.26,1.01l-1.49,1.49.87.97,1.59-1.49c.2-.19.45-.3.73-.3.09,0,.19.01.28.04.36.1.63.38.72.75.39,1.63-.18,3.31-1.49,4.37-.73.59-1.6.88-2.65.88-.15,0-.3,0-.46-.02-.43-.03-1.19-.27-1.19-.28l-.9.84h-1.14ZM12.09,12.7l.52-.37-2.79-2.48c.09-.08.24-.27.26-.32l-1.41-1.04-.7.62.88,1.53c.16-.02.36-.17.46-.25l2.79,2.32Z" />
               <line
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  x1="15.03"
                  y1="16.87"
                  x2="15.03"
                  y2="19.36"
               />
               <line
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  x1="16.27"
                  y1="18.12"
                  x2="13.78"
                  y2="18.12"
               />
            </>
         ),
      },
      'remove-from-kit': {
         width: 30,
         height: 30,
         viewBox: [0, 0, 30, 30],
         data: (
            <>
               <rect
                  fill="none"
                  x="0"
                  width="30"
                  height="30"
                  rx="5.02"
                  ry="5.02"
               />
               <path d="M20.82,15.58c.4,0,.72.32.72.72v3.52c0,.4-.32.72-.72.72h-11.58c-.4,0-.72-.32-.72-.72v-3.52c0-.4.32-.72.72-.72h11.58M20.82,14.08h-11.58c-1.22,0-2.22.99-2.22,2.22v3.52c0,1.22.99,2.22,2.22,2.22h11.58c1.22,0,2.22-.99,2.22-2.22v-3.52c0-1.22-.99-2.22-2.22-2.22h0Z" />
               <path d="M14.37,14.53l1.63-1.84c.12-.13.29-.21.46-.21.09,0,.18.02.26.06.4.19.84.28,1.28.28.7,0,1.39-.24,1.93-.67.78-.63,1.2-1.57,1.15-2.56v-.17s-1.4,1.39-1.4,1.39c-.19.19-.46.3-.74.3s-.55-.11-.74-.3l-1.25-1.25c-.2-.2-.31-.46-.31-.74s.11-.54.31-.74l1.39-1.39h-.16c-.06-.01-.12-.01-.17-.01-.81,0-1.58.32-2.16.9-.91.91-1.15,2.3-.62,3.46.12.25.05.54-.15.72l-3.13,2.77h-1.86s1.06-.95,1.06-.95l-2.02-1.71c-.17.02-.28.05-.4.05-.04,0-.08,0-.11,0-.29-.04-.54-.2-.69-.44l-1.08-1.76c-.29-.46-.22-1.06.17-1.44l.77-.76c.22-.22.52-.35.83-.35.21,0,.43.06.61.17l1.76,1.08c.25.15.41.4.44.69.02.15,0,.3-.05.44l2.19,1.82.33-.21c-.47-1.62-.07-3.31,1.08-4.46.82-.82,1.89-1.26,3.04-1.26.34,0,.68.04,1.02.12.36.09.64.35.75.72.1.36,0,.74-.26,1.01l-1.49,1.49.87.97,1.59-1.49c.2-.19.45-.3.73-.3.09,0,.19.01.28.04.36.1.63.38.72.75.39,1.63-.18,3.31-1.49,4.37-.73.59-1.6.88-2.65.88-.15,0-.3,0-.46-.02-.43-.03-1.19-.27-1.19-.28l-.9.84h-1.14ZM12.09,12.7l.52-.37-2.79-2.48c.09-.08.24-.27.26-.32l-1.41-1.04-.7.62.88,1.53c.16-.02.36-.17.46-.25l2.79,2.32Z" />
               <line
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  x1="16.27"
                  y1="18.12"
                  x2="13.78"
                  y2="18.12"
               />
            </>
         ),
      },
      'location-tracking': {
         width: 25,
         height: 25,
         viewBox: [-4, -5, 25, 25],
         data: (
            <path
               style={{
                  stroke: '#000',
                  strokeWidth: 0.5,
               }}
               fillRule="evenodd"
               clipRule="evenodd"
               d="M9.58927 0.153375C10.0329 -0.0511249 10.5385 -0.0511249 10.9821 0.153375L14.9821 2.01841C15.601 2.30381 16 2.94011 16 3.64254V11.7099C16 12.9957 14.7232 13.8559 13.5893 13.3335L10.5178 11.9185C10.37 11.8507 10.2014 11.8507 10.0536 11.9185L5.8677 13.8468C5.39951 14.0627 4.86324 14.0496 4.40512 13.8126L0.947545 12.0211C0.366629 11.7197 0 11.1045 0 10.4318V2.42011C0 1.09965 1.34096 0.240658 2.481 0.830838L4.91572 2.09319C5.06862 2.17237 5.24775 2.17635 5.40345 2.10458L9.58927 0.153375ZM10.8571 1.39181V10.7848C10.899 10.8002 10.9408 10.8173 10.9821 10.8361L14.0536 12.2511C14.4314 12.4254 14.8571 12.1389 14.8571 11.7099V3.64253C14.8571 3.4084 14.7243 3.19593 14.5179 3.10137L10.8571 1.39181ZM9.71427 10.7848V1.39181L5.8677 3.18685C5.81747 3.2102 5.76613 3.23071 5.71424 3.24837V12.6214L9.58925 10.8361C9.63054 10.8173 9.67242 10.8002 9.71427 10.7848ZM4.40512 3.15199C4.45925 3.18047 4.51506 3.20554 4.57142 3.22719V12.5747L1.4587 10.9615C1.26506 10.8612 1.14286 10.6562 1.14286 10.4317V2.42004C1.14286 1.9797 1.58985 1.69372 1.96987 1.89026L4.40512 3.15199Z"
               fill="#000000"
            />
         ),
      },
      bluetooth: {
         width: 25,
         height: 25,
         viewBox: [-4, -5, 25, 25],
         fill: '#00B4D7',
         data: (
            <g>
               <path d="M4.49057 14.9998C4.12257 14.9998 3.82863 14.7058 3.82863 14.3378V9.04382L1.13299 11.7395C0.863731 12.0087 0.446364 12.0087 0.201769 11.7395C-0.0435533 11.4702 -0.0674882 11.0528 0.201769 10.8082L3.85327 7.15674V0.662159C3.85327 0.392901 4.02455 0.14756 4.26989 0.0495798C4.51521 -0.0484038 4.80917 0.000214505 4.98045 0.196928L8.36273 3.57921C8.4854 3.70188 8.55869 3.87317 8.55869 4.04519C8.55869 4.21648 8.48539 4.38852 8.36273 4.51118L5.17633 7.69758V14.291C5.1524 14.6814 4.85769 15 4.49045 15L4.49057 14.9998ZM5.15251 2.27906V5.85742L6.94165 4.06828L5.15251 2.27906Z" />
               <path d="M4.49069 14.9997C4.41739 14.9997 4.3194 14.9751 4.24536 14.9504C4.00004 14.8524 3.82874 14.6071 3.82874 14.3378V7.81852L0.201943 4.19096C-0.0673144 3.9217 -0.0673144 3.50433 0.201943 3.25974C0.471201 3.01441 0.888567 2.99048 1.13316 3.25974L3.8288 5.95538V0.661942C3.8288 0.293939 4.12276 0 4.49074 0C4.85873 0 5.15269 0.293958 5.15269 0.661942V7.25533L8.33909 10.4417C8.46175 10.5644 8.53504 10.7357 8.53504 10.9077C8.53504 11.079 8.46174 11.251 8.33909 11.3737L4.9568 14.8038C4.83414 14.9265 4.66196 14.9997 4.49069 14.9997ZM5.15263 9.14164V12.72L6.94177 10.9309L5.15263 9.14164Z" />
            </g>
         ),
      },
      gps: {
         width: 25,
         height: 25,
         viewBox: [-4, -5, 25, 25],
         fill: '#8054FF',
         data: (
            <g>
               <path d="M0.0621948 8.06833C0.0621948 8.34849 0.174258 8.61484 0.377918 8.81798C0.585927 9.02548 0.871973 9.14394 1.16262 9.14266C3.30975 9.13627 5.31897 8.31574 6.83158 6.83332L6.83261 6.8323L6.83363 6.83128C8.31605 5.31867 9.13657 3.30945 9.14297 1.16232C9.14399 0.871668 9.02553 0.585622 8.81829 0.377613C8.61514 0.173953 8.34905 0.0618896 8.06864 0.0618896C7.44691 0.0624014 6.99559 0.513983 6.99559 1.13545C6.99584 2.69539 6.41608 4.13995 5.32051 5.31995C4.14025 6.41551 2.69596 6.99528 1.13601 6.99502C0.514544 6.99502 0.0629626 7.44635 0.0624509 8.06808L0.0621948 8.06833Z" />
               <path d="M4.09126 4.09128L4.09229 4.09026C4.89925 3.26948 5.34648 2.20461 5.34955 1.08551C5.35109 0.543097 4.96833 0.082048 4.45969 0.0127115C4.11173 -0.0348773 3.79038 0.0521132 3.55499 0.257564C3.32856 0.457898 3.20242 0.74599 3.20242 1.07374C3.20217 1.63559 2.98137 2.1693 2.58172 2.58174C2.16903 2.98139 1.63557 3.20219 1.07372 3.20244C0.74597 3.20244 0.457878 3.32858 0.257544 3.55501C0.052349 3.7904 -0.0348975 4.11175 0.0126914 4.45971C0.0820279 4.96835 0.543077 5.35111 1.08549 5.34957C2.20459 5.34625 3.26946 4.89927 4.09024 4.09231L4.09126 4.09128Z" />
               <path d="M10.8526 1.07583C10.8526 3.66994 9.83202 6.11897 7.97938 7.97161L7.97887 7.97213L7.97657 7.97443L7.97554 7.97545L7.97452 7.97647L7.97222 7.97878L7.97171 7.97929C6.11907 9.83193 3.66977 10.8523 1.07593 10.8525C0.454201 10.8525 0.00236157 11.3033 0.00210571 11.9253C0.00210571 12.2042 0.113401 12.4693 0.316294 12.6717C0.526094 12.8812 0.81521 13.0009 1.10995 13.0002C4.27871 12.9912 7.2612 11.7536 9.51399 9.51595L9.51502 9.51492L9.51604 9.5139C11.754 7.26136 12.9913 4.27861 13.0003 1.10986C13.001 0.815118 12.8813 0.526002 12.6717 0.316202C12.4694 0.11331 12.2043 0.00201416 11.9254 0.00201416C11.3034 0.00227001 10.8526 0.454109 10.8526 1.07583Z" />
            </g>
         ),
      },
      cardViewBluetooth: {
         width: 18,
         height: 25,
         viewBox: [-1, -2, 18, 20],
         fill: '#96999b',
         data: (
            <g>
               <path d="M4.49057 14.9998C4.12257 14.9998 3.82863 14.7058 3.82863 14.3378V9.04382L1.13299 11.7395C0.863731 12.0087 0.446364 12.0087 0.201769 11.7395C-0.0435533 11.4702 -0.0674882 11.0528 0.201769 10.8082L3.85327 7.15674V0.662159C3.85327 0.392901 4.02455 0.14756 4.26989 0.0495798C4.51521 -0.0484038 4.80917 0.000214505 4.98045 0.196928L8.36273 3.57921C8.4854 3.70188 8.55869 3.87317 8.55869 4.04519C8.55869 4.21648 8.48539 4.38852 8.36273 4.51118L5.17633 7.69758V14.291C5.1524 14.6814 4.85769 15 4.49045 15L4.49057 14.9998ZM5.15251 2.27906V5.85742L6.94165 4.06828L5.15251 2.27906Z" />
               <path d="M4.49069 14.9997C4.41739 14.9997 4.3194 14.9751 4.24536 14.9504C4.00004 14.8524 3.82874 14.6071 3.82874 14.3378V7.81852L0.201943 4.19096C-0.0673144 3.9217 -0.0673144 3.50433 0.201943 3.25974C0.471201 3.01441 0.888567 2.99048 1.13316 3.25974L3.8288 5.95538V0.661942C3.8288 0.293939 4.12276 0 4.49074 0C4.85873 0 5.15269 0.293958 5.15269 0.661942V7.25533L8.33909 10.4417C8.46175 10.5644 8.53504 10.7357 8.53504 10.9077C8.53504 11.079 8.46174 11.251 8.33909 11.3737L4.9568 14.8038C4.83414 14.9265 4.66196 14.9997 4.49069 14.9997ZM5.15263 9.14164V12.72L6.94177 10.9309L5.15263 9.14164Z" />
            </g>
         ),
      },
      cardViewGps: {
         width: 18,
         height: 25,
         viewBox: [-1, -2, 20, 20],
         fill: '#96999b',
         data: (
            <g>
               <path d="M0.0621948 8.06833C0.0621948 8.34849 0.174258 8.61484 0.377918 8.81798C0.585927 9.02548 0.871973 9.14394 1.16262 9.14266C3.30975 9.13627 5.31897 8.31574 6.83158 6.83332L6.83261 6.8323L6.83363 6.83128C8.31605 5.31867 9.13657 3.30945 9.14297 1.16232C9.14399 0.871668 9.02553 0.585622 8.81829 0.377613C8.61514 0.173953 8.34905 0.0618896 8.06864 0.0618896C7.44691 0.0624014 6.99559 0.513983 6.99559 1.13545C6.99584 2.69539 6.41608 4.13995 5.32051 5.31995C4.14025 6.41551 2.69596 6.99528 1.13601 6.99502C0.514544 6.99502 0.0629626 7.44635 0.0624509 8.06808L0.0621948 8.06833Z" />
               <path d="M4.09126 4.09128L4.09229 4.09026C4.89925 3.26948 5.34648 2.20461 5.34955 1.08551C5.35109 0.543097 4.96833 0.082048 4.45969 0.0127115C4.11173 -0.0348773 3.79038 0.0521132 3.55499 0.257564C3.32856 0.457898 3.20242 0.74599 3.20242 1.07374C3.20217 1.63559 2.98137 2.1693 2.58172 2.58174C2.16903 2.98139 1.63557 3.20219 1.07372 3.20244C0.74597 3.20244 0.457878 3.32858 0.257544 3.55501C0.052349 3.7904 -0.0348975 4.11175 0.0126914 4.45971C0.0820279 4.96835 0.543077 5.35111 1.08549 5.34957C2.20459 5.34625 3.26946 4.89927 4.09024 4.09231L4.09126 4.09128Z" />
               <path d="M10.8526 1.07583C10.8526 3.66994 9.83202 6.11897 7.97938 7.97161L7.97887 7.97213L7.97657 7.97443L7.97554 7.97545L7.97452 7.97647L7.97222 7.97878L7.97171 7.97929C6.11907 9.83193 3.66977 10.8523 1.07593 10.8525C0.454201 10.8525 0.00236157 11.3033 0.00210571 11.9253C0.00210571 12.2042 0.113401 12.4693 0.316294 12.6717C0.526094 12.8812 0.81521 13.0009 1.10995 13.0002C4.27871 12.9912 7.2612 11.7536 9.51399 9.51595L9.51502 9.51492L9.51604 9.5139C11.754 7.26136 12.9913 4.27861 13.0003 1.10986C13.001 0.815118 12.8813 0.526002 12.6717 0.316202C12.4694 0.11331 12.2043 0.00201416 11.9254 0.00201416C11.3034 0.00227001 10.8526 0.454109 10.8526 1.07583Z" />
            </g>
         ),
      },
      cardViewAssignedToKit: {
         width: 23,
         height: 25,
         viewBox: [-1, 0, 8, 10],
         fill: '#96999b',
         data: (
            <g>
               <path
                  d="M2.16721 1.35241C2.36447 1.6773 2.36839 2.05787 2.21292 2.37368L3.2 4H2.6535L2.77606 3.9328L1.82925 2.37286C2.01881 2.12817 2.04988 1.79021 1.87985 1.51017C1.76522 1.32138 1.57822 1.1919 1.36766 1.1404L1.30969 1.1283L1.26063 1.12135L1.6754 1.80458L0.813367 2.27784L0.398552 1.59463L0.380419 1.63833C0.31432 1.81402 0.314783 2.00925 0.387207 2.18788L0.414021 2.24676L0.44306 2.29897C0.602521 2.56161 0.896827 2.70405 1.19481 2.6929L1.25441 2.68861L2.0506 4H1.66736L1.06336 3.00504C0.697857 2.97528 0.353032 2.78174 0.155702 2.45673C-0.0815779 2.06593 -0.0427666 1.58354 0.238743 1.23356L0.278632 1.18668L0.431106 1.01714L0.934482 1.8469L1.22213 1.68898L0.718785 0.859264L0.949449 0.81855C1.42931 0.73385 1.91922 0.943971 2.16721 1.35241Z"
                  fill="#97999B"
               />
               <path
                  d="M3.25915 0L4.40128 0.694867L4.31848 0.845305C4.48965 0.823354 4.66875 0.857598 4.82957 0.955442C4.99027 1.05321 5.1079 1.19938 5.17547 1.36639L5.25787 1.21602L6.39999 1.91088L5.57574 3.41531L4.57654 2.807L3.92289 4H3.54208L4.51871 2.21777L4.53438 2.21403L4.54993 2.20976L4.95777 2.45724L4.88387 2.59281L5.45493 2.94024L5.94949 2.03759L5.37842 1.69015L5.28747 1.85547L4.90541 1.62276C4.88205 1.47423 4.79811 1.33748 4.66472 1.25633C4.54615 1.18419 4.41102 1.16967 4.28852 1.20453L4.24324 1.21989L3.8601 0.98706L3.95077 0.821569L3.37971 0.474136L2.88515 1.37679L3.45622 1.72423L3.5304 1.58883L3.93856 1.8378L3.94276 1.85391L3.94745 1.86987L2.8131 3.94103L2.91004 4H2.39999L3.43425 2.11244L2.4349 1.50443L3.25915 0Z"
                  fill="#97999B"
               />
               <path d="M6.4 4V8H0V4H6.4ZM5.76 4.66667H0.64V7.33333H5.76V4.66667Z" />
            </g>
         ),
      },
      cardViewBarcode: {
         width: 22,
         height: 25,
         viewBox: [-1, -1.5, 10, 10],
         fill: '#96999b',
         data: (
            <g>
               <path d="M0 0H0.924723V6H0V0ZM5.83039 0H6.48643V6H5.83039V0ZM7.03059 0H8V6H7.03059V0ZM2.66914 0H4.0855V6H2.66914V0ZM4.62996 0H5.286V6H4.62996V0ZM1.46863 0H2.12467V6H1.46863V0Z" />
            </g>
         ),
      },
      cardViewCategory: {
         width: 22,
         height: 25,
         viewBox: [-1, -2, 10, 10],
         fill: '#96999b',
         data: (
            <g>
               <path d="M5.91044 5H1.07683C0.482981 5 0 4.50694 0 3.90132V1.09868C0 0.492782 0.483251 0 1.07683 0H5.91014L8 2.49996L5.91044 5ZM1.07683 0.668657C0.844488 0.668657 0.655306 0.861678 0.655306 1.09873V3.90137C0.655306 4.13843 0.844488 4.33145 1.07683 4.33145H5.60785L7.13877 2.50007L5.60785 0.668687L1.07683 0.668657Z" />
            </g>
         ),
      },
      cardViewSerialNumber: {
         width: 22,
         height: 25,
         viewBox: [0, -2.5, 10, 10],
         fill: '#fff',
         data: (
            <g>
               <rect
                  x="0.300031"
                  y="0.3"
                  width="8.4"
                  height="4.4"
                  rx="0.7"
                  stroke="#97999B"
                  strokeWidth="0.6"
               />
               <path d="M7.49997 3.5L1.29997 3.5" stroke="#97999B" />
            </g>
         ),
      },
      cardViewText: {
         width: 22,
         height: 25,
         viewBox: [-1, -3, 10, 10],
         fill: '#fff',
         data: (
            <g>
               <rect
                  x="0.3"
                  y="0.3"
                  width="7.4"
                  height="4.4"
                  rx="0.7"
                  stroke="#97999B"
                  strokeWidth="0.6"
               />
               <line
                  x1="1.3"
                  y1="1.3"
                  x2="1.3"
                  y2="3.7"
                  stroke="#97999B"
                  strokeWidth="0.6"
               />
            </g>
         ),
      },
      makeUnavailable: {
         width: 30,
         height: 30,
         viewBox: [0, 0, 30, 30],
         data: (
            <>
               <rect fill="none" width="30" height="30" rx="5.02" ry="5.02" />
               <path
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5px"
                  fillRule="evenodd"
                  d="M17.26,21.42h-8.21c-.68,0-1.23-.55-1.23-1.23v-8.43c0-.43.23-.83.6-1.05l6.52-3.9,6.5,3.71c.38.22.62.63.62,1.07v.66"
               />
               <path
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5px"
                  fillRule="evenodd"
                  d="M16.37,21.42h-5.36v-7.97c0-.24.19-.43.43-.43h6.02"
               />
               <line
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5px"
                  x1="11.02"
                  y1="15.79"
                  x2="15.23"
                  y2="15.79"
               />
               <line
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5px"
                  x1="11.05"
                  y1="18.61"
                  x2="15.26"
                  y2="18.61"
               />
               <circle
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5px"
                  cx="20.24"
                  cy="17.22"
                  r="4.97"
               />
               <line
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5px"
                  x1="21.72"
                  y1="15.74"
                  x2="18.76"
                  y2="18.7"
               />
               <line
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5px"
                  x1="21.72"
                  y1="18.7"
                  x2="18.76"
                  y2="15.74"
               />
            </>
         ),
      },
      makeAvailable: {
         width: 30,
         height: 30,
         viewBox: [0, 0, 30, 30],
         data: (
            <>
               <rect fill="none" width="30" height="30" rx="5.02" ry="5.02" />
               <path
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5px"
                  fillRule="evenodd"
                  d="M17.26,21.42h-8.21c-.68,0-1.23-.55-1.23-1.23v-8.43c0-.43.23-.83.6-1.05l6.52-3.9,6.5,3.71c.38.22.62.63.62,1.07v.66"
               />
               <path
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5px"
                  fillRule="evenodd"
                  d="M16.37,21.42h-5.36v-7.97c0-.24.19-.43.43-.43h6.02"
               />
               <line
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5px"
                  x1="11.02"
                  y1="15.79"
                  x2="15.23"
                  y2="15.79"
               />
               <line
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5px"
                  x1="11.05"
                  y1="18.61"
                  x2="15.26"
                  y2="18.61"
               />
               <circle
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5px"
                  cx="20.24"
                  cy="17.22"
                  r="4.97"
               />
               <line
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5px"
                  x1="22.33"
                  y1="17.22"
                  x2="18.14"
                  y2="17.22"
               />
               <line
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5px"
                  x1="20.24"
                  y1="19.31"
                  x2="20.24"
                  y2="15.12"
               />
            </>
         ),
      },
      images: {
         width: 30,
         height: 26,
         viewBox: [0, 0, 26, 26],
         data: (
            <>
               <g clipPath="url(#clip0_2386_11981)">
                  <path
                     fillRule="evenodd"
                     clipRule="evenodd"
                     d="M17.2458 7.69992C17.3644 7.72436 17.4634 7.80575 17.5102 7.91767C17.5572 8.02932 17.5456 8.157 17.4794 8.25867L16.7307 9.41329C16.6692 9.50805 16.6481 9.62119 16.6717 9.7319C16.6953 9.84262 16.7607 9.9371 16.8555 9.99879C17.0455 10.1218 17.3178 10.0638 17.4409 9.87402L18.19 8.71958C18.2561 8.61768 18.3676 8.5558 18.4888 8.55246C18.6101 8.54958 18.7247 8.60679 18.7954 8.70511C19.4086 9.56025 19.4357 10.6823 18.864 11.5637C18.3752 12.3173 17.5474 12.7435 16.6729 12.7186L17.6051 13.3225L18.5526 13.2038C18.6419 13.1927 18.732 13.2134 18.8075 13.2623L20.7786 14.5408C21.2812 14.8666 21.4248 15.5406 21.099 16.0431L20.1479 17.509C19.9901 17.7525 19.7468 17.9199 19.4631 17.9804C19.1791 18.0409 18.8887 17.9872 18.6451 17.8293L16.6743 16.551C16.5988 16.5018 16.5431 16.4279 16.5169 16.3419L16.2389 15.4284L15.3074 14.8237C15.6863 15.6119 15.635 16.5417 15.146 17.2953C14.7712 17.8734 14.1963 18.2587 13.5542 18.3955C13.2175 18.4673 12.8627 18.4707 12.5081 18.3981C12.3893 18.3739 12.2903 18.2926 12.2438 18.1806C12.1968 18.0689 12.2084 17.9413 12.2743 17.8396L13.0233 16.685C13.1503 16.4891 13.0943 16.2265 12.8982 16.0993C12.7029 15.9724 12.4397 16.028 12.3127 16.2241L11.5638 17.3787C11.4981 17.4803 11.3867 17.5431 11.2649 17.5458C11.1439 17.5487 11.0292 17.4915 10.9585 17.3929C10.3453 16.5378 10.3182 15.4157 10.8899 14.5343C11.4152 13.7251 12.3311 13.2937 13.2759 13.3925L13.7162 12.7136L12.1633 11.7062C12.101 11.6658 12.0557 11.6089 12.0297 11.5448L11.1855 11.713C11.0772 11.7346 10.9656 11.7005 10.8878 11.622L9.73579 10.4596C9.62715 10.35 9.60963 10.1792 9.69357 10.0495L10.0247 9.53897C10.1089 9.40945 10.2718 9.35585 10.4162 9.41035L11.9477 9.98848C12.0508 10.0274 12.1273 10.1157 12.1519 10.2231L12.3425 11.0625C12.4116 11.0602 12.4821 11.0783 12.5445 11.1189L14.0974 12.1259L14.5378 11.447C14.0625 10.6248 14.0827 9.61238 14.6075 8.80301C15.1796 7.92154 16.2148 7.48886 17.2458 7.69992ZM16.1608 13.295L15.6249 14.1209L16.7709 14.8642C16.8464 14.9131 16.9023 14.987 16.9283 15.0731L17.2062 15.9865L19.0604 17.1891C19.2056 17.2831 19.4137 17.239 19.5077 17.0938L20.4589 15.6279C20.5556 15.4785 20.5129 15.2779 20.3635 15.1806L18.5092 13.9783L17.5617 14.097C17.4724 14.1079 17.382 14.0872 17.3067 14.0382L16.1608 13.295ZM14.3308 13.1123L13.7618 13.99C13.6797 14.1166 13.5287 14.1798 13.3809 14.1495C12.6473 13.9991 11.9115 14.3069 11.5051 14.9332C11.2069 15.393 11.138 15.9449 11.2948 16.4467L11.6978 15.8252C12.0449 15.2903 12.7621 15.1375 13.2973 15.4843C13.8324 15.8316 13.9853 16.5491 13.6382 17.0839L13.235 17.7054C13.7561 17.6438 14.233 17.3559 14.5313 16.8964C14.9374 16.2699 14.9184 15.4721 14.4821 14.864C14.3942 14.7414 14.3903 14.5775 14.4724 14.4509L15.0414 13.5732L14.3308 13.1123ZM15.2227 9.20187C14.8163 9.82836 14.8357 10.6259 15.2721 11.2342C15.3598 11.3568 15.3637 11.5208 15.2816 11.6474L14.712 12.5246L15.4226 12.9855L15.9918 12.1081C16.074 11.9817 16.2253 11.9185 16.373 11.9485C17.1058 12.0989 17.8422 11.7914 18.2488 11.1648C18.5471 10.7053 18.6159 10.1531 18.4591 9.65137L18.0561 10.2729C17.8879 10.5321 17.6288 10.7102 17.3268 10.7746C17.0248 10.8389 16.7156 10.782 16.4566 10.6137C16.1976 10.4457 16.0193 10.1867 15.9549 9.88466C15.8906 9.58263 15.9477 9.27339 16.1157 9.01439L16.5189 8.39283C15.9958 8.45485 15.5209 8.74209 15.2227 9.20187ZM10.4318 10.1185L10.3887 10.185L11.2302 11.0342L11.6435 10.9517L11.5504 10.5407L10.4318 10.1185Z"
                  />
               </g>
               <path d="M27.9093 3.60162L27.3072 3.50774L27.1942 2.43862C27.075 1.31316 26.0586 0.50643 24.936 0.625254L15.4824 1.63827L5.2883 0.0250394C4.16539 -0.150136 3.11787 0.612592 2.93591 1.72573L2.73513 3.00759L2.15806 3.0701C1.02898 3.18894 0.219637 4.202 0.338844 5.32101L1.16059 12.9059L0.0252705 20.0594C-0.150471 21.1724 0.608774 22.2228 1.73146 22.398L2.19573 22.4731L2.34 23.7799C2.45922 24.8992 3.47555 25.7121 4.59817 25.5933L14.9169 24.4866L24.3518 25.9748C25.4684 26.15 26.5222 25.3932 26.698 24.2741L26.8673 23.1985L27.3692 23.1422C28.4921 23.0234 29.3077 22.0103 29.1884 20.8913L28.398 13.5878L29.6148 5.94076C29.7908 4.82744 29.0255 3.77708 27.9089 3.60192L27.9093 3.60162ZM4.83064 22.9915L2.94232 5.55837L24.6972 3.21971L26.5853 20.6587L4.83064 22.9915Z" />
               <defs>
                  <clipPath id="clip0_2386_11981">
                     <rect
                        width="10.7322"
                        height="10.7322"
                        transform="translate(9 9.23694) rotate(-12.0302)"
                     />
                  </clipPath>
               </defs>
            </>
         ),
      },
      view: {
         width: 32,
         height: 32,
         viewBox: [0, 0, 32, 32],
         data: (
            <g>
               <path
                  xmlns="http://www.w3.org/2000/svg"
                  d="M16.108 10.044c-3.313 0-6 2.687-6 6s2.687 6 6 6 6-2.686 6-6-2.686-6-6-6zM16.108 20.044c-2.206 0-4.046-1.838-4.046-4.044s1.794-4 4-4c2.206 0 4 1.794 4 4s-1.748 4.044-3.954 4.044zM31.99 15.768c-0.012-0.050-0.006-0.104-0.021-0.153-0.006-0.021-0.020-0.033-0.027-0.051-0.011-0.028-0.008-0.062-0.023-0.089-2.909-6.66-9.177-10.492-15.857-10.492s-13.074 3.826-15.984 10.486c-0.012 0.028-0.010 0.057-0.021 0.089-0.007 0.020-0.021 0.030-0.028 0.049-0.015 0.050-0.009 0.103-0.019 0.154-0.018 0.090-0.035 0.178-0.035 0.269s0.017 0.177 0.035 0.268c0.010 0.050 0.003 0.105 0.019 0.152 0.006 0.023 0.021 0.032 0.028 0.052 0.010 0.027 0.008 0.061 0.021 0.089 2.91 6.658 9.242 10.428 15.922 10.428s13.011-3.762 15.92-10.422c0.015-0.029 0.012-0.058 0.023-0.090 0.007-0.017 0.020-0.030 0.026-0.050 0.015-0.049 0.011-0.102 0.021-0.154 0.018-0.090 0.034-0.177 0.034-0.27 0-0.088-0.017-0.175-0.035-0.266zM16 25.019c-5.665 0-11.242-2.986-13.982-8.99 2.714-5.983 8.365-9.047 14.044-9.047 5.678 0 11.203 3.067 13.918 9.053-2.713 5.982-8.301 8.984-13.981 8.984z"
               />
            </g>
         ),
      },
      imageMatch: {
         width: 24,
         height: 24,
         viewBox: [0, 0, 28, 28],
         data: (
            <>
               <path d="M16.48,11.59c1.29-4.79-3.51-6.08-3.51-6.08,4.84,1.3,6.08-3.51,6.08-3.51-1.28,4.76,3.51,6.08,3.51,6.08-4.79-1.29-6.08,3.51-6.08,3.51Z" />
               <path d="M17.43,16.17c.83-3.1-2.27-3.94-2.27-3.94,3.14.84,3.94-2.27,3.94-2.27-.83,3.09,2.27,3.94,2.27,3.94-3.1-.83-3.94,2.27-3.94,2.27Z" />
               <path d="M21.99,14.46c1.03-3.82-2.8-4.85-2.8-4.85,3.86,1.04,4.85-2.8,4.85-2.8-1.02,3.8,2.8,4.85,2.8,4.85-3.82-1.03-4.85,2.8-4.85,2.8Z" />
               <path d="M18.82,27.92H5.77c-1.99,0-3.61-1.64-3.61-3.67v-13.57c0-2.02,1.62-3.66,3.61-3.66h7.54c.55,0,1,.45,1,1s-.45,1-1,1h-7.54c-.89,0-1.61.75-1.61,1.66v10.88l6.15-6.09c.68-.67,1.74-.72,2.47-.1l3.88,3.27,2.79-2.23c.55-.44,1.3-.53,1.94-.22.64.31,1.04.94,1.04,1.65v6.41c0,2.02-1.62,3.67-3.61,3.67ZM4.17,24.37c.06.87.75,1.55,1.6,1.55h13.05c.89,0,1.61-.75,1.61-1.67v-6.06l-2.62,2.1c-.68.54-1.66.53-2.33-.03l-3.87-3.26-7.32,7.26s-.08.07-.12.1Z" />
            </>
         ),
      },
      matchedImage: {
         width: 18,
         height: 19,
         viewBox: [0, 0, 25, 25],
         data: (
            <>
               <path d="M8.78,19.54c2.34-8.7-6.36-11.04-6.36-11.04,8.79,2.36,11.04-6.36,11.04-6.36-2.32,8.65,6.36,11.04,6.36,11.04-8.7-2.34-11.04,6.36-11.04,6.36Z" />
               <path d="M10.51,27.86c1.51-5.64-4.12-7.15-4.12-7.15,5.69,1.53,7.15-4.12,7.15-4.12-1.5,5.6,4.12,7.15,4.12,7.15-5.64-1.51-7.15,4.12-7.15,4.12Z" />
               <path d="M18.78,24.75c1.86-6.94-5.07-8.8-5.07-8.8,7.01,1.88,8.8-5.07,8.8-5.07-1.85,6.9,5.07,8.8,5.07,8.8-6.94-1.86-8.8,5.07-8.8,5.07Z" />
            </>
         ),
      },
      users: {
         width: 30,
         height: 30,
         viewBox: [0, 0, 26, 26],
         data: (
            <>
               <path
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M14.57,18.73c-1.05-1.24-2.31-1.73-4.1-1.73-3.16,0-5.73,2.26-5.73,5.06"
               />
               <ellipse
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  cx="10.46"
                  cy="13.54"
                  rx="3.15"
                  ry="3.46"
               />
               <path
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M25.27,22.06c0-3.29-2.57-5.96-5.73-5.96s-5.73,2.67-5.73,5.96"
               />
               <ellipse
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  cx="19.54"
                  cy="11.46"
                  rx="3.15"
                  ry="3.52"
               />
               <line
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  x1="4.73"
                  y1="22.06"
                  x2="25.27"
                  y2="22.06"
               />
            </>
         ),
      },
      'images-nav': {
         width: 30,
         height: 30,
         viewBox: [0, 0, 28, 28],
         data: (
            <>
               <path
                  stroke="none"
                  d="M17.74,11.62c1.29-4.81-3.52-6.1-3.52-6.1,4.86,1.3,6.1-3.52,6.1-3.52-1.28,4.78,3.52,6.1,3.52,6.1-4.81-1.29-6.1,3.52-6.1,3.52Z"
               />
               <path
                  stroke="none"
                  d="M18.7,16.21c.84-3.11-2.28-3.95-2.28-3.95,3.15.84,3.95-2.28,3.95-2.28-.83,3.1,2.28,3.95,2.28,3.95-3.11-.84-3.95,2.28-3.95,2.28Z"
               />
               <path
                  stroke="none"
                  d="M23.27,14.49c1.03-3.83-2.8-4.86-2.8-4.86,3.87,1.04,4.86-2.8,4.86-2.8-1.02,3.81,2.8,4.86,2.8,4.86-3.83-1.03-4.86,2.8-4.86,2.8Z"
               />
               <path
                  stroke="none"
                  d="M20.09,28H7c-1.99,0-3.62-1.65-3.62-3.68v-13.61c0-2.03,1.62-3.68,3.62-3.68h7.56c.55,0,1,.45,1,1s-.45,1-1,1h-7.56c-.89,0-1.61.75-1.61,1.67v10.92l6.17-6.11c.68-.67,1.75-.72,2.48-.1l3.89,3.28,2.79-2.24c.56-.45,1.3-.53,1.94-.22.64.31,1.04.94,1.04,1.66v6.43c0,2.03-1.62,3.68-3.62,3.68ZM5.39,24.44c.06.87.76,1.56,1.61,1.56h13.09c.89,0,1.61-.75,1.61-1.67v-6.08l-2.63,2.11c-.68.55-1.67.53-2.33-.03l-3.88-3.27-7.35,7.28s-.08.07-.12.1Z"
               />
            </>
         ),
      },
      reminders: {
         width: 20,
         height: 25,
         viewBox: [0, 0, 25, 25],
         fill: 'none',
         data: (
            <path
               fillRule="evenodd"
               clipRule="evenodd"
               d="M10.0093 1.92234C6.47978 1.92234 3.79664 4.50794 3.79664 7.45867V16.1572C3.79664 16.3206 3.75678 16.4812 3.68082 16.624L3.58992 16.7949L3.58878 16.797L2.43794 18.9735H17.5715L16.4207 16.797L16.4195 16.7949L16.3286 16.624C16.2527 16.4812 16.2128 16.3206 16.2128 16.1572V15.965C16.2128 15.9187 16.216 15.8731 16.222 15.8286V7.45867C16.222 4.50794 13.5389 1.92234 10.0093 1.92234ZM18.0628 15.9259V7.45867C18.0628 3.20063 14.3032 0 10.0093 0C5.7155 0 1.95585 3.20063 1.95585 7.45867V15.9084L0.136749 19.3487C0.0468072 19.5096 0 19.6919 0 19.8758C0 20.0393 0.0396332 20.267 0.185551 20.4759C0.245178 20.5646 0.326562 20.6556 0.436298 20.732C0.518002 20.7889 0.606489 20.8312 0.698145 20.8585C0.743309 20.872 0.78764 20.8814 0.830517 20.8873C0.851907 20.8903 0.872828 20.8924 0.893209 20.8938C0.903396 20.8945 0.913443 20.895 0.92334 20.8953L0.938071 20.8957L0.94535 20.8958L0.948968 20.8958L0.950771 20.8958C0.950734 20.8959 0.950808 20.8958 0.950771 20.8958C0.951334 20.8958 0.952007 20.8958 0.95257 20.8958L19.0569 20.8958C19.1997 20.8958 19.3407 20.8611 19.4685 20.7943L19.0569 19.9346C19.4685 20.7943 19.4683 20.7944 19.4685 20.7943L19.4698 20.7937L19.4711 20.793L19.4738 20.7915L19.4795 20.7885L19.4923 20.7815C19.5012 20.7764 19.5118 20.7704 19.5235 20.7632C19.545 20.7501 19.5792 20.7282 19.6183 20.6976C19.6521 20.6711 19.7218 20.6134 19.7911 20.5229C19.8385 20.461 19.9416 20.3118 19.9804 20.091C20.0078 19.9433 19.999 19.8244 19.9973 19.8005C19.9972 19.7992 19.9971 19.7981 19.9971 19.7974C19.9949 19.7641 19.9919 19.7359 19.9895 19.7161C19.9882 19.7059 19.987 19.6969 19.9859 19.6894L19.9844 19.6791L19.9837 19.6748L19.9833 19.6718C19.9833 19.6717 19.9831 19.6709 19.0753 19.8289L19.9833 19.6718C19.9661 19.5643 19.9314 19.4597 19.881 19.3643L18.0628 15.9259ZM6.80635 24.0388C6.80635 23.508 7.21842 23.0777 7.72675 23.0777H12.2735C12.7818 23.0777 13.1939 23.508 13.1939 24.0388C13.1939 24.5697 12.7818 25 12.2735 25H7.72675C7.21842 25 6.80635 24.5697 6.80635 24.0388Z"
               fill="black"
               stroke="none"
            />
         ),
      },
      list: {
         width: 20,
         height: 20,
         viewBox: [0, 0, 20, 20],
         fill: 'none',
         data: (
            <>
               <path
                  d="M17.1335 3.89339V5.22673H6.46688V3.89339H17.1335ZM17.1335 2.56006H6.46688C5.73354 2.56006 5.13354 3.16006 5.13354 3.89339V5.22673C5.13354 5.96006 5.73354 6.56006 6.46688 6.56006H17.1335C17.8669 6.56006 18.4669 5.96006 18.4669 5.22673V3.89339C18.4669 3.16006 17.8669 2.56006 17.1335 2.56006Z"
                  fill="#6F7680"
                  stroke="none"
               />
               <path
                  d="M2.86646 3.22681V5.89347"
                  stroke="#6F7680"
                  fill="none"
                  strokeWidth="1.06667"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  d="M17.1335 9.27987V10.6132H6.46688V9.27987H17.1335ZM17.1335 7.94653H6.46688C5.73354 7.94653 5.13354 8.54653 5.13354 9.27987V10.6132C5.13354 11.3465 5.73354 11.9465 6.46688 11.9465H17.1335C17.8669 11.9465 18.4669 11.3465 18.4669 10.6132V9.27987C18.4669 8.54653 17.8669 7.94653 17.1335 7.94653Z"
                  fill="#6F7680"
                  stroke="none"
               />
               <path
                  d="M17.1335 14.7733V16.1066H6.46688V14.7733H17.1335ZM17.1335 13.4399H6.46688C5.73354 13.4399 5.13354 14.0399 5.13354 14.7733V16.1066C5.13354 16.8399 5.73354 17.4399 6.46688 17.4399H17.1335C17.8669 17.4399 18.4669 16.8399 18.4669 16.1066V14.7733C18.4669 14.0399 17.8669 13.4399 17.1335 13.4399Z"
                  fill="#6F7680"
                  stroke="none"
               />
               <path
                  d="M2.86646 8.77319V16.7732"
                  stroke="#6F7680"
                  strokeWidth="1.06667"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  fill="none"
               />
            </>
         ),
      },
      'action-tasks': {
         width: 22,
         height: 13,
         viewBox: [0, 0, 22, 13],
         fill: 'none',
         data: (
            <>
               <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M14.1176 0.0747055C14.3696 -0.0495487 14.6694 -0.0169482 14.8897 0.158665L21.7203 5.60366C21.8969 5.74443 22 5.95966 22 6.1875C22 6.41534 21.8969 6.63057 21.7203 6.77134L14.8897 12.2163C14.6694 12.3919 14.3696 12.4245 14.1176 12.3003C13.8656 12.176 13.7056 11.9167 13.7056 11.6325V9.405H7.60685C7.20266 9.405 6.875 9.07257 6.875 8.6625C6.875 8.25243 7.20266 7.92 7.60685 7.92H14.4375C14.8417 7.92 15.1694 8.25243 15.1694 8.6625V10.1048L20.0836 6.1875L15.1694 2.27017V3.7125C15.1694 4.12257 14.8417 4.455 14.4375 4.455H7.60685C7.20266 4.455 6.875 4.12257 6.875 3.7125C6.875 3.30243 7.20266 2.97 7.60685 2.97H13.7056V0.742505C13.7056 0.45826 13.8656 0.19896 14.1176 0.0747055Z"
                  fill="black"
                  stroke="none"
               />
               <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M7.88242 12.3003C7.63044 12.4245 7.33065 12.3919 7.11034 12.2163L0.279699 6.77134C0.10311 6.63057 5.2101e-07 6.41534 5.40928e-07 6.1875C5.60847e-07 5.95965 0.10311 5.74442 0.279699 5.60366L7.11035 0.158664C7.33065 -0.0169484 7.63044 -0.0495498 7.88242 0.0747045C8.13441 0.198959 8.29436 0.458259 8.29436 0.742504L8.29436 2.97L14.3931 2.97C14.7973 2.97 15.125 3.30243 15.125 3.7125C15.125 4.12257 14.7973 4.455 14.3931 4.455L7.5625 4.455C7.15831 4.455 6.83065 4.12257 6.83065 3.7125L6.83065 2.27017L1.91643 6.1875L6.83064 10.1048L6.83064 8.6625C6.83064 8.25243 7.15831 7.92 7.5625 7.92L14.3931 7.92C14.7973 7.92 15.125 8.25243 15.125 8.6625C15.125 9.07257 14.7973 9.405 14.3931 9.405L8.29435 9.405L8.29435 11.6325C8.29435 11.9167 8.1344 12.176 7.88242 12.3003Z"
                  fill="black"
                  stroke="none"
               />
            </>
         ),
      },
      'info-tasks': {
         width: 22,
         height: 22,
         viewBox: [0, 0, 22, 22],
         fill: 'none',
         data: (
            <>
               <path
                  d="M12.3756 8.70407V17.0001H9.89565V8.70407H12.3756ZM12.6316 6.43207C12.6316 6.62941 12.5916 6.81607 12.5116 6.99207C12.4316 7.16274 12.3223 7.31474 12.1836 7.44807C12.045 7.57607 11.8823 7.68007 11.6956 7.76007C11.5143 7.83474 11.3196 7.87207 11.1116 7.87207C10.909 7.87207 10.7196 7.83474 10.5436 7.76007C10.3676 7.68007 10.2103 7.57607 10.0716 7.44807C9.93832 7.31474 9.83165 7.16274 9.75165 6.99207C9.67698 6.81607 9.63965 6.62941 9.63965 6.43207C9.63965 6.22941 9.67698 6.04007 9.75165 5.86407C9.83165 5.68807 9.93832 5.53341 10.0716 5.40007C10.2103 5.26674 10.3676 5.16274 10.5436 5.08807C10.7196 5.01341 10.909 4.97607 11.1116 4.97607C11.3196 4.97607 11.5143 5.01341 11.6956 5.08807C11.8823 5.16274 12.045 5.26674 12.1836 5.40007C12.3223 5.53341 12.4316 5.68807 12.5116 5.86407C12.5916 6.04007 12.6316 6.22941 12.6316 6.43207Z"
                  fill="black"
                  stroke="none"
               />
               <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M11 20C15.9706 20 20 15.9706 20 11C20 6.02944 15.9706 2 11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20ZM11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22Z"
                  fill="black"
                  stroke="none"
               />
            </>
         ),
      },
      'global-tasks': {
         width: 30,
         height: 30,
         viewBox: [0, 0, 30, 30],
         fill: 'none',
         data: (
            <>
               <path
                  d="M15 25C20.5228 25 25 20.5228 25 15C25 9.47715 20.5228 5 15 5C9.47715 5 5 9.47715 5 15C5 20.5228 9.47715 25 15 25Z"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  d="M15.0001 25C17.143 25 18.8801 20.5228 18.8801 15C18.8801 9.47715 17.143 5 15.0001 5C12.8573 5 11.1201 9.47715 11.1201 15C11.1201 20.5228 12.8573 25 15.0001 25Z"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  d="M5 15H25"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  d="M6.5 19.1599H23.5"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  d="M6.5 10.8401H23.5"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
            </>
         ),
      },
      employee: {
         width: 53,
         height: 75,
         viewBox: [0, 0, 53, 75],
         data: (
            <g enableBackground="new">
               <clipPath id="cp0">
                  <path
                     transform="matrix(2.7777777,0,0,-2.7777777,0,75)"
                     d="M 14.75033 18.43878 C 14.75033 15.58673 12.4289 13.26531 9.543367 13.26531 C 6.691326 13.26531 4.369898 15.58673 4.369898 18.43878 C 4.369898 18.57143 4.403061 18.73724 4.403061 18.8699 L 7.155612 17.74235 L 11.79847 17.74235 L 14.71684 19.00255 C 14.75033 18.83673 14.75033 18.63775 14.75033 18.43878 Z M 9.57653 22.88265 C 8.714285 22.88265 8.283163 23.64541 8.283163 24.57398 L 8.283163 26.92857 L 9.57653 26.92857 L 10.86957 26.92857 L 10.86957 24.54082 C 10.86957 23.64541 10.43911 22.88265 9.57653 22.88265 Z M 7.288265 18.73724 L 3.839286 20.1301 L 3.540816 21.125 L 3.872449 21.45663 C 4.104592 24.24235 5.596939 26.16582 7.653061 26.89541 L 7.653061 24.54082 C 7.653061 23.18112 8.448979 22.08673 9.57653 22.08673 C 10.70408 22.08673 11.5 23.21429 11.5 24.54082 L 11.5 26.89541 C 13.55612 26.16582 15.04847 24.24235 15.24745 21.45663 L 15.57908 21.125 L 15.28061 20.1301 L 11.83163 18.73724 L 7.288265 18.73724 Z M 18.62309 3.611152 L 18.62309 .989485 C 18.62309 .446558 18.09596 .006359782 17.44581 .006359782 L 1.748789 .006359782 C 1.098451 .006359782 .5715121 .446558 .5715121 .989485 L .5715121 3.611152 C .5544584 6.92424 3.144889 9.853614 6.941722 10.81482 C 7.0519 10.84298 7.166677 10.85722 7.281837 10.85706 C 7.437811 10.85674 7.592252 10.83178 7.737112 10.78329 C 8.035264 10.68681 8.343379 10.61368 8.657818 10.56472 C 8.762439 10.54679 8.866869 10.53527 8.968999 10.52471 C 9.063082 10.51399 9.153332 10.50743 9.252205 10.49991 L 9.299342 10.49991 C 9.38461 10.49623 9.469304 10.49303 9.553997 10.49303 L 9.597302 10.49303 C 9.697324 10.49303 9.796964 10.49623 9.907142 10.49959 C 9.918639 10.49959 9.952746 10.50215 9.964818 10.50215 C 10.05353 10.50903 10.14264 10.51559 10.2212 10.52471 C 10.33138 10.53591 10.43159 10.54711 10.52759 10.56408 C 10.84663 10.61336 11.15915 10.68745 11.46171 10.78537 C 11.71234 10.86938 11.9898 10.87994 12.24886 10.81546 C 16.03726 9.843213 18.6229 6.920719 18.62309 3.611152 Z "
                     fillRule="evenodd"
                  />
               </clipPath>
               <g clipPath="url(#cp0)">
                  <clipPath id="cp1">
                     <path
                        transform="matrix(2.7777777,0,0,-2.7777777,0,75)"
                        d="M -50 -730 L 325 -730 L 325 227 L -50 227 Z "
                     />
                  </clipPath>
                  <g clipPath="url(#cp1)">
                     <path
                        transform="matrix(2.7777777,0,0,-2.7777777,0,75)"
                        d="M -4.428572 31.92857 L 23.62309 31.92857 L 23.62309 -4.99364 L -4.428572 -4.99364 Z "
                        fill="#6f7680"
                     />
                  </g>
               </g>
            </g>
         ),
      },
      star: {
         width: 15,
         height: 14,
         viewBox: [0, 0, 15, 14],
         fill: 'none',
         data: (
            <path
               d="M6.67328 0.610536C6.9211 0.014696 7.76517 0.0146964 8.013 0.610536L9.37975 3.89661C9.48423 4.1478 9.72045 4.31943 9.99163 4.34117L13.5392 4.62557C14.1825 4.67714 14.4433 5.4799 13.9532 5.89972L11.2503 8.21504C11.0437 8.39202 10.9535 8.66972 11.0166 8.93435L11.8424 12.3962C11.9921 13.0239 11.3093 13.52 10.7585 13.1837L7.7213 11.3285C7.48913 11.1867 7.19714 11.1867 6.96497 11.3285L3.92774 13.1837C3.37702 13.52 2.69415 13.0239 2.84389 12.3962L3.66966 8.93435C3.73278 8.66972 3.64255 8.39202 3.43594 8.21504L0.733055 5.89972C0.242959 5.4799 0.503792 4.67714 1.14705 4.62557L4.69464 4.34117C4.96582 4.31943 5.20205 4.1478 5.30652 3.89661L6.67328 0.610536Z"
               fill="#6F7680"
               stroke="none"
            />
         ),
      },
      expand: {
         width: 14,
         height: 14,
         viewBox: [0, 0, 14, 14],
         fill: 'none',
         data: (
            <>
               <path
                  d="M13.3634 6.36375C13.0121 6.36375 12.7271 6.6485 12.7271 6.99999V12.091C12.7271 12.2598 12.6601 12.4217 12.5407 12.5409C12.4215 12.6603 12.2596 12.7273 12.0909 12.7273H1.90903C1.55777 12.7273 1.27279 12.4423 1.27279 12.0911V1.90922C1.27279 1.55795 1.55778 1.27297 1.90903 1.27297H7.00008C7.35158 1.27297 7.63632 0.987983 7.63632 0.636733C7.63632 0.285228 7.35157 0.000244141 7.00008 0.000244141H1.90903C1.40289 0.000244141 0.917136 0.201488 0.559305 0.559549C0.201244 0.917368 0 1.40311 0 1.90928V12.0911C0 12.5973 0.201244 13.083 0.559305 13.4408C0.917124 13.7989 1.40286 14.0002 1.90903 14.0002H12.0909C12.597 14.0002 13.0828 13.7989 13.4406 13.4408C13.7987 13.083 13.9999 12.5973 13.9999 12.0911V7.00007C13.9999 6.83136 13.9329 6.66944 13.8135 6.55001C13.694 6.43081 13.5324 6.36381 13.3634 6.36381L13.3634 6.36375Z"
                  fill="#6F7680"
               />
               <path
                  d="M10.1826 1.27268H11.8691L7.21086 5.93723C6.96422 6.18556 6.96422 6.58633 7.21086 6.83448C7.4592 7.08136 7.85996 7.08136 8.10811 6.83448L12.7282 2.22723V3.81827C12.7282 3.98698 12.7952 4.1489 12.9147 4.26809C13.0338 4.38753 13.1958 4.45453 13.3645 4.45453C13.5334 4.45453 13.6951 4.38753 13.8145 4.26809C13.934 4.1489 14.001 3.98698 14.001 3.81827V0.636502C14.001 0.467542 13.934 0.305872 13.8145 0.186435C13.6951 0.0669986 13.5334 0 13.3645 0H10.1827C9.83121 0 9.54647 0.284991 9.54647 0.63649C9.54647 0.987752 9.83122 1.27273 10.1827 1.27273L10.1826 1.27268Z"
                  fill="#6F7680"
               />
            </>
         ),
      },
      borrowRequest: {
         width: 30,
         height: 30,
         viewBox: [0, 0, 30, 30],
         fill: 'none',
         data: (
            <>
               <g clipPath="url(#clip0_4395_3731)">
                  <circle cx="15" cy="15" r="15" fill="#FFD600" stroke="none" />
                  <path
                     d="M13.1701 8.20996V15.25H9.86011L15.0001 21.79L20.1401 15.25H16.8601V8.20996"
                     stroke="black"
                     fill="none"
                     strokeWidth="1.5"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                  />
                  <path
                     d="M8.8501 10.8V9.99996C8.8501 9.00996 9.6401 8.20996 10.6001 8.20996H19.3801C20.3501 8.20996 21.1301 9.00996 21.1301 9.99996V10.8"
                     stroke="black"
                     fill="none"
                     strokeWidth="1.5"
                     strokeMiterlimit="10"
                     strokeLinecap="round"
                  />
               </g>
               <defs>
                  <clipPath id="clip0_4395_3731">
                     <rect width="30" height="30" fill="white" stroke="none" />
                  </clipPath>
               </defs>
            </>
         ),
      },
      loanRequest: {
         width: 30,
         height: 30,
         viewBox: [0, 0, 30, 30],
         fill: 'none',
         data: (
            <>
               <g clipPath="url(#clip0_3879_6125)">
                  <circle cx="15" cy="15" r="15" fill="#FFD600" stroke="none" />
                  <path
                     d="M8.54004 16.96H17.07V20.27L23.62 15.13L17.07 9.98999V13.27H8.54004"
                     stroke="black"
                     strokeWidth="1.5"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                     fill="none"
                  />
                  <path
                     d="M10.59 21.28H9.79C8.8 21.28 8 20.49 8 19.53V10.75C8 9.78 8.8 9 9.79 9H10.59"
                     stroke="black"
                     strokeWidth="1.5"
                     strokeMiterlimit="10"
                     strokeLinecap="round"
                     fill="none"
                  />
               </g>
               <defs>
                  <clipPath id="clip0_3879_6125">
                     <rect width="30" height="30" fill="black" stroke="none" />
                  </clipPath>
               </defs>
            </>
         ),
      },
      returnRequest: {
         width: 30,
         height: 30,
         viewBox: [0, 0, 30, 30],
         fill: 'none',
         data: (
            <>
               <g clipPath="url(#clip0_3879_6027)">
                  <circle cx="15" cy="15" r="15" fill="#FFD600" stroke="none" />
                  <path
                     d="M23.4799 13.3H14.9499V9.98999L8.3999 15.13L14.9499 20.27V16.99H23.4799"
                     stroke="black"
                     strokeWidth="1.5"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                     fill="none"
                  />
                  <path
                     d="M8.59 21.28H7.79C6.8 21.28 6 20.49 6 19.53V10.75C6 9.78 6.8 9 7.79 9H8.59"
                     stroke="black"
                     strokeWidth="1.5"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                     fill="none"
                  />
               </g>
               <defs>
                  <clipPath id="clip0_3879_6027">
                     <rect width="30" height="30" fill="white" stroke="none" />
                  </clipPath>
               </defs>
            </>
         ),
      },
      transferRequest: {
         width: 30,
         height: 30,
         viewBox: [0, 0, 30, 30],
         fill: 'none',
         data: (
            <>
               <g clipPath="url(#clip0_4395_8011)">
                  <circle cx="15" cy="15" r="15" fill="#FFD600" stroke="none" />
                  <path
                     d="M14.6099 15.0002H11.2099V12.1802L5.16992 16.9202L11.2099 21.6602V18.8502H14.6099"
                     stroke="black"
                     strokeWidth="1.5"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                  />
                  <path
                     d="M16.22 18.8501H12"
                     stroke="black"
                     strokeWidth="1.5"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                  />
                  <path
                     d="M17.04 15H12"
                     stroke="black"
                     strokeWidth="1.5"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                  />
                  <path
                     d="M15.3899 14.9998H18.7899V17.8198L24.8299 13.0798L18.7899 8.33984V11.1498H15.3899"
                     stroke="black"
                     strokeWidth="1.5"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                  />
                  <path
                     d="M13.8101 11.1499H18.0001"
                     stroke="black"
                     strokeWidth="1.5"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                  />
                  <path
                     d="M12.96 15H18"
                     stroke="black"
                     strokeWidth="1.5"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                  />
               </g>
               <defs>
                  <clipPath id="clip0_4395_8011">
                     <rect width="30" height="30" fill="white" stroke="none" />
                  </clipPath>
               </defs>
            </>
         ),
      },
      taskLocation: {
         width: 9,
         height: 12,
         viewBox: [0, 0, 9, 12],
         fill: 'none',
         data: (
            <path
               d="M4.5 0C6.98528 0 9 1.97589 9 4.41327C9 5.19989 8.66434 6.17236 7.99442 7.34001L7.83389 7.61294C7.75066 7.75114 7.66298 7.89194 7.57085 8.03537L7.38067 8.32573C7.24993 8.52165 7.11128 8.72223 6.96474 8.92753L6.73901 9.23904L6.50143 9.55762L6.25201 9.88333L5.99076 10.2162L5.71768 10.5562C5.62468 10.6707 5.52971 10.7865 5.43277 10.9034L5.13603 11.2579C5.03515 11.3772 4.9323 11.4978 4.82748 11.6196L4.5 12L4.17252 11.6196L3.86397 11.2579L3.56723 10.9034C3.47029 10.7865 3.37532 10.6707 3.28232 10.5562L3.00924 10.2162L2.74799 9.88333L2.49857 9.55762L2.26099 9.23904L2.03526 8.92753C1.88872 8.72223 1.75007 8.52165 1.61933 8.32573L1.42915 8.03537C1.33702 7.89194 1.24934 7.75114 1.16611 7.61294L1.00558 7.34001C0.335657 6.17236 0 5.19989 0 4.41327C0 1.97589 2.01472 0 4.5 0ZM4.5 0.840624C2.48811 0.840624 0.857143 2.44015 0.857143 4.41327C0.857143 5.18543 1.29735 6.26142 2.18003 7.62607L2.36246 7.90284C2.48802 8.08992 2.62145 8.2821 2.76275 8.47936L2.98061 8.77906L3.21028 9.08636C3.28881 9.19005 3.36931 9.29501 3.45178 9.40122L3.70509 9.7236L3.97024 10.0535C4.01541 10.1091 4.06108 10.165 4.10724 10.2213L4.39014 10.5624L4.5 10.6923L4.75586 10.3872L5.03858 10.0426L5.30896 9.70592C5.35299 9.65045 5.39651 9.59531 5.43951 9.54049L5.69137 9.21554L5.93089 8.89847C5.96978 8.84628 6.00815 8.79442 6.04602 8.74289L6.26703 8.4377C6.33865 8.33729 6.40821 8.23821 6.47572 8.14046L6.67208 7.8512C6.73548 7.75612 6.79682 7.66237 6.85612 7.56996L7.02784 7.29676L7.18726 7.03162C7.80029 5.98725 8.11794 5.13726 8.14145 4.48991L8.14286 4.41327C8.14286 2.44015 6.51189 0.840624 4.5 0.840624ZM4.5 2.52187C5.56512 2.52187 6.42857 3.36868 6.42857 4.41327C6.42857 5.45787 5.56512 6.30468 4.5 6.30468C3.43488 6.30468 2.57143 5.45787 2.57143 4.41327C2.57143 3.36868 3.43488 2.52187 4.5 2.52187ZM4.5 3.36249C3.90827 3.36249 3.42857 3.83294 3.42857 4.41327C3.42857 4.9936 3.90827 5.46405 4.5 5.46405C5.09173 5.46405 5.57143 4.9936 5.57143 4.41327C5.57143 3.83294 5.09173 3.36249 4.5 3.36249Z"
               fill="#2E2E30"
               stroke="none"
            />
         ),
      },
      taskWarehouse: {
         width: 12,
         height: 9,
         viewBox: [0, 0, 12, 9],
         fill: 'none',
         data: (
            <path
               d="M6.02659 9C7.89185 9 9.75711 9 11.6188 9C11.9249 9 11.9926 8.93899 11.9961 8.62676C11.9997 8.21764 11.9961 7.80851 11.9961 7.39939C11.9961 7.28454 11.9605 7.2343 11.8431 7.24148C11.7363 7.24866 11.6259 7.25225 11.5191 7.24148C11.3981 7.23071 11.3518 7.27019 11.3554 7.39939C11.3625 7.65419 11.359 7.909 11.3554 8.16022C11.3554 8.39708 11.3376 8.41143 11.1027 8.41502C10.9496 8.41502 10.7965 8.40785 10.6435 8.41502C10.5189 8.4222 10.4833 8.36837 10.4833 8.24635C10.4868 7.96283 10.4833 7.67932 10.4833 7.3958C10.4833 7.28096 10.4477 7.23071 10.3302 7.23789C10.2092 7.24507 10.0846 7.24507 9.96001 7.23789C9.86034 7.2343 9.83542 7.27378 9.83898 7.37068C9.8461 7.66137 9.83898 7.94848 9.8461 8.23917C9.8461 8.36478 9.8105 8.41861 9.6788 8.41861C8.32969 8.41502 6.98413 8.41143 5.63502 8.41502C5.50688 8.41502 5.46416 8.37555 5.46416 8.24276C5.46416 7.02615 5.46416 5.80954 5.46416 4.59293C5.46416 4.45656 5.51399 4.4099 5.6457 4.4099C6.86667 4.4099 8.08407 4.39914 9.30503 4.39555C9.43318 4.39555 9.56133 4.4099 9.68948 4.4099C9.79982 4.4099 9.84966 4.44938 9.8461 4.56781C9.83898 4.82262 9.8461 7.1374 9.83898 7.38862C9.83542 7.4927 9.86746 7.53576 9.97069 7.53217C10.0953 7.52858 10.2163 7.53217 10.3409 7.53217C10.437 7.53217 10.4868 7.49987 10.4833 7.3958C10.4797 7.01538 10.4833 4.57858 10.4797 4.19816C10.4797 4.1228 10.4655 4.04743 10.4441 3.97924C10.3907 3.79621 10.3373 3.76033 10.1451 3.76033C8.56462 3.76391 6.98769 3.77109 5.40721 3.77468C5.31821 3.77468 5.22922 3.77468 5.14023 3.77468C4.97649 3.77468 4.89817 3.83569 4.86258 4.00078C4.84478 4.09409 4.8341 4.1874 4.8341 4.2807C4.8341 5.57268 4.8341 6.86106 4.8341 8.15304C4.8341 8.32769 4.74629 8.41502 4.57068 8.41502C4.42474 8.41502 4.27523 8.40785 4.12929 8.41502C4.00826 8.41861 3.96198 8.37555 3.96198 8.24994C3.9691 8.00949 3.96198 7.77262 3.96198 7.53217C3.96198 6.3048 3.96198 5.08101 3.96198 3.85364C3.96198 3.73162 3.97978 3.63472 4.08657 3.55576C4.96937 2.87389 5.8486 2.18842 6.72784 1.50296C7.00905 1.28404 7.28671 1.06512 7.5608 0.842617C7.62487 0.788784 7.66759 0.781607 7.73878 0.839028C8.53615 1.48143 9.32995 2.12024 10.1344 2.75546C10.4762 3.02462 10.825 3.28301 11.1774 3.53423C11.3056 3.62395 11.3554 3.73162 11.3554 3.88235C11.3518 4.36684 11.3554 6.80006 11.3554 7.28455C11.3554 7.38862 11.3803 7.4281 11.4871 7.42092C11.6153 7.41374 11.7434 7.42092 11.8715 7.42092C11.9463 7.42092 11.989 7.39939 11.989 7.30967C11.989 6.75699 11.9819 4.25199 11.9997 3.69932C12.0068 3.39786 11.8893 3.19688 11.658 3.02103C11.0101 2.53654 10.3765 2.0341 9.73575 1.53885C9.20536 1.12613 8.67853 0.713419 8.14814 0.300705C8.03779 0.214574 7.92744 0.124853 7.81709 0.0351326C7.7459 -0.0222884 7.53232 0.00283328 7.46113 0.0638432C7.29027 0.210985 7.1194 0.361715 6.9343 0.487324C6.88446 0.523212 6.76344 0.508857 6.70648 0.46938C6.51782 0.336593 6.34696 0.182274 6.16897 0.0351326C6.09422 -0.0258773 5.88776 -0.000755538 5.80945 0.0638432C5.6457 0.203807 5.48552 0.354537 5.30753 0.472968C5.24346 0.516034 5.10463 0.519623 5.04056 0.472968C4.8519 0.350949 4.68103 0.200218 4.50661 0.0566656C4.41762 -0.0151108 4.2432 -0.0186996 4.16488 0.0458991C3.94419 0.228929 3.72349 0.40837 3.50279 0.584222C3.01511 0.968225 2.52744 1.35582 2.03621 1.73623C1.47378 2.17048 0.914914 2.60832 0.341808 3.02821C0.110431 3.19688 -0.00347805 3.39427 8.2016e-05 3.68855C0.0107603 5.30711 0.00364113 6.92925 0.00720119 8.54781C0.00720119 8.94258 0.0605965 8.99282 0.452159 8.99282C2.3103 8.99282 4.172 8.99282 6.03015 8.99282L6.02659 9ZM1.68024 5.91003C1.68024 6.67803 1.68024 7.44604 1.68024 8.21046C1.68024 8.41861 1.66956 8.4222 1.47378 8.4222C1.26732 8.4222 1.06086 8.4222 0.854401 8.4222C0.633702 8.4222 0.633701 8.4222 0.630141 8.1961C0.630141 7.30967 0.626582 6.42323 0.626582 5.53679C0.626582 4.98052 0.626582 4.42067 0.633701 3.8644C0.633701 3.77468 0.665738 3.65266 0.729812 3.60242C1.08222 3.3189 1.45242 3.05692 1.81551 2.78058C2.41709 2.31762 3.01867 1.85466 3.62026 1.38812C3.82672 1.22662 4.02962 1.06153 4.23252 0.900038C4.31439 0.835439 4.46034 0.871327 4.53865 0.982581C4.61696 1.09025 4.50305 1.12254 4.44966 1.16202C4.2432 1.32352 4.02962 1.47066 3.82316 1.63216C3.20734 2.10947 2.60219 2.60473 1.97569 3.0641C1.74432 3.23277 1.67312 3.43015 1.67312 3.69573C1.67668 4.43143 1.67312 5.17073 1.67312 5.90644L1.68024 5.91003ZM3.32836 5.89208C3.32836 6.67803 3.32836 7.46757 3.32836 8.25353C3.32836 8.37555 3.28565 8.42579 3.16462 8.42579C2.93324 8.4222 2.70186 8.41861 2.47049 8.42579C2.37082 8.42579 2.32098 8.38272 2.32098 8.28583C2.32098 8.13151 2.3281 7.97719 2.3281 7.82287C2.32454 6.54166 2.31742 5.26045 2.3103 3.97924C2.3103 3.80698 2.3281 3.67419 2.50252 3.55576C2.90832 3.27584 3.27853 2.94925 3.66653 2.64779C4.33575 2.12741 5.00852 1.60704 5.67774 1.08666C5.75961 1.02206 5.84148 0.957459 5.92336 0.896449C6.04438 0.810317 6.12626 0.907215 6.18677 0.978992C6.26508 1.06871 6.15829 1.1046 6.1049 1.14408C5.73825 1.42759 5.36805 1.70393 5.0014 1.99104C4.53153 2.3571 4.07233 2.7411 3.59178 3.09639C3.396 3.23995 3.31769 3.40503 3.32125 3.63472C3.32481 4.38837 3.32125 5.13843 3.32125 5.89208H3.32836Z"
               fill="#2E2E30"
            />
         ),
      },
      taskBarcode: {
         width: 12,
         height: 8,
         viewBox: [0, 0, 12, 8],
         fill: 'none',
         data: (
            <path
               fillRule="evenodd"
               clipRule="evenodd"
               d="M0 0H1.38708V8H0V0ZM8.74559 0H9.72965V8H8.74559V0ZM10.5459 0H12V8H10.5459V0ZM4.00372 0H6.12825V8H4.00372V0ZM6.94493 0H7.929V8H6.94493V0ZM2.20295 0H3.18701V8H2.20295V0Z"
               fill="#6F7680"
               stroke="none"
            />
         ),
      },
      taskCustomField: {
         width: 12,
         height: 8,
         viewBox: [0, 0, 12, 8],
         fill: 'none',
         data: (
            <>
               <mask id="path-1-inside-1_3879_6040" fill="white">
                  <rect width="12" height="7.5" rx="0.6" />
               </mask>
               <rect
                  width="12"
                  height="7.5"
                  rx="0.6"
                  stroke="#6F7680"
                  strokeWidth="1.8"
                  mask="url(#path-1-inside-1_3879_6040)"
                  fill="none"
               />
               <line
                  x1="1.95"
                  y1="1.95"
                  x2="1.95"
                  y2="5.55"
                  stroke="#6F7680"
                  strokeWidth="0.9"
                  strokeLinecap="round"
                  fill="none"
               />
            </>
         ),
      },
      notepad: {
         width: 30,
         height: 30,
         viewBox: [0, 0, 30, 30],
         fill: 'none',
         data: (
            <>
               <g clipPath="url(#clip0_3879_6324)">
                  <circle cx="15" cy="15" r="15" fill="#6CD329" />
                  <path
                     d="M8.54004 16.96H17.07V20.27L23.62 15.13L17.07 9.98999V13.27H8.54004"
                     stroke="white"
                     strokeWidth="1.5"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                  />
                  <path
                     d="M10.59 21.28H9.79C8.8 21.28 8 20.49 8 19.53V10.75C8 9.78 8.8 9 9.79 9H10.59"
                     stroke="white"
                     strokeWidth="1.5"
                     strokeMiterlimit="10"
                     strokeLinecap="round"
                  />
                  <circle cx="15" cy="15" r="15" fill="#111E40" />
                  <rect
                     x="10.8267"
                     y="10.4031"
                     width="7.98387"
                     height="9.43548"
                     fill="#111E40"
                  />
                  <g clipPath="url(#clip1_3879_6324)">
                     <path
                        d="M19.5346 8.65385C20.5327 8.65385 21.3462 9.46731 21.3462 10.4654V17.7173C21.3462 19.7192 19.7192 21.3462 17.7173 21.3462H10.4654C9.46731 21.3462 8.65385 20.5327 8.65385 19.5346V10.4654C8.65385 9.46731 9.46731 8.65385 10.4654 8.65385H19.5288M19.5346 7.5H10.4654C8.82692 7.5 7.5 8.82692 7.5 10.4654V19.5288C7.5 21.1673 8.82692 22.4942 10.4654 22.4942H17.7173C20.3596 22.4942 22.5 20.3538 22.5 17.7115V10.4654C22.5 8.82692 21.1731 7.5 19.5346 7.5Z"
                        fill="#FFD600"
                     />
                     <path
                        d="M12.0923 11.9539H17.775"
                        stroke="#FFD600"
                        strokeWidth="1.5"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                     />
                     <path
                        d="M12.0923 15H17.775"
                        stroke="#FFD600"
                        strokeWidth="1.5"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                     />
                     <path
                        d="M12.0923 18.0461H16.6442"
                        stroke="#FFD600"
                        strokeWidth="1.5"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                     />
                  </g>
               </g>
               <defs>
                  <clipPath id="clip0_3879_6324">
                     <rect width="30" height="30" fill="white" />
                  </clipPath>
                  <clipPath id="clip1_3879_6324">
                     <rect
                        width="15"
                        height="15"
                        fill="white"
                        transform="translate(7.5 7.5)"
                     />
                  </clipPath>
               </defs>
            </>
         ),
      },
      warranty: {
         width: 30,
         height: 30,
         viewBox: [0, 0, 30, 30],
         fill: 'none',
         data: (
            <>
               <g clipPath="url(#clip0_3879_6500)">
                  <circle cx="15" cy="15" r="15" fill="#6CD329" />
                  <path
                     d="M8.54004 16.96H17.07V20.27L23.62 15.13L17.07 9.98999V13.27H8.54004"
                     stroke="white"
                     strokeWidth="1.5"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                  />
                  <path
                     d="M10.59 21.28H9.79C8.8 21.28 8 20.49 8 19.53V10.75C8 9.78 8.8 9 9.79 9H10.59"
                     stroke="white"
                     strokeWidth="1.5"
                     strokeMiterlimit="10"
                     strokeLinecap="round"
                  />
                  <circle cx="15" cy="15" r="15" fill="#111E40" />
                  <path
                     d="M18.1482 21.0161L15.0433 23L11.9384 21.0161C9.438 19.4197 8 17.1071 8 14.6831V8.22084L15.0433 7L22.0866 8.22671V14.6889C22.0866 17.1189 20.6486 19.4255 18.1482 21.022V21.0161Z"
                     stroke="#FFD600"
                     strokeWidth="1.5"
                     strokeMiterlimit="10"
                     strokeLinecap="round"
                  />
                  <path
                     d="M12.449 14.2195C13.2413 15.4404 14.1159 16.1036 14.5091 16.3619C14.6324 16.444 14.7909 16.4323 14.9024 16.3325C15.5187 15.8043 16.2817 15.0002 18.3653 12.042"
                     stroke="#FFD600"
                     strokeWidth="1.5"
                     strokeMiterlimit="10"
                     strokeLinecap="round"
                  />
               </g>
               <defs>
                  <clipPath id="clip0_3879_6500">
                     <rect width="30" height="30" fill="white" />
                  </clipPath>
               </defs>
            </>
         ),
      },
      'info-outlined': {
         width: 19,
         height: 19,
         viewBox: [0, 0, 19, 19],
         fill: 'none',
         data: (
            <>
               <g clipPath="url(#clip0_7021_1871)">
                  <path
                     d="M9.10999 8.35999V12.94"
                     stroke="#1A4D80"
                     strokeWidth="1.5"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                  />
                  <path
                     d="M9.09998 5.53V5.65"
                     stroke="#1A4D80"
                     strokeWidth="2"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                  />
                  <path
                     d="M9.11 17.47C13.7271 17.47 17.47 13.7271 17.47 9.11C17.47 4.4929 13.7271 0.75 9.11 0.75C4.4929 0.75 0.75 4.4929 0.75 9.11C0.75 13.7271 4.4929 17.47 9.11 17.47Z"
                     stroke="#1A4D80"
                     strokeWidth="1.5"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                  />
               </g>
               <defs>
                  <clipPath id="clip0_7021_1871">
                     <rect width="18.23" height="18.23" fill="white" />
                  </clipPath>
               </defs>
            </>
         ),
      },
      'info-filled': {
         width: 19,
         height: 19,
         viewBox: [0, 0, 19, 19],
         fill: 'none',
         data: (
            <>
               <path
                  d="M9.11 17.47C13.7271 17.47 17.47 13.7271 17.47 9.11C17.47 4.4929 13.7271 0.75 9.11 0.75C4.4929 0.75 0.75 4.4929 0.75 9.11C0.75 13.7271 4.4929 17.47 9.11 17.47Z"
                  fill="#1A4D80"
                  stroke="#1A4D80"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  d="M9.10999 8.35999V12.94"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  d="M9.09998 5.53V5.65"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
            </>
         ),
      },
      download: {
         width: 26,
         height: 26,
         data: (
            <path d="m 0.36523438,3.578125 v 2.0097656 0.6816406 h 0.68359372 5.1875 V 5.5878906 3.578125 H 5.5546875 V 5.5878906 H 1.0488281 V 3.578125 Z M 1.4420245,2.4929744 1.4414008,3.4981245 2.9725423,5.1197003 H 3.6424577 L 5.1092509,3.5527208 V 2.535321 L 3.6437053,4.1010606 3.6430815,0.37656313 H 2.973166 V 4.1029281 Z" />
         ),
      },
      cards: {
         width: 38,
         height: 25,
         viewBox: [0, 0, 38, 25],
         fill: 'none',
         data: (
            <>
               <g clipPath="url(#clip0_7035_3146)">
                  <path
                     d="M15.6346 1.92308V9.61539H1.92308V1.92308H15.6346ZM15.6346 0H1.92308C0.865385 0 0 0.865385 0 1.92308V9.61539C0 10.6731 0.865385 11.5385 1.92308 11.5385H15.6346C16.6923 11.5385 17.5577 10.6731 17.5577 9.61539V1.92308C17.5577 0.865385 16.6923 0 15.6346 0Z"
                     fill="#6F7680"
                  />
                  <path
                     d="M35.4039 1.92308V9.61539H21.6924V1.92308H35.4039ZM35.4039 0H21.6924C20.6347 0 19.7693 0.865385 19.7693 1.92308V9.61539C19.7693 10.6731 20.6347 11.5385 21.6924 11.5385H35.4039C36.4616 11.5385 37.327 10.6731 37.327 9.61539V1.92308C37.327 0.865385 36.4616 0 35.4039 0Z"
                     fill="#6F7680"
                  />
                  <path
                     d="M15.6346 15.3845V23.0768H1.92308V15.3845H15.6346ZM15.6346 13.4614H1.92308C0.865385 13.4614 0 14.3268 0 15.3845V23.0768C0 24.1345 0.865385 24.9999 1.92308 24.9999H15.6346C16.6923 24.9999 17.5577 24.1345 17.5577 23.0768V15.3845C17.5577 14.3268 16.6923 13.4614 15.6346 13.4614Z"
                     fill="#6F7680"
                  />
                  <path
                     d="M35.4039 15.3845V23.0768H21.6924V15.3845H35.4039ZM35.4039 13.4614H21.6924C20.6347 13.4614 19.7693 14.3268 19.7693 15.3845V23.0768C19.7693 24.1345 20.6347 24.9999 21.6924 24.9999H35.4039C36.4616 24.9999 37.327 24.1345 37.327 23.0768V15.3845C37.327 14.3268 36.4616 13.4614 35.4039 13.4614Z"
                     fill="#6F7680"
                  />
               </g>
               <defs>
                  <clipPath id="clip0_7035_3146">
                     <rect width="37.3269" height="25" fill="white" />
                  </clipPath>
               </defs>
            </>
         ),
      },
      table: {
         width: 37,
         height: 25,
         viewBox: [0, 0, 37, 25],
         fill: 'none',
         data: (
            <>
               <rect
                  x="1"
                  y="1"
                  width="35"
                  height="23"
                  rx="1"
                  stroke="#6F7680"
                  strokeWidth="2"
               />
               <path
                  d="M7 6H13.9759"
                  stroke="#6F7680"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  d="M18.9756 6H30.7765"
                  stroke="#6F7680"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  d="M7 10.3333H13.9759"
                  stroke="#6F7680"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  d="M18.9756 10.3333H30.7765"
                  stroke="#6F7680"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  d="M7 14.6667H13.9759"
                  stroke="#6F7680"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  d="M18.9756 14.6667H30.7765"
                  stroke="#6F7680"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  d="M7 19H13.9759"
                  stroke="#6F7680"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  d="M18.9756 19H30.7765"
                  stroke="#6F7680"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
            </>
         ),
      },
      columns: {
         width: 17,
         height: 17,
         viewBox: [0, 0, 17, 17],
         fill: 'none',
         data: (
            <>
               <g clipPath="url(#clip0_6968_22778)">
                  <path
                     d="M13.44 2.16992C14.11 2.16992 14.66 2.71992 14.66 3.38992V13.6199C14.66 14.2899 14.11 14.8399 13.44 14.8399H3.22C2.55 14.8399 2 14.2899 2 13.6199V3.38992C2 2.71992 2.55 2.16992 3.22 2.16992H13.45M13.44 0.169922H3.22C1.44 0.169922 0 1.60992 0 3.38992V13.6199C0 15.3999 1.44 16.8399 3.22 16.8399H13.45C15.23 16.8399 16.67 15.3999 16.67 13.6199V3.38992C16.67 1.60992 15.23 0.169922 13.45 0.169922H13.44Z"
                     fill="#6F7680"
                  />
                  <path
                     d="M5.96002 4.96997V14.98"
                     stroke="#6F7680"
                     strokeWidth="2"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                  />
                  <path
                     d="M10.7 4.96997V14.98"
                     stroke="#6F7680"
                     strokeWidth="2"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                  />
                  <path
                     d="M1.34998 4.85986H15.31"
                     stroke="#6F7680"
                     strokeWidth="2"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                  />
               </g>
               <defs>
                  <clipPath id="clip0_6968_22778">
                     <rect
                        width="16.66"
                        height="16.66"
                        fill="white"
                        transform="translate(0 0.169922)"
                     />
                  </clipPath>
               </defs>
            </>
         ),
      },
      'add-item': {
         width: 17,
         height: 14,
         viewBox: [0, 0, 17, 14],
         fill: 'none',
         data: (
            <>
               <g clipPath="url(#clip0_7035_4382)">
                  <path
                     d="M11.9888 4.94718C12.0997 4.80258 12.1299 4.60635 12.0644 4.43593L11.3888 2.7111C11.3888 2.7111 11.2426 2.41675 10.8091 2.41675H2.17293C1.69399 2.41675 1.58307 2.73693 1.58307 2.73693L0.892384 4.43076C0.821803 4.60635 0.84701 4.80258 0.962965 4.95234L2.28384 6.66684C2.43509 6.86308 2.42501 7.14711 2.25864 7.33302L0.630225 9.15596C0.544519 9.24891 0.499146 9.37285 0.499146 9.50196V11.7122C0.499146 12.2854 0.952882 12.745 1.50745 12.745H9.88141M9.88141 12.745C9.86125 12.6882 9.84108 12.6211 9.84108 12.5436C9.84108 12.6263 9.8562 12.6882 9.88141 12.745Z"
                     stroke="#6F7680"
                     strokeMiterlimit="10"
                  />
                  <path
                     d="M0.781494 4.71484H12.1703"
                     stroke="#6F7680"
                     strokeMiterlimit="10"
                  />
                  <path
                     d="M0.50415 9.30591H8.47479"
                     stroke="#6F7680"
                     strokeMiterlimit="10"
                  />
                  <path
                     d="M4.20972 2.08626L4.73403 0.795221C4.83487 0.624804 5.04661 0.516357 5.27852 0.516357H7.65811C7.89002 0.516357 8.09673 0.624804 8.2026 0.795221L8.72692 2.08626"
                     stroke="#6F7680"
                     strokeMiterlimit="10"
                  />
                  <path
                     d="M12.4172 13.4835C14.6698 13.4835 16.4958 11.6131 16.4958 9.30572C16.4958 6.99839 14.6698 5.12793 12.4172 5.12793C10.1647 5.12793 8.33862 6.99839 8.33862 9.30572C8.33862 11.6131 10.1647 13.4835 12.4172 13.4835Z"
                     stroke="#6F7680"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                  />
                  <path
                     d="M14.1364 9.30591H10.6981"
                     stroke="#6F7680"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                  />
                  <path
                     d="M12.4172 11.0669V7.54492"
                     stroke="#6F7680"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                  />
               </g>
               <defs>
                  <clipPath id="clip0_7035_4382">
                     <rect width="17" height="14" fill="white" />
                  </clipPath>
               </defs>
            </>
         ),
      },
      'delete-item': {
         width: 17,
         height: 14,
         viewBox: [0, 0, 17, 14],
         fill: 'none',
         data: (
            <>
               <g clipPath="url(#clip0_7035_4396)">
                  <path
                     d="M11.9888 4.94718C12.0997 4.80258 12.1299 4.60635 12.0644 4.43593L11.3888 2.7111C11.3888 2.7111 11.2426 2.41675 10.8091 2.41675H2.17293C1.69399 2.41675 1.58307 2.73693 1.58307 2.73693L0.892384 4.43076C0.821803 4.60635 0.84701 4.80258 0.962965 4.95234L2.28384 6.66684C2.43509 6.86308 2.42501 7.14711 2.25864 7.33302L0.630225 9.15596C0.544519 9.24891 0.499146 9.37285 0.499146 9.50196V11.7122C0.499146 12.2854 0.952882 12.745 1.50745 12.745H9.88141M9.88141 12.745C9.86125 12.6882 9.84108 12.6211 9.84108 12.5436C9.84108 12.6263 9.8562 12.6882 9.88141 12.745Z"
                     stroke="#6F7680"
                     strokeMiterlimit="10"
                  />
                  <path
                     d="M0.781494 4.71484H12.1703"
                     stroke="#6F7680"
                     strokeMiterlimit="10"
                  />
                  <path
                     d="M0.50415 9.30591H8.47479"
                     stroke="#6F7680"
                     strokeMiterlimit="10"
                  />
                  <path
                     d="M4.20972 2.08626L4.73403 0.795221C4.83487 0.624804 5.04661 0.516357 5.27852 0.516357H7.65811C7.89002 0.516357 8.09673 0.624804 8.2026 0.795221L8.72692 2.08626"
                     stroke="#6F7680"
                     strokeMiterlimit="10"
                  />
                  <path
                     d="M12.4172 13.4835C14.6698 13.4835 16.4958 11.6131 16.4958 9.30572C16.4958 6.99839 14.6698 5.12793 12.4172 5.12793C10.1647 5.12793 8.33862 6.99839 8.33862 9.30572C8.33862 11.6131 10.1647 13.4835 12.4172 13.4835Z"
                     stroke="#6F7680"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                  />
                  <path
                     d="M13.6329 10.5213L11.2017 8.09009"
                     stroke="#6F7680"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                  />
                  <path
                     d="M11.172 10.5512L13.6624 8.06079"
                     stroke="#6F7680"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                  />
               </g>
               <defs>
                  <clipPath id="clip0_7035_4396">
                     <rect width="17" height="14" fill="white" />
                  </clipPath>
               </defs>
            </>
         ),
      },
      'scan-item': {
         width: 15,
         height: 14,
         viewBox: [0, 0, 15, 14],
         fill: 'none',
         data: (
            <>
               <g clipPath="url(#clip0_7035_4424)">
                  <path
                     d="M4.25215 0.445068H0.452393V4.18394"
                     stroke="#6F7680"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                  />
                  <path
                     d="M12.509 4.18394V0.445068H8.70923"
                     stroke="#6F7680"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                  />
                  <path
                     d="M0.452393 8.56982V12.3087H4.25215"
                     stroke="#6F7680"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                  />
                  <path
                     d="M2.36426 6.68848V10.2434"
                     stroke="#6F7680"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                  />
                  <path
                     d="M3.63086 6.68848V10.2434"
                     stroke="#6F7680"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                  />
                  <path
                     d="M5.21716 6.83691V10.0595"
                     stroke="#6F7680"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                  />
                  <path
                     d="M5.00603 2.64087H2.89506C2.77847 2.64087 2.68396 2.73387 2.68396 2.84858V4.92574C2.68396 5.04045 2.77847 5.13345 2.89506 5.13345H5.00603C5.12262 5.13345 5.21713 5.04045 5.21713 4.92574V2.84858C5.21713 2.73387 5.12262 2.64087 5.00603 2.64087Z"
                     stroke="#6F7680"
                     strokeMiterlimit="10"
                     strokeLinecap="round"
                  />
                  <path
                     d="M7.43066 2.5105V5.8102"
                     stroke="#6F7680"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                  />
                  <path
                     d="M10.597 2.5105V5.8102"
                     stroke="#6F7680"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                  />
                  <path
                     d="M9.01685 2.64087V5.66164"
                     stroke="#6F7680"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                  />
                  <path
                     d="M9.49341 10.3502C9.9337 11.0208 10.4162 11.3828 10.6394 11.5193C10.7057 11.5668 10.7962 11.5549 10.8565 11.5015C11.2003 11.2107 11.6225 10.7715 12.7805 9.15137"
                     stroke="#6F7680"
                     strokeMiterlimit="10"
                     strokeLinecap="round"
                  />
                  <path
                     d="M10.9892 13.5608C12.9545 13.5608 14.5477 11.9932 14.5477 10.0593C14.5477 8.12553 12.9545 6.55786 10.9892 6.55786C9.02386 6.55786 7.43066 8.12553 7.43066 10.0593C7.43066 11.9932 9.02386 13.5608 10.9892 13.5608Z"
                     stroke="#6F7680"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                  />
               </g>
               <defs>
                  <clipPath id="clip0_7035_4424">
                     <rect width="15" height="14" fill="white" />
                  </clipPath>
               </defs>
            </>
         ),
      },
      'auto-accept-item': {
         width: 14,
         height: 14,
         viewBox: [0, 0, 14, 14],
         fill: 'none',
         data: (
            <>
               <g clipPath="url(#clip0_7035_4443)">
                  <path
                     d="M3.03479 6.94465H7.15504V8.54512L10.3228 6.05857L7.15504 3.57202V5.16142H3.03479"
                     stroke="#6F7680"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                  />
                  <path
                     d="M4.02616 9.03233H3.63851C3.16224 9.03233 2.76904 8.65021 2.76904 8.18502V3.9374C2.76904 3.46667 3.1567 3.09009 3.63851 3.09009H4.02616"
                     stroke="#6F7680"
                     strokeMiterlimit="10"
                     strokeLinecap="round"
                  />
                  <path
                     d="M8.94934 10.5835C9.35361 11.2095 9.79665 11.5475 10.0016 11.6749C10.0625 11.7192 10.1455 11.7081 10.2009 11.6583C10.5166 11.3868 10.9042 10.9768 11.9675 9.46436"
                     stroke="#6F7680"
                     strokeMiterlimit="10"
                     strokeLinecap="round"
                  />
                  <path
                     d="M11.9676 7.21062V2.00493C11.9676 1.12439 11.2311 0.415527 10.3173 0.415527H2.06572C1.15749 0.415527 0.415405 1.12993 0.415405 2.00493V10.1125C0.415405 10.9931 1.15196 11.7019 2.06572 11.7019H7.21604"
                     stroke="#6F7680"
                     strokeMiterlimit="10"
                     strokeLinecap="round"
                  />
                  <path
                     d="M10.3228 13.579C12.1274 13.579 13.5902 12.1161 13.5902 10.3116C13.5902 8.50706 12.1274 7.04419 10.3228 7.04419C8.51829 7.04419 7.05542 8.50706 7.05542 10.3116C7.05542 12.1161 8.51829 13.579 10.3228 13.579Z"
                     stroke="#6F7680"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                  />
               </g>
               <defs>
                  <clipPath id="clip0_7035_4443">
                     <rect width="14" height="13.9945" fill="white" />
                  </clipPath>
               </defs>
            </>
         ),
      },
      'allow-transfer-to-employees': {
         width: 14,
         height: 14,
         viewBox: [0, 0, 14, 14],
         fill: 'none',
         data: (
            <>
               <path d="M11.93 7.21V2.07C11.93 1.2 11.2 0.5 10.3 0.5H2.12999C1.22999 0.5 0.5 1.2 0.5 2.07V10.08C0.5 10.95 1.22999 11.65 2.12999 11.65H7.23" stroke="#6F7680" stroke-linecap="round" stroke-linejoin="round"/>
               <path d="M10.3001 13.5C12.0839 13.5 13.5301 12.0539 13.5301 10.27C13.5301 8.48612 12.0839 7.04 10.3001 7.04C8.51618 7.04 7.07007 8.48612 7.07007 10.27C7.07007 12.0539 8.51618 13.5 10.3001 13.5Z" stroke="#6F7680" stroke-linecap="round" stroke-linejoin="round"/>
               <path d="M10.49 8.95L11.82 10.27L10.49 11.6" stroke="#6F7680" stroke-linecap="round" stroke-linejoin="round"/>
               <path d="M11.69 10.27H8.84998" stroke="#6F7680" stroke-linecap="round" stroke-linejoin="round"/>
               <path d="M7.08995 9.27C6.83995 9.24 6.58995 9.23 6.33995 9.23C4.56995 9.23 2.66994 9.97 2.43994 11.57" stroke="#6F7680" stroke-linecap="round" stroke-linejoin="round"/>
               <path d="M6.93994 0.99V2.49" stroke="#6F7680" stroke-linecap="round" stroke-linejoin="round"/>
               <path d="M5.58997 2.49V0.99" stroke="#6F7680" stroke-linecap="round" stroke-linejoin="round"/>
               <path d="M8.69002 4.17C9.03002 4.17 9.49002 4.45 9.49002 4.79V4.96C9.49002 5.3 9.21003 5.58 8.87003 5.58H6.26003H3.65002C3.31002 5.58 3.03003 5.3 3.03003 4.96V4.79C3.03003 4.45 3.50003 4.17 3.84003 4.17" stroke="#6F7680" stroke-linecap="round" stroke-linejoin="round"/>
               <path d="M3.93994 4.17V3.72C3.93994 2.92 4.29995 1.93 5.11995 1.74L5.46996 1.25H6.93994L7.25995 1.74C8.07995 1.92 8.56995 2.82 8.56995 3.72V4.17" stroke="#6F7680" stroke-linecap="round" stroke-linejoin="round"/>
               <path d="M8.94006 5.95C8.94006 7.46 7.74007 8.68 6.26007 8.68C4.78007 8.68 3.58008 7.46 3.58008 5.95" stroke="#6F7680" stroke-linecap="round" stroke-linejoin="round"/>
            </>
         ),
      },
      'allow-transfer-to-view-only': {
         width: 24,
         height: 24,
         viewBox: [0, 0, 24, 24],
         fill: 'none',
         data: (
            <>
               <g clip-path="url(#clip0_9839_7620)">
                  <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F3F4F6"/>
                  <path d="M11.3299 14.22C9.55993 14.22 7.65993 14.96 7.42993 16.56L11.9999 16.5L12.0799 14.26C11.8299 14.23 11.5799 14.22 11.3299 14.22Z" fill="#C5C8CC"/>
                  <path d="M13.68 9.16999H13.57V8.71999C13.57 7.88999 13.14 7.04999 12.43 6.79999V6.54999C12.43 6.26999 12.21 6.04999 11.93 6.04999C11.77 6.04999 11.63 6.12999 11.54 6.25999H10.98C10.89 6.13999 10.75 6.04999 10.59 6.04999C10.31 6.04999 10.09 6.26999 10.09 6.54999V6.75999C9.30003 6.96999 8.95003 7.93999 8.95003 8.72999V9.17999H8.84003C8.50003 9.17999 8.03003 9.45999 8.03003 9.79999V9.96999C8.03003 10.31 8.31003 10.59 8.65003 10.59H13.88C14.22 10.59 14.5 10.31 14.5 9.96999V9.79999C14.5 9.45999 14.04 9.17999 13.7 9.17999L13.68 9.16999Z" fill="#C5C8CC"/>
                  <path d="M11.2501 13.68C12.7301 13.68 13.9301 12.46 13.9301 10.95H8.57007C8.57007 12.46 9.77007 13.68 11.2501 13.68Z" fill="#C5C8CC"/>
                  <path d="M16.92 12.21V7.07C16.92 6.2 16.19 5.5 15.29 5.5H7.10998C6.20998 5.5 5.47998 6.2 5.47998 7.07V15.08C5.47998 15.95 6.20998 16.65 7.10998 16.65H12.21" stroke="#6F7680" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M15.2901 18.5C17.0739 18.5 18.5201 17.0539 18.5201 15.27C18.5201 13.4861 17.0739 12.04 15.2901 12.04C13.5062 12.04 12.0601 13.4861 12.0601 15.27C12.0601 17.0539 13.5062 18.5 15.2901 18.5Z" stroke="#6F7680" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M15.48 13.95L16.81 15.27L15.48 16.6" stroke="#6F7680" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M16.6801 15.27H13.8401" stroke="#6F7680" stroke-linecap="round" stroke-linejoin="round"/>
               </g>
               <defs>
                  <clipPath id="clip0_9839_7620">
                     <rect width="24" height="24" fill="white"/>
                  </clipPath>
               </defs> 
            </>
         ),
      },
      'allow-transfer-item': {
         width: 14,
         height: 14,
         viewBox: [0, 0, 14, 14],
         fill: 'none',
         data: (
            <>
               <g clipPath="url(#clip0_7035_4410)">
                  <path
                     d="M3.99847 4.45972C2.59182 4.88077 1.60606 5.99434 3.26745 6.83091C4.25875 7.32952 5.46603 7.52343 6.6567 7.52897"
                     stroke="#6F7680"
                     strokeMiterlimit="10"
                     strokeLinecap="round"
                  />
                  <path
                     d="M8.36786 7.09141C9.18748 6.8421 10.5609 6.1662 9.72466 5.18559C8.82197 4.13296 6.6234 4.07202 5.38843 4.07202"
                     stroke="#6F7680"
                     strokeMiterlimit="10"
                     strokeLinecap="round"
                  />
                  <path
                     d="M6.41846 5.17447L5.31641 4.07198L6.41846 2.96948"
                     stroke="#6F7680"
                     strokeMiterlimit="10"
                     strokeLinecap="round"
                  />
                  <path
                     d="M5.89795 6.39331L7.00001 7.4958L5.89795 8.5983"
                     stroke="#6F7680"
                     strokeMiterlimit="10"
                     strokeLinecap="round"
                  />
                  <path
                     d="M11.9676 7.21331V2.00556C11.9676 1.12467 11.2311 0.415527 10.3173 0.415527H2.06572C1.15749 0.415527 0.415405 1.13021 0.415405 2.00556V10.1164C0.415405 10.9972 1.15196 11.7064 2.06572 11.7064H7.21604"
                     stroke="#6F7680"
                     strokeMiterlimit="10"
                     strokeLinecap="round"
                  />
                  <path
                     d="M10.3228 13.5845C12.1274 13.5845 13.5902 12.1211 13.5902 10.3158C13.5902 8.51057 12.1274 7.04712 10.3228 7.04712C8.51829 7.04712 7.05542 8.51057 7.05542 10.3158C7.05542 12.1211 8.51829 13.5845 10.3228 13.5845Z"
                     stroke="#6F7680"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                  />
                  <path
                     d="M10.5221 8.96948L11.8623 10.3157L10.5221 11.662"
                     stroke="#6F7680"
                     strokeMiterlimit="10"
                     strokeLinecap="round"
                  />
                  <path
                     d="M11.7349 10.3157H8.86072"
                     stroke="#6F7680"
                     strokeMiterlimit="10"
                     strokeLinecap="round"
                  />
               </g>
               <defs>
                  <clipPath id="clip0_7035_4410">
                     <rect width="14" height="14" fill="white" />
                  </clipPath>
               </defs>
            </>
         ),
      },
      'allow-add-location': {
         width: 16,
         height: 14,
         viewBox: [0, 0, 16, 14],
         fill: 'none',
         data: (
            <>
               <path d="M4.53985 6.79C5.74936 6.79 6.72985 5.80055 6.72985 4.58C6.72985 3.35945 5.74936 2.37 4.53985 2.37C3.33035 2.37 2.34985 3.35945 2.34985 4.58C2.34985 5.80055 3.33035 6.79 4.53985 6.79Z" stroke="#6F7680" stroke-linecap="round" stroke-linejoin="round"/>
               <path d="M6.36 9.29C5.42 10.35 4.54 11.01 4.54 11.01C4.54 11.01 0.5 7.48 0.5 4.58C0.5 2.33 2.31 0.5 4.54 0.5C6.77 0.5 8.58 2.33 8.58 4.58C8.58 4.97 8.53 5.36 8.43 5.74" stroke="#6F7680" stroke-linecap="round" stroke-linejoin="round"/>
               <path d="M10.71 13.5C13.0131 13.5 14.88 11.633 14.88 9.33C14.88 7.02697 13.0131 5.16 10.71 5.16C8.40701 5.16 6.54004 7.02697 6.54004 9.33C6.54004 11.633 8.40701 13.5 10.71 13.5Z" stroke="#6F7680" stroke-linecap="round" stroke-linejoin="round"/>
               <path d="M12.47 9.33H8.95996" stroke="#6F7680" stroke-linecap="round" stroke-linejoin="round"/>
               <path d="M10.71 11.09V7.57" stroke="#6F7680" stroke-linecap="round" stroke-linejoin="round"/>
            </>
         ),
      },
      'audit-sent': {
         width: 14,
         height: 14,
         viewBox: [0, 0, 14, 14],
         fill: 'none',
         data: (
            <>
               <g clipPath="url(#clip0_7035_5147)">
                  <path
                     d="M11.2759 12.3971L0.584473 6.59874L13.4154 1.07764L11.2759 12.3971Z"
                     stroke="#B7BCC2"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                  />
                  <path
                     d="M13.4155 1.07764L5.76953 9.14561V12.9168L7.46473 10.3353"
                     stroke="#B7BCC2"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                  />
               </g>
               <defs>
                  <clipPath id="clip0_7035_5147">
                     <rect
                        width="14"
                        height="13"
                        fill="white"
                        transform="translate(0 0.5)"
                     />
                  </clipPath>
               </defs>
            </>
         ),
      },
      'audit-due': {
         width: 16,
         height: 17,
         viewBox: [0, 0, 16, 17],
         fill: 'none',
         data: (
            <>
               <path
                  d="M13.4895 9.06061V3.5134C13.4895 2.57405 12.6889 1.81812 11.7077 1.81812H2.7818C1.79505 1.81812 1 2.57961 1 3.5134V12.151C1 13.0904 1.80068 13.8463 2.7818 13.8463H8.35276"
                  stroke="#B7BCC2"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
               />
               <path
                  d="M11.6018 15.5916C13.4785 15.5916 14.9999 14.1099 14.9999 12.2821C14.9999 10.4544 13.4785 8.97266 11.6018 8.97266C9.72502 8.97266 8.20361 10.4544 8.20361 12.2821C8.20361 14.1099 9.72502 15.5916 11.6018 15.5916Z"
                  stroke="#B7BCC2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  d="M11.5386 11.2456V12.7297"
                  stroke="#B7BCC2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  d="M12.8016 12.7295H11.5386"
                  stroke="#B7BCC2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  d="M3.34912 1.40796V3.00876"
                  stroke="#B7BCC2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  d="M11.2661 1.40796V3.00876"
                  stroke="#B7BCC2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  d="M5.87183 5.77602C6.29535 5.77602 6.63868 5.43758 6.63868 5.02009C6.63868 4.6026 6.29535 4.26416 5.87183 4.26416C5.44831 4.26416 5.10498 4.6026 5.10498 5.02009C5.10498 5.43758 5.44831 5.77602 5.87183 5.77602Z"
                  fill="#B7BCC2"
               />
               <path
                  d="M8.29664 5.77602C8.72016 5.77602 9.06349 5.43758 9.06349 5.02009C9.06349 4.6026 8.72016 4.26416 8.29664 4.26416C7.87312 4.26416 7.52979 4.6026 7.52979 5.02009C7.52979 5.43758 7.87312 5.77602 8.29664 5.77602Z"
                  fill="#B7BCC2"
               />
               <path
                  d="M10.7268 5.77602C11.1503 5.77602 11.4937 5.43758 11.4937 5.02009C11.4937 4.6026 11.1503 4.26416 10.7268 4.26416C10.3033 4.26416 9.95996 4.6026 9.95996 5.02009C9.95996 5.43758 10.3033 5.77602 10.7268 5.77602Z"
                  fill="#B7BCC2"
               />
               <path
                  d="M3.44166 8.44961C3.86518 8.44961 4.20851 8.11117 4.20851 7.69368C4.20851 7.27619 3.86518 6.93774 3.44166 6.93774C3.01814 6.93774 2.6748 7.27619 2.6748 7.69368C2.6748 8.11117 3.01814 8.44961 3.44166 8.44961Z"
                  fill="#B7BCC2"
               />
               <path
                  d="M5.87183 8.44961C6.29535 8.44961 6.63868 8.11117 6.63868 7.69368C6.63868 7.27619 6.29535 6.93774 5.87183 6.93774C5.44831 6.93774 5.10498 7.27619 5.10498 7.69368C5.10498 8.11117 5.44831 8.44961 5.87183 8.44961Z"
                  fill="#B7BCC2"
               />
               <path
                  d="M8.29664 8.44961C8.72016 8.44961 9.06349 8.11117 9.06349 7.69368C9.06349 7.27619 8.72016 6.93774 8.29664 6.93774C7.87312 6.93774 7.52979 7.27619 7.52979 7.69368C7.52979 8.11117 7.87312 8.44961 8.29664 8.44961Z"
                  fill="#B7BCC2"
               />
               <path
                  d="M10.7268 8.44961C11.1503 8.44961 11.4937 8.11117 11.4937 7.69368C11.4937 7.27619 11.1503 6.93774 10.7268 6.93774C10.3033 6.93774 9.95996 7.27619 9.95996 7.69368C9.95996 8.11117 10.3033 8.44961 10.7268 8.44961Z"
                  fill="#B7BCC2"
               />
               <path
                  d="M3.44166 11.029C3.86518 11.029 4.20851 10.6905 4.20851 10.273C4.20851 9.85553 3.86518 9.51709 3.44166 9.51709C3.01814 9.51709 2.6748 9.85553 2.6748 10.273C2.6748 10.6905 3.01814 11.029 3.44166 11.029Z"
                  fill="#B7BCC2"
               />
               <path
                  d="M5.87183 11.029C6.29535 11.029 6.63868 10.6905 6.63868 10.273C6.63868 9.85553 6.29535 9.51709 5.87183 9.51709C5.44831 9.51709 5.10498 9.85553 5.10498 10.273C5.10498 10.6905 5.44831 11.029 5.87183 11.029Z"
                  fill="#B7BCC2"
               />
               <path
                  d="M8.29664 11.029C8.72016 11.029 9.06349 10.6905 9.06349 10.273C9.06349 9.85553 8.72016 9.51709 8.29664 9.51709C7.87312 9.51709 7.52979 9.85553 7.52979 10.273C7.52979 10.6905 7.87312 11.029 8.29664 11.029Z"
                  fill="#B7BCC2"
               />
            </>
         ),
      },
      'audit-received': {
         width: 16,
         height: 15,
         viewBox: [0, 0, 16, 15],
         fill: 'none',
         data: (
            <>
               <path
                  d="M10.673 7.27454L9.8985 8.42267C9.6772 8.74989 9.30449 8.94507 8.90849 8.94507H7.11481C6.7188 8.94507 6.34609 8.74989 6.12479 8.42267L5.35025 7.26879C5.1406 6.95306 4.77953 6.76362 4.39517 6.76362H2.17055C1.52413 6.75213 1 7.26879 1 7.90027V12.7741C1 13.4056 1.5183 13.9222 2.16473 13.9222H13.8236C14.4642 13.9222 14.9884 13.4113 14.9884 12.7798L15 7.91749C15 7.28028 14.4817 6.76936 13.8353 6.76936H11.6281C11.2438 6.76936 10.8827 6.9588 10.673 7.27454Z"
                  stroke="#B7BCC2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  d="M6.44531 4.17459L8.00604 5.38013L9.56095 4.17459L8.00604 5.38013V1"
                  stroke="#B7BCC2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  d="M3.87158 11.3386H12.1353"
                  stroke="#B7BCC2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
            </>
         ),
      },
      'comment-outlined': {
         width: 18,
         height: 18,
         viewBox: [0, 0, 18, 18],
         fill: 'none',
         data: (
            <>
               <path 
                  d="M4.24139 13.974H2.06255C1.34065 13.974 0.75 13.3833 0.75 12.6614V2.06255C0.75 1.34065 1.34065 0.75 2.06255 0.75H15.5162C16.2381 0.75 16.8288 1.34065 16.8288 2.06255V12.6614C16.8288 13.3833 16.2381 13.974 15.5162 13.974H11.0929L8.76313 16.75L6.91899 13.974H4.23482H4.24139Z" 
                  stroke="#1A4D80" 
                  stroke-width="1.5" 
                  stroke-linecap="round" 
                  stroke-linejoin="round"
               />
               <path 
                  d="M5.00269 5.80994H12.1955" 
                  stroke="#1A4D80" 
                  stroke-width="1.5" 
                  stroke-miterlimit="10" 
                  stroke-linecap="round"
               />
               <path 
                  d="M5.00269 8.91406H12.1955" 
                  stroke="#1A4D80" 
                  stroke-width="1.5" 
                  stroke-miterlimit="10" 
                  stroke-linecap="round"
               />
            </>
         )
      },
      'comment-filled': {
         width: 18,
         height: 18,
         viewBox: [0, 0, 18, 18],
         fill: 'none',
         data: (
            <>
               <path 
                  d="M4.24139 13.974H2.06255C1.34065 13.974 0.75 13.3833 0.75 12.6614V2.06255C0.75 1.34065 1.34065 0.75 2.06255 0.75H15.5162C16.2381 0.75 16.8288 1.34065 16.8288 2.06255V12.6614C16.8288 13.3833 16.2381 13.974 15.5162 13.974H11.0929L8.76313 16.75L6.91899 13.974H4.23482H4.24139Z" 
                  fill="#1A4D80" 
                  stroke="#1A4D80" 
                  stroke-width="1.5" 
                  stroke-linecap="round" 
                  stroke-linejoin="round" 
               />
               <path d="M5.00269 5.80994H12.1955" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" 
               />
               <path d="M5.00269 8.91406H12.1955" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" 
               />
               </>
         )
      },
      'print-calendar-from': {
         width: 11,
         height: 11,
         viewBox: [0,0,11,11],
         fill: 'none',
         data: (
            <>
               <g clip-path="url(#clip0_8733_6641)">
                  <path d="M9.625 0H1.375C1.01033 0 0.660591 0.144866 0.402728 0.402728C0.144866 0.660591 0 1.01033 0 1.375L0 9.625C0 9.98967 0.144866 10.3394 0.402728 10.5973C0.660591 10.8551 1.01033 11 1.375 11H9.625C9.98967 11 10.3394 10.8551 10.5973 10.5973C10.8551 10.3394 11 9.98967 11 9.625V1.375C11 1.01033 10.8551 0.660591 10.5973 0.402728C10.3394 0.144866 9.98967 0 9.625 0V0ZM0.6875 2.65169C0.6875 2.3265 0.9955 2.0625 1.375 2.0625H9.625C10.0045 2.0625 10.3125 2.3265 10.3125 2.65169V9.72331C10.3125 10.0485 10.0045 10.3125 9.625 10.3125H1.375C0.9955 10.3125 0.6875 10.0485 0.6875 9.72331V2.65169Z" fill="#6F7680"/>
                  <path d="M4.46875 4.8125C4.65109 4.8125 4.82595 4.74007 4.95489 4.61114C5.08382 4.4822 5.15625 4.30734 5.15625 4.125C5.15625 3.94266 5.08382 3.7678 4.95489 3.63886C4.82595 3.50993 4.65109 3.4375 4.46875 3.4375C4.28641 3.4375 4.11155 3.50993 3.98261 3.63886C3.85368 3.7678 3.78125 3.94266 3.78125 4.125C3.78125 4.30734 3.85368 4.4822 3.98261 4.61114C4.11155 4.74007 4.28641 4.8125 4.46875 4.8125ZM6.53125 4.8125C6.71359 4.8125 6.88845 4.74007 7.01739 4.61114C7.14632 4.4822 7.21875 4.30734 7.21875 4.125C7.21875 3.94266 7.14632 3.7678 7.01739 3.63886C6.88845 3.50993 6.71359 3.4375 6.53125 3.4375C6.34891 3.4375 6.17405 3.50993 6.04511 3.63886C5.91618 3.7678 5.84375 3.94266 5.84375 4.125C5.84375 4.30734 5.91618 4.4822 6.04511 4.61114C6.17405 4.74007 6.34891 4.8125 6.53125 4.8125ZM8.59375 4.8125C8.77609 4.8125 8.95095 4.74007 9.07989 4.61114C9.20882 4.4822 9.28125 4.30734 9.28125 4.125C9.28125 3.94266 9.20882 3.7678 9.07989 3.63886C8.95095 3.50993 8.77609 3.4375 8.59375 3.4375C8.41141 3.4375 8.23655 3.50993 8.10761 3.63886C7.97868 3.7678 7.90625 3.94266 7.90625 4.125C7.90625 4.30734 7.97868 4.4822 8.10761 4.61114C8.23655 4.74007 8.41141 4.8125 8.59375 4.8125ZM2.40625 6.875C2.58859 6.875 2.76345 6.80257 2.89239 6.67364C3.02132 6.5447 3.09375 6.36984 3.09375 6.1875C3.09375 6.00516 3.02132 5.8303 2.89239 5.70136C2.76345 5.57243 2.58859 5.5 2.40625 5.5C2.22391 5.5 2.04905 5.57243 1.92011 5.70136C1.79118 5.8303 1.71875 6.00516 1.71875 6.1875C1.71875 6.36984 1.79118 6.5447 1.92011 6.67364C2.04905 6.80257 2.22391 6.875 2.40625 6.875ZM4.46875 6.875C4.65109 6.875 4.82595 6.80257 4.95489 6.67364C5.08382 6.5447 5.15625 6.36984 5.15625 6.1875C5.15625 6.00516 5.08382 5.8303 4.95489 5.70136C4.82595 5.57243 4.65109 5.5 4.46875 5.5C4.28641 5.5 4.11155 5.57243 3.98261 5.70136C3.85368 5.8303 3.78125 6.00516 3.78125 6.1875C3.78125 6.36984 3.85368 6.5447 3.98261 6.67364C4.11155 6.80257 4.28641 6.875 4.46875 6.875ZM6.53125 6.875C6.71359 6.875 6.88845 6.80257 7.01739 6.67364C7.14632 6.5447 7.21875 6.36984 7.21875 6.1875C7.21875 6.00516 7.14632 5.8303 7.01739 5.70136C6.88845 5.57243 6.71359 5.5 6.53125 5.5C6.34891 5.5 6.17405 5.57243 6.04511 5.70136C5.91618 5.8303 5.84375 6.00516 5.84375 6.1875C5.84375 6.36984 5.91618 6.5447 6.04511 6.67364C6.17405 6.80257 6.34891 6.875 6.53125 6.875ZM8.59375 6.875C8.77609 6.875 8.95095 6.80257 9.07989 6.67364C9.20882 6.5447 9.28125 6.36984 9.28125 6.1875C9.28125 6.00516 9.20882 5.8303 9.07989 5.70136C8.95095 5.57243 8.77609 5.5 8.59375 5.5C8.41141 5.5 8.23655 5.57243 8.10761 5.70136C7.97868 5.8303 7.90625 6.00516 7.90625 6.1875C7.90625 6.36984 7.97868 6.5447 8.10761 6.67364C8.23655 6.80257 8.41141 6.875 8.59375 6.875ZM2.40625 8.9375C2.58859 8.9375 2.76345 8.86507 2.89239 8.73614C3.02132 8.6072 3.09375 8.43234 3.09375 8.25C3.09375 8.06766 3.02132 7.8928 2.89239 7.76386C2.76345 7.63493 2.58859 7.5625 2.40625 7.5625C2.22391 7.5625 2.04905 7.63493 1.92011 7.76386C1.79118 7.8928 1.71875 8.06766 1.71875 8.25C1.71875 8.43234 1.79118 8.6072 1.92011 8.73614C2.04905 8.86507 2.22391 8.9375 2.40625 8.9375ZM4.46875 8.9375C4.65109 8.9375 4.82595 8.86507 4.95489 8.73614C5.08382 8.6072 5.15625 8.43234 5.15625 8.25C5.15625 8.06766 5.08382 7.8928 4.95489 7.76386C4.82595 7.63493 4.65109 7.5625 4.46875 7.5625C4.28641 7.5625 4.11155 7.63493 3.98261 7.76386C3.85368 7.8928 3.78125 8.06766 3.78125 8.25C3.78125 8.43234 3.85368 8.6072 3.98261 8.73614C4.11155 8.86507 4.28641 8.9375 4.46875 8.9375ZM6.53125 8.9375C6.71359 8.9375 6.88845 8.86507 7.01739 8.73614C7.14632 8.6072 7.21875 8.43234 7.21875 8.25C7.21875 8.06766 7.14632 7.8928 7.01739 7.76386C6.88845 7.63493 6.71359 7.5625 6.53125 7.5625C6.34891 7.5625 6.17405 7.63493 6.04511 7.76386C5.91618 7.8928 5.84375 8.06766 5.84375 8.25C5.84375 8.43234 5.91618 8.6072 6.04511 8.73614C6.17405 8.86507 6.34891 8.9375 6.53125 8.9375Z" fill="#6F7680"/>
               </g>
               <defs>
               <clipPath id="clip0_8733_6641">
               <rect width="11" height="11" fill="white"/>
               </clipPath>
               </defs>
            </>
         )
      },
      'print-location-warehouse': {
         width: 12,
         height: 9,
         viewBox: [0,0,12,9],
         fill: 'none',
         data: (
            <path d="M6.02659 9C7.89185 9 9.75711 9 11.6188 9C11.9249 9 11.9926 8.93899 11.9961 8.62676C11.9997 8.21764 11.9961 7.80851 11.9961 7.39939C11.9961 7.28454 11.9605 7.2343 11.8431 7.24148C11.7363 7.24866 11.6259 7.25225 11.5191 7.24148C11.3981 7.23071 11.3518 7.27019 11.3554 7.39939C11.3625 7.65419 11.359 7.909 11.3554 8.16022C11.3554 8.39708 11.3376 8.41143 11.1027 8.41502C10.9496 8.41502 10.7965 8.40785 10.6435 8.41502C10.5189 8.4222 10.4833 8.36837 10.4833 8.24635C10.4868 7.96283 10.4833 7.67932 10.4833 7.3958C10.4833 7.28096 10.4477 7.23071 10.3302 7.23789C10.2092 7.24507 10.0846 7.24507 9.96001 7.23789C9.86034 7.2343 9.83542 7.27378 9.83898 7.37068C9.8461 7.66137 9.83898 7.94848 9.8461 8.23917C9.8461 8.36478 9.8105 8.41861 9.6788 8.41861C8.32969 8.41502 6.98413 8.41143 5.63502 8.41502C5.50687 8.41502 5.46416 8.37555 5.46416 8.24276C5.46416 7.02615 5.46416 5.80954 5.46416 4.59293C5.46416 4.45656 5.51399 4.4099 5.6457 4.4099C6.86666 4.4099 8.08407 4.39913 9.30503 4.39555C9.43318 4.39555 9.56133 4.4099 9.68948 4.4099C9.79982 4.4099 9.84966 4.44938 9.8461 4.56781C9.83898 4.82262 9.8461 7.1374 9.83898 7.38862C9.83542 7.4927 9.86746 7.53576 9.97069 7.53217C10.0953 7.52858 10.2163 7.53217 10.3409 7.53217C10.437 7.53217 10.4868 7.49988 10.4833 7.3958C10.4797 7.01538 10.4833 4.57858 10.4797 4.19816C10.4797 4.1228 10.4655 4.04743 10.4441 3.97924C10.3907 3.79621 10.3373 3.76033 10.1451 3.76033C8.56462 3.76391 6.98769 3.77109 5.4072 3.77468C5.31821 3.77468 5.22922 3.77468 5.14023 3.77468C4.97649 3.77468 4.89817 3.83569 4.86258 4.00078C4.84478 4.09409 4.8341 4.1874 4.8341 4.2807C4.8341 5.57268 4.8341 6.86106 4.8341 8.15304C4.8341 8.32769 4.74629 8.41502 4.57068 8.41502C4.42474 8.41502 4.27523 8.40785 4.12929 8.41502C4.00826 8.41861 3.96198 8.37555 3.96198 8.24994C3.9691 8.00949 3.96198 7.77262 3.96198 7.53217C3.96198 6.3048 3.96198 5.08101 3.96198 3.85364C3.96198 3.73162 3.97978 3.63472 4.08657 3.55576C4.96937 2.87389 5.8486 2.18842 6.72784 1.50296C7.00905 1.28404 7.2867 1.06512 7.5608 0.842617C7.62487 0.788784 7.66759 0.781607 7.73878 0.839028C8.53615 1.48143 9.32995 2.12024 10.1344 2.75546C10.4762 3.02462 10.825 3.28301 11.1774 3.53423C11.3056 3.62395 11.3554 3.73162 11.3554 3.88235C11.3518 4.36684 11.3554 6.80006 11.3554 7.28455C11.3554 7.38862 11.3803 7.4281 11.4871 7.42092C11.6153 7.41374 11.7434 7.42092 11.8715 7.42092C11.9463 7.42092 11.989 7.39939 11.989 7.30967C11.989 6.75699 11.9819 4.25199 11.9997 3.69932C12.0068 3.39786 11.8893 3.19688 11.658 3.02103C11.0101 2.53654 10.3765 2.0341 9.73575 1.53885C9.20536 1.12613 8.67853 0.713419 8.14814 0.300705C8.03779 0.214574 7.92744 0.124853 7.81709 0.0351326C7.7459 -0.0222884 7.53232 0.00283328 7.46113 0.0638432C7.29026 0.210985 7.1194 0.361715 6.9343 0.487324C6.88446 0.523212 6.76343 0.508857 6.70648 0.46938C6.51782 0.336593 6.34695 0.182274 6.16897 0.0351326C6.09422 -0.0258773 5.88776 -0.000755534 5.80945 0.0638432C5.6457 0.203807 5.48552 0.354537 5.30753 0.472968C5.24346 0.516034 5.10463 0.519623 5.04056 0.472968C4.8519 0.350949 4.68103 0.200218 4.50661 0.0566656C4.41762 -0.0151108 4.2432 -0.0186996 4.16488 0.0458991C3.94418 0.228929 3.72348 0.40837 3.50279 0.584222C3.01511 0.968225 2.52744 1.35582 2.03621 1.73623C1.47378 2.17048 0.914912 2.60831 0.341807 3.02821C0.110429 3.19688 -0.003479 3.39427 8.10623e-05 3.68855C0.0107594 5.30711 0.00364017 6.92925 0.00720024 8.54781C0.00720024 8.94258 0.0605946 8.99282 0.452158 8.99282C2.3103 8.99282 4.172 8.99282 6.03015 8.99282L6.02659 9ZM1.68024 5.91003C1.68024 6.67803 1.68024 7.44604 1.68024 8.21046C1.68024 8.41861 1.66956 8.4222 1.47378 8.4222C1.26732 8.4222 1.06086 8.4222 0.8544 8.4222C0.6337 8.4222 0.633699 8.4222 0.63014 8.1961C0.63014 7.30967 0.626581 6.42323 0.626581 5.53679C0.626581 4.98052 0.62658 4.42067 0.6337 3.8644C0.6337 3.77468 0.665736 3.65266 0.729811 3.60242C1.08222 3.3189 1.45242 3.05692 1.81551 2.78058C2.41709 2.31762 3.01867 1.85466 3.62026 1.38812C3.82672 1.22662 4.02962 1.06153 4.23252 0.900038C4.31439 0.835439 4.46033 0.871327 4.53865 0.982581C4.61696 1.09025 4.50305 1.12254 4.44966 1.16202C4.2432 1.32352 4.02962 1.47066 3.82316 1.63216C3.20733 2.10947 2.60219 2.60473 1.97569 3.0641C1.74431 3.23277 1.67312 3.43015 1.67312 3.69573C1.67668 4.43143 1.67312 5.17073 1.67312 5.90644L1.68024 5.91003ZM3.32836 5.89208C3.32836 6.67803 3.32836 7.46757 3.32836 8.25353C3.32836 8.37555 3.28565 8.42579 3.16462 8.42579C2.93324 8.4222 2.70186 8.41861 2.47048 8.42579C2.37081 8.42579 2.32098 8.38272 2.32098 8.28583C2.32098 8.13151 2.3281 7.97719 2.3281 7.82287C2.32454 6.54166 2.31742 5.26045 2.3103 3.97924C2.3103 3.80698 2.3281 3.67419 2.50252 3.55576C2.90832 3.27584 3.27853 2.94925 3.66653 2.64779C4.33575 2.12741 5.00852 1.60704 5.67774 1.08666C5.75961 1.02206 5.84148 0.957459 5.92335 0.896449C6.04438 0.810317 6.12626 0.907215 6.18677 0.978992C6.26508 1.06871 6.15829 1.1046 6.1049 1.14408C5.73825 1.42759 5.36805 1.70393 5.0014 1.99104C4.53153 2.3571 4.07233 2.7411 3.59178 3.09639C3.396 3.23995 3.31768 3.40503 3.32124 3.63472C3.3248 4.38837 3.32124 5.13843 3.32124 5.89208H3.32836Z" fill="#6F7680"/>
         )
      },
      'print-location-item': {
         width: 10,
         height: 8,
         viewBox: [0,0,10,8],
         fill: 'none',
         data: (
            <path d="M5.02215 7.5C6.57654 7.5 8.13092 7.5 9.68234 7.5C9.93745 7.5 9.99381 7.44916 9.99678 7.18897C9.99975 6.84803 9.99678 6.50709 9.99678 6.16616C9.99678 6.07045 9.96712 6.02858 9.86922 6.03457C9.78023 6.04055 9.68828 6.04354 9.59928 6.03457C9.49843 6.02559 9.45986 6.05849 9.46283 6.16616C9.46876 6.37849 9.4658 6.59083 9.46283 6.80018C9.46283 6.99757 9.448 7.00953 9.25222 7.01252C9.12466 7.01252 8.99711 7.00654 8.86955 7.01252C8.76573 7.0185 8.73607 6.97364 8.73607 6.87196C8.73903 6.63569 8.73607 6.39943 8.73607 6.16317C8.73607 6.06746 8.7064 6.02559 8.60851 6.03158C8.50765 6.03756 8.40383 6.03756 8.30001 6.03158C8.21695 6.02858 8.19618 6.06148 8.19915 6.14223C8.20508 6.38448 8.19915 6.62373 8.20508 6.86598C8.20508 6.97065 8.17542 7.01551 8.06566 7.01551C6.9414 7.01252 5.82011 7.00953 4.69585 7.01252C4.58906 7.01252 4.55347 6.97962 4.55347 6.86897C4.55347 5.85512 4.55347 4.84128 4.55347 3.82744C4.55347 3.7138 4.595 3.67492 4.70475 3.67492C5.72222 3.67492 6.73672 3.66595 7.75419 3.66295C7.86098 3.66295 7.96777 3.67492 8.07456 3.67492C8.16652 3.67492 8.20805 3.70782 8.20508 3.80651C8.19915 4.01885 8.20508 5.94784 8.19915 6.15718C8.19618 6.24391 8.22288 6.2798 8.30891 6.27681C8.41273 6.27382 8.51359 6.27681 8.61741 6.27681C8.6975 6.27681 8.73903 6.2499 8.73607 6.16317C8.7331 5.84615 8.73607 3.81548 8.7331 3.49847C8.7331 3.43566 8.72123 3.37286 8.70344 3.31604C8.65894 3.16351 8.61444 3.1336 8.45426 3.1336C7.13719 3.1366 5.82308 3.14258 4.506 3.14557C4.43184 3.14557 4.35769 3.14557 4.28353 3.14557C4.14707 3.14557 4.08181 3.19641 4.05215 3.33398C4.03732 3.41174 4.02842 3.4895 4.02842 3.56725C4.02842 4.6439 4.02842 5.71755 4.02842 6.7942C4.02842 6.93975 3.95525 7.01252 3.8089 7.01252C3.68728 7.01252 3.56269 7.00654 3.44107 7.01252C3.34021 7.01551 3.30165 6.97962 3.30165 6.87495C3.30758 6.67457 3.30165 6.47719 3.30165 6.27681C3.30165 5.254 3.30165 4.23418 3.30165 3.21136C3.30165 3.10968 3.31648 3.02893 3.40548 2.96314C4.14114 2.39491 4.87384 1.82369 5.60653 1.25247C5.84088 1.07003 6.07225 0.887603 6.30067 0.702181C6.35406 0.65732 6.38966 0.651339 6.44898 0.69919C7.11345 1.23452 7.77496 1.76686 8.44536 2.29621C8.73013 2.52051 9.02084 2.73584 9.31451 2.94519C9.4213 3.01996 9.46283 3.10968 9.46283 3.23529C9.45986 3.63903 9.46283 5.66671 9.46283 6.07045C9.46283 6.15718 9.48359 6.19008 9.57259 6.1841C9.67938 6.17812 9.78617 6.1841 9.89296 6.1841C9.95525 6.1841 9.99085 6.16616 9.99085 6.09139C9.99085 5.63082 9.98491 3.54333 9.99975 3.08276C10.0057 2.83155 9.90779 2.66407 9.71497 2.51752C9.17509 2.11378 8.64707 1.69509 8.11313 1.28237C7.67113 0.938444 7.23211 0.594516 6.79012 0.250588C6.69816 0.178811 6.6062 0.104044 6.51425 0.0292772C6.45492 -0.0185737 6.27693 0.00236107 6.21761 0.0532027C6.07522 0.175821 5.93283 0.301429 5.77858 0.406103C5.73705 0.43601 5.6362 0.424047 5.58873 0.39115C5.43152 0.280494 5.28913 0.151895 5.14081 0.0292772C5.07852 -0.0215644 4.90647 -0.000629611 4.84121 0.0532027C4.70475 0.169839 4.57126 0.295448 4.42295 0.39414C4.36955 0.430029 4.25386 0.433019 4.20047 0.39414C4.04325 0.292457 3.90086 0.166849 3.75551 0.0472213C3.68135 -0.0125923 3.536 -0.015583 3.47074 0.0382492C3.28682 0.190774 3.1029 0.340308 2.91899 0.486851C2.51259 0.806854 2.1062 1.12985 1.69684 1.44686C1.22815 1.80873 0.762427 2.1736 0.28484 2.52351C0.0920248 2.66407 -0.00289822 2.82856 6.77109e-05 3.07379C0.0089674 4.42259 0.00303459 5.77438 0.00600052 7.12317C0.00600052 7.45215 0.0504961 7.49402 0.376799 7.49402C1.92525 7.49402 3.47667 7.49402 5.02512 7.49402L5.02215 7.5ZM1.4002 4.92502C1.4002 5.56503 1.4002 6.20504 1.4002 6.84205C1.4002 7.01551 1.3913 7.0185 1.22815 7.0185C1.0561 7.0185 0.88405 7.0185 0.712 7.0185C0.528085 7.0185 0.528084 7.0185 0.525117 6.83009C0.525117 6.09139 0.522151 5.35269 0.522151 4.61399C0.522151 4.15044 0.522151 3.68389 0.528084 3.22033C0.528084 3.14557 0.554781 3.04388 0.608176 3.00201C0.901848 2.76575 1.21035 2.54743 1.51292 2.31715C2.01424 1.93135 2.51556 1.54555 3.01688 1.15676C3.18893 1.02218 3.35801 0.884612 3.5271 0.750032C3.59532 0.696199 3.71695 0.726106 3.78221 0.818817C3.84747 0.908538 3.75254 0.935454 3.70805 0.968351C3.536 1.10293 3.35801 1.22555 3.18596 1.36013C2.67278 1.75789 2.16849 2.17061 1.64641 2.55341C1.4536 2.69397 1.39427 2.85846 1.39427 3.07977C1.39723 3.69286 1.39427 4.30894 1.39427 4.92203L1.4002 4.92502ZM2.77364 4.91007C2.77364 5.56503 2.77364 6.22298 2.77364 6.87794C2.77364 6.97962 2.73804 7.02149 2.63718 7.02149C2.44437 7.0185 2.25155 7.01551 2.05874 7.02149C1.97568 7.02149 1.93415 6.9856 1.93415 6.90485C1.93415 6.77626 1.94008 6.64766 1.94008 6.51906C1.93712 5.45138 1.93118 4.38371 1.92525 3.31604C1.92525 3.17248 1.94008 3.06183 2.08543 2.96314C2.4236 2.72986 2.73211 2.45771 3.05544 2.20649C3.61312 1.77284 4.17377 1.3392 4.73145 0.905547C4.79968 0.851715 4.8679 0.797882 4.93613 0.747041C5.03699 0.675264 5.10521 0.756013 5.15564 0.815827C5.2209 0.890594 5.13191 0.9205 5.08741 0.953398C4.78188 1.18966 4.47337 1.41994 4.16784 1.6592C3.77627 1.96425 3.39361 2.28425 2.99315 2.58033C2.83 2.69996 2.76474 2.83753 2.7677 3.02893C2.77067 3.65697 2.7677 4.28203 2.7677 4.91007H2.77364Z" fill="#0B0B0B"/>
         )
      },
      'print-serial-number-item': {
         width: 10,
         height: 6,
         viewBox: [0,0,10,6],
         fill: 'none',
         data: (
            <>
               <g clip-path="url(#clip0_8736_7013)">
               <path d="M9.2381 0.773196V5.2268H0.761905V0.773196H9.2381ZM9.2381 0H0.761905C0.342857 0 0 0.347938 0 0.773196V5.2268C0 5.65206 0.342857 6 0.761905 6H9.2381C9.65714 6 10 5.65206 10 5.2268V0.773196C10 0.347938 9.65714 0 9.2381 0Z" fill="black"/>
               <path d="M2 4H8" stroke="black" stroke-width="0.853846" stroke-linecap="round" stroke-linejoin="round"/>
               </g>
               <defs>
               <clipPath id="clip0_8736_7013">
               <rect width="10" height="6" fill="white"/>
               </clipPath>
               </defs>
            </>
         )
      },
      'print-barcode-item': {
         width: 10,
         height: 10,
         viewBox: [0,0,10,10],
         fill: 'none',
         data: (
            <>
               <g clip-path="url(#clip0_8736_7019)">
               <path d="M3.2806 0.348999H0.348999V3.2806" stroke="black" stroke-width="0.853846" stroke-linecap="round" stroke-linejoin="round"/>
               <path d="M9.65096 3.2806V0.348999H6.71936" stroke="black" stroke-width="0.853846" stroke-linecap="round" stroke-linejoin="round"/>
               <path d="M6.71936 9.65099H9.65096V6.71939" stroke="black" stroke-width="0.853846" stroke-linecap="round" stroke-linejoin="round"/>
               <path d="M0.348999 6.71939V9.65099H3.2806" stroke="black" stroke-width="0.853846" stroke-linecap="round" stroke-linejoin="round"/>
               <path d="M1.82422 5.24428V8.03162" stroke="black" stroke-width="0.569231" stroke-linecap="round" stroke-linejoin="round"/>
               <path d="M2.80127 5.24428V8.03162" stroke="black" stroke-width="0.569231" stroke-linecap="round" stroke-linejoin="round"/>
               <path d="M4.02515 5.36066V7.88741" stroke="black" stroke-width="0.853846" stroke-linecap="round" stroke-linejoin="round"/>
               <path d="M3.86221 2.07074H2.23355C2.1436 2.07074 2.07068 2.14366 2.07068 2.23361V3.86227C2.07068 3.95222 2.1436 4.02514 2.23355 4.02514H3.86221C3.95216 4.02514 4.02508 3.95222 4.02508 3.86227V2.23361C4.02508 2.14366 3.95216 2.07074 3.86221 2.07074Z" stroke="black" stroke-width="0.853846" stroke-miterlimit="10" stroke-linecap="round"/>
               <path d="M7.77115 5.97951H6.14248C6.05253 5.97951 5.97961 6.05242 5.97961 6.14237V7.77104C5.97961 7.86099 6.05253 7.9339 6.14248 7.9339H7.77115C7.86109 7.9339 7.93401 7.86099 7.93401 7.77104V6.14237C7.93401 6.05242 7.86109 5.97951 7.77115 5.97951Z" stroke="black" stroke-width="0.853846" stroke-miterlimit="10" stroke-linecap="round"/>
               <path d="M5.73291 1.96837V4.55562" stroke="black" stroke-width="0.569231" stroke-linecap="round" stroke-linejoin="round"/>
               <path d="M8.1759 1.96837V4.55562" stroke="black" stroke-width="0.569231" stroke-linecap="round" stroke-linejoin="round"/>
               <path d="M6.95679 2.07074V4.43928" stroke="black" stroke-width="0.853846" stroke-linecap="round" stroke-linejoin="round"/>
               </g>
               <defs>
               <clipPath id="clip0_8736_7019">
               <rect width="10" height="10" fill="white"/>
               </clipPath>
               </defs>
            </>
         )
      },
      'print-id-item': {
         width: 10,
         height: 10,
         viewBox: [0,0,10,10],
         fill: 'none',
         data: (
            <path d="M9.99781 1.87821L9.8399 0.499675C9.8195 0.321362 9.6789 0.181259 9.50059 0.160371L8.12204 0.00245739C8.00542 -0.0107767 7.88869 0.0299202 7.8056 0.113006L3.81084 4.10773C2.77509 3.81886 1.64758 4.10723 0.879347 4.876C0.312255 5.44309 0 6.19653 0 6.99833C0 7.80023 0.312357 8.55378 0.879347 9.12066C1.44644 9.68765 2.20038 10 3.0017 10C3.80361 10 4.55717 9.68765 5.12406 9.12066C5.89285 8.35188 6.18121 7.22499 5.89234 6.1892L6.64839 5.43315C6.72073 5.36081 6.76153 5.263 6.76153 5.16061V4.46677H7.45538C7.55777 4.46677 7.65559 4.42597 7.72792 4.35363L8.17162 3.90994C8.24396 3.8376 8.28476 3.73979 8.28476 3.6374V2.94356H8.97861C9.081 2.94356 9.17881 2.90276 9.25115 2.83042L9.88699 2.19459C9.97008 2.1115 10.0108 1.99488 9.99754 1.87816L9.99781 1.87821ZM8.81936 2.17215H7.89922C7.68628 2.17215 7.51353 2.34489 7.51353 2.55784V3.47796L7.29551 3.69598H6.37538C6.16244 3.69598 5.98969 3.86871 5.98969 4.08167V5.00179L5.1796 5.81186C5.07313 5.91833 5.03801 6.07783 5.09094 6.21892C5.39512 7.03557 5.19383 7.96076 4.57788 8.57671C4.15657 8.99801 3.59664 9.22987 3.00051 9.22987C2.40437 9.22987 1.84454 8.99802 1.42313 8.57671C1.00172 8.1554 0.769966 7.59548 0.769966 6.99935C0.769966 6.40322 1.00182 5.8434 1.42313 5.42199C1.84852 4.99661 2.42119 4.76934 3.004 4.76934C3.26541 4.76934 3.52819 4.81522 3.78094 4.90895C3.92254 4.96139 4.08155 4.92676 4.18801 4.82029L8.21792 0.790417L9.10751 0.89231L9.2094 1.78189L8.81816 2.17313L8.81936 2.17215ZM2.91102 7.7727C3.06127 7.92295 3.06127 8.16754 2.91102 8.31778C2.8356 8.3932 2.73679 8.43092 2.63848 8.43092C2.53967 8.43092 2.44136 8.3932 2.36594 8.31778L1.68223 7.63408C1.53197 7.48383 1.53197 7.23924 1.68223 7.089C1.83248 6.93875 2.07707 6.93875 2.22731 7.089L2.91102 7.7727Z" fill="black"/>
         )
      },
      'print-custom-text-item': {
         width: 10,
         height: 7,
         viewBox: [0,0,10,7],
         fill: 'none',
         data: (
            <>
               <mask id="path-1-inside-1_8736_7034" fill="white">
               <rect width="10" height="6.25" rx="0.341538"/>
               </mask>
               <rect width="10" height="6.25" rx="0.341538" stroke="black" stroke-width="1.70769" mask="url(#path-1-inside-1_8736_7034)"/>
               <line x1="2.30205" y1="1.67692" x2="2.30205" y2="4.57308" stroke="black" stroke-width="0.853846" stroke-linecap="round"/>
            </>
         )
      },
      'print-due-back-to': {
         width: 13,
         height: 15,
         viewBox: [0,0,13,15],
         fill: 'none',
         data: (
            <>
               <path d="M10.4211 9.32931V9.44115L10.4768 9.54181L11.5975 11.5773C11.5975 11.5773 11.6031 11.6109 11.5975 11.6277C11.5975 11.6333 11.5863 11.6389 11.5863 11.6389H11.5808H0.625065C0.625065 11.6389 0.625065 11.6389 0.61949 11.6389C0.61949 11.6389 0.613914 11.6389 0.608339 11.6277C0.597188 11.6165 0.597188 11.5941 0.608339 11.5773L1.729 9.54181L1.78475 9.44115V4.38028C1.78475 2.28323 3.73615 0.599998 6.10571 0.599998C8.47526 0.599998 10.4267 2.28323 10.4267 4.38028V9.32931H10.4211Z" stroke="#6F7680" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
               <path d="M4.72302 14.0268H7.47728" stroke="#6F7680" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
            </> 
         )
      },
      'print-location-pin': {
         width: 13,
         height: 15,
         viewBox: [0,0,13,15],
         fill: 'none',
         data: (
            <>
               <path d="M11.6 5.77922C11.6 9.78494 6.09998 13.9091 6.09998 13.9091C6.09998 13.9091 0.599976 9.78494 0.599976 5.77922C0.599976 3.22911 3.0605 0.600002 6.09998 0.600002C9.13945 0.600002 11.6 3.22911 11.6 5.77922Z" stroke="#6F7680" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
               <path d="M6.09978 8.04731C7.24766 8.04731 8.1782 7.14049 8.1782 6.02188C8.1782 4.90327 7.24766 3.99646 6.09978 3.99646C4.9519 3.99646 4.02136 4.90327 4.02136 6.02188C4.02136 7.14049 4.9519 8.04731 6.09978 8.04731Z" stroke="#6F7680" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
            </>
         )
      },
      'print-comment': {
         width: 12,
         height: 12,
         viewBox: [0,0,12,12],
         fill: 'none',
         data: (
            <>
               <path d="M2.81362 9.47194H1.32301C0.82913 9.47194 0.425049 9.06786 0.425049 8.57398V1.32296C0.425049 0.829085 0.82913 0.425003 1.32301 0.425003H10.5271C11.021 0.425003 11.425 0.829085 11.425 1.32296V8.57398C11.425 9.06786 11.021 9.47194 10.5271 9.47194H7.50097L5.90709 11.3711L4.64546 9.47194H2.80913H2.81362Z" stroke="black" stroke-width="0.85" stroke-linecap="round" stroke-linejoin="round"/>
               <path d="M3.33447 3.88669H8.25529" stroke="black" stroke-width="0.85" stroke-miterlimit="10" stroke-linecap="round"/>
               <path d="M3.33447 6.01035H8.25529" stroke="black" stroke-width="0.85" stroke-miterlimit="10" stroke-linecap="round"/>
            </>
         )
      },
      'sharemytoolbox-print-logo': {
         width: 55, 
         height: 25,
         viewBox: [0,0,55,25],
         fill: 'none',
         data: (
            <>
               <g clip-path="url(#clip0_8733_6661)">
               <path d="M6.39314 9.936L7.7475 11.6495L7.7465 11.651C7.76646 11.6705 8.38153 12.5535 9.95788 12.9445C12.3503 13.5385 15.523 12.9465 16.2363 12.624V11.6495L17.902 13.7335H18.8393L18.3983 13.1825L17.1722 11.65L17.5443 11.185L18.8393 9.567H6.10132L6.39314 9.9365V9.936Z" fill="black"/>
               <path d="M16.2354 16.142V15.176C12.6831 15.447 10.6099 14.9625 9.40324 14.2735H5.97119V17.14C5.97119 17.7435 6.45906 18.2325 7.06116 18.2325H17.8806C18.4827 18.2325 18.9706 17.7435 18.9706 17.14V14.2735H17.917L16.2354 16.142Z" fill="black"/>
               <path d="M7.74552 11.652L6.10083 13.733H8.6574C7.61831 12.7705 7.73654 11.6975 7.74552 11.652Z" fill="black"/>
               <path d="M19.9537 0H4.98844C2.23332 0 0 2.2385 0 5V20C0 22.7615 2.23332 25 4.98844 25H19.9537C22.7089 25 24.9422 22.7615 24.9422 20V5C24.9422 2.2385 22.7089 0 19.9537 0ZM19.5103 13.709V17.141C19.5103 18.0405 18.7805 18.772 17.883 18.772H7.06063C6.16321 18.772 5.4334 18.0405 5.4334 17.141V13.7105L7.06263 11.649L5.3935 9.5375L5.89982 7.1645C6.03501 6.5315 6.6017 6.071 7.2477 6.069L9.07945 6.0645L9.26851 5.129L9.2725 5.114C9.41717 4.564 9.82871 4.505 9.99932 4.505H14.9454C15.116 4.505 15.528 4.5645 15.6722 5.1145L15.6747 5.1245L15.8852 6.072L17.5229 6.0755C18.2976 6.0755 18.9481 6.6065 19.1037 7.3665L19.5497 9.5415L17.8631 11.649L19.5108 13.7085L19.5103 13.709Z" fill="black"/>
               <path d="M17.5194 6.616L15.4527 6.6115L15.1509 5.254C15.1135 5.111 15.0581 5.046 14.9434 5.046H9.99884C9.88411 5.046 9.82874 5.111 9.79132 5.254L9.51846 6.604L7.24922 6.6095C6.85164 6.6105 6.50843 6.8895 6.42562 7.279L6.05249 9.0275L18.8927 9.026L18.575 7.4765C18.4707 6.9685 18.0367 6.616 17.5194 6.616ZM10.5531 6.604L10.6613 6.069C10.6867 5.9725 10.7242 5.9285 10.8015 5.9285H14.1407C14.2181 5.9285 14.2555 5.9725 14.2809 6.069L14.3892 6.604H10.5531Z" fill="black"/>
               <path d="M29.371 8.55C28.8228 8.55 28.2272 8.36 27.8077 8.082L27.3677 9.0725C27.8141 9.3845 28.5859 9.595 29.364 9.595C30.7718 9.595 31.4617 8.8895 31.4617 8.062C31.4617 6.312 28.7754 6.8545 28.7754 6.129C28.7754 5.8915 28.9784 5.7015 29.5401 5.7015C29.9527 5.7015 30.3996 5.8235 30.8531 6.068L31.2661 5.071C30.7992 4.7995 30.1632 4.6575 29.5471 4.6575C28.1394 4.6575 27.4495 5.3495 27.4495 6.197C27.4495 7.9605 30.1427 7.411 30.1427 8.164C30.1427 8.3945 29.9262 8.5505 29.3715 8.5505L29.371 8.55Z" fill="black"/>
               <path d="M33.1676 7.7225C33.1676 7.112 33.4859 6.8545 33.8984 6.8545C34.2706 6.8545 34.5005 7.0785 34.5005 7.6075V9.5H35.786V7.3975C35.786 6.258 35.1296 5.763 34.2701 5.763C33.8371 5.763 33.4515 5.8985 33.1671 6.163V4.4675H31.8816V9.5005H33.1671V7.7235L33.1676 7.7225Z" fill="black"/>
               <path d="M37.9451 9.5605C38.4255 9.5605 38.7842 9.425 39.0276 9.133V9.4995H40.2523V5.823H38.9667V6.142C38.7163 5.8845 38.3711 5.762 37.9451 5.762C36.9504 5.762 36.1448 6.488 36.1448 7.6545C36.1448 8.821 36.9499 9.5605 37.9451 9.5605ZM38.216 6.7865C38.649 6.7865 38.9872 7.0985 38.9872 7.6545C38.9872 8.2105 38.649 8.5365 38.216 8.5365C37.783 8.5365 37.4443 8.2175 37.4443 7.6545C37.4443 7.0915 37.7825 6.7865 38.216 6.7865Z" fill="black"/>
               <path d="M43.3994 6.922V5.762C42.8582 5.762 42.4317 5.9315 42.1678 6.264V5.823H40.9431V9.4995H42.2286V7.8105C42.2286 7.166 42.5873 6.9015 43.1086 6.9015C43.2034 6.9015 43.2847 6.9085 43.3994 6.922Z" fill="black"/>
               <path d="M45.6801 9.5605C46.377 9.5605 46.8913 9.357 47.2365 8.9635L46.5665 8.258C46.3161 8.475 46.0792 8.577 45.7205 8.577C45.3144 8.577 45.0301 8.4345 44.8879 8.136L47.5069 7.634C47.4999 6.4335 46.6134 5.762 45.5579 5.762C44.3941 5.762 43.5276 6.549 43.5276 7.6545C43.5276 8.76 44.3736 9.5605 45.6796 9.5605H45.6801ZM45.5649 6.678C45.9235 6.678 46.1874 6.8815 46.2752 7.1865L44.7867 7.478C44.8271 6.9555 45.1249 6.6775 45.5649 6.6775V6.678Z" fill="black"/>
               <path d="M30.4085 12.852L28.7438 10.112H27.6409V14.86H28.879V12.4115L30.0902 14.392H30.6858L31.904 12.3435L31.9175 14.86H33.1491L33.1356 10.112H32.0327L30.4085 12.852Z" fill="black"/>
               <path d="M34.4826 15.2195C34.2796 15.2195 34.0631 15.138 33.9144 15.0025L33.4679 15.9045C33.7114 16.108 34.1449 16.237 34.5305 16.237C35.2548 16.237 35.796 15.959 36.1816 15.0095L37.765 11.184H36.5403L35.6334 13.429L34.7335 11.184H33.4141L34.9839 14.908C34.8757 15.125 34.7335 15.22 34.4831 15.22L34.4826 15.2195Z" fill="black"/>
               <path d="M31.8835 15.724H27.6409V16.789H29.0955V20.472H30.4354V16.789H31.8835V15.724Z" fill="black"/>
               <path d="M33.2509 16.735C32.0532 16.735 31.1802 17.522 31.1802 18.6275C31.1802 19.733 32.0532 20.5335 33.2509 20.5335C34.4486 20.5335 35.3216 19.74 35.3216 18.6275C35.3216 17.515 34.4621 16.735 33.2509 16.735ZM33.2509 19.509C32.8179 19.509 32.4792 19.19 32.4792 18.627C32.4792 18.064 32.8174 17.759 33.2509 17.759C33.6844 17.759 34.0221 18.071 34.0221 18.627C34.0221 19.183 33.6904 19.509 33.2509 19.509Z" fill="black"/>
               <path d="M37.6222 16.735C36.4245 16.735 35.5515 17.522 35.5515 18.6275C35.5515 19.733 36.4245 20.5335 37.6222 20.5335C38.8199 20.5335 39.6929 19.74 39.6929 18.6275C39.6929 17.515 38.8334 16.735 37.6222 16.735ZM37.6222 19.509C37.1892 19.509 36.8505 19.19 36.8505 18.627C36.8505 18.064 37.1887 17.759 37.6222 17.759C38.0557 17.759 38.3934 18.071 38.3934 18.627C38.3934 19.183 38.0617 19.509 37.6222 19.509Z" fill="black"/>
               <path d="M41.8379 19.536C41.5875 19.536 41.4388 19.3935 41.4388 19.1155V15.439H40.1533V19.183C40.1533 20.065 40.6946 20.533 41.581 20.533C41.784 20.533 41.9736 20.506 42.1831 20.438L42.1287 19.468C42.0609 19.502 41.9462 19.536 41.8379 19.536Z" fill="black"/>
               <path d="M44.8157 16.735C44.3892 16.735 44.0445 16.857 43.7941 17.115V15.4395H42.5085V20.4725H43.7332V20.106C43.9766 20.3975 44.3353 20.5335 44.8157 20.5335C45.8104 20.5335 46.616 19.801 46.616 18.6275C46.616 17.454 45.8109 16.735 44.8157 16.735ZM44.5448 19.509C44.1118 19.509 43.7736 19.19 43.7736 18.627C43.7736 18.064 44.1118 17.759 44.5448 17.759C44.9778 17.759 45.3165 18.071 45.3165 18.627C45.3165 19.183 44.9783 19.509 44.5448 19.509Z" fill="black"/>
               <path d="M48.9166 16.735C47.7189 16.735 46.8459 17.522 46.8459 18.6275C46.8459 19.733 47.7189 20.5335 48.9166 20.5335C50.1144 20.5335 50.9873 19.74 50.9873 18.6275C50.9873 17.515 50.1278 16.735 48.9166 16.735ZM48.9166 19.509C48.4836 19.509 48.1449 19.19 48.1449 18.627C48.1449 18.064 48.4831 17.759 48.9166 17.759C49.3501 17.759 49.6879 18.071 49.6879 18.627C49.6879 19.183 49.3561 19.509 48.9166 19.509Z" fill="black"/>
               <path d="M53.5993 18.5865L54.9527 16.796H53.5923L52.9159 17.725L52.2664 16.796H50.8182L52.1716 18.634L50.7773 20.472H52.1716L52.8755 19.509L53.5315 20.472H55.0001L53.5993 18.5865Z" fill="black"/>
               </g>
               <defs>
               <clipPath id="clip0_8733_6661">
               <rect width="55" height="25" fill="white"/>
               </clipPath>
               </defs>
            </>
         )
      },
      'print-loan': {
         height: 20,
         width: 20,
         viewBox: [0,0,20,20],
         fill: 'none',
         data: (
            <>
               <circle cx="9.5" cy="9.5" r="9.5" fill="#FFD600"/>
               <path d="M5.69336 11.3067H11.38V13.5133L15.7467 10.0867L11.38 6.65999V8.84666H5.69336" stroke="black" stroke-width="0.95" stroke-linecap="round" stroke-linejoin="round"/>
               <path d="M7.05992 14.1867H6.52658C5.86658 14.1867 5.33325 13.66 5.33325 13.02V7.16667C5.33325 6.52 5.86658 6 6.52658 6H7.05992" stroke="black" stroke-width="0.95" stroke-miterlimit="10" stroke-linecap="round"/>
            </>
         )
      },
      'print-transfer-return': {
         height: 20,
         width: 20,
         viewBox: [0,0,20,20],
         fill: 'none',
         data: (
            <>
               <g clip-path="url(#clip0_8736_8150)">
               <circle cx="10" cy="10" r="10" fill="#FFD600"/>
               <path d="M9.74011 10H7.47344V8.12L3.44678 11.28L7.47344 14.44V12.5667H9.74011" stroke="black" stroke-width="0.95" stroke-linecap="round" stroke-linejoin="round"/>
               <path d="M10.8133 12.5667H8" stroke="black" stroke-width="0.95" stroke-linecap="round" stroke-linejoin="round"/>
               <path d="M11.36 10H8" stroke="black" stroke-width="0.95" stroke-linecap="round" stroke-linejoin="round"/>
               <path d="M10.26 10H12.5267V11.88L16.5533 8.72L12.5267 5.56V7.43333H10.26" stroke="black" stroke-width="0.95" stroke-linecap="round" stroke-linejoin="round"/>
               <path d="M9.20679 7.43333H12.0001" stroke="black" stroke-width="0.95" stroke-linecap="round" stroke-linejoin="round"/>
               <path d="M8.63989 10H11.9999" stroke="black" stroke-width="0.95" stroke-linecap="round" stroke-linejoin="round"/>
               </g>
               <defs>
               <clipPath id="clip0_8736_8150">
               <rect width="20" height="20" rx="10" fill="white"/>
               </clipPath>
               </defs>           
            </>
         )
      },
      'smart-audit-location-pin': {
         width: 15,
         height: 18,
         viewBox: [0,0,15,18],
         fill: 'none',
         data: (
            <>
               <path d="M14.5 7.09174C14.5 12.1899 7.5 17.4389 7.5 17.4389C7.5 17.4389 0.5 12.1899 0.5 7.09174C0.5 3.84613 3.63158 0.5 7.5 0.5C11.3684 0.5 14.5 3.84613 14.5 7.09174Z" stroke="#6F7680" stroke-linecap="round" stroke-linejoin="round"/>
               <path d="M7.49976 9.97838C8.96069 9.97838 10.145 8.82425 10.145 7.40057C10.145 5.97688 8.96069 4.82275 7.49976 4.82275C6.03882 4.82275 4.85449 5.97688 4.85449 7.40057C4.85449 8.82425 6.03882 9.97838 7.49976 9.97838Z" stroke="#6F7680" stroke-linecap="round" stroke-linejoin="round"/>
            </>
         )
      },
      'smart-audit-toolbox': {
         width: 14,
         height: 14,
         viewBox: [0,0,14,14],
         fill: 'none',
         data: (
            <>
               <g clip-path="url(#clip0_7827_12589)">
               <path d="M13.4671 10.0396V12.3721C13.4671 12.9752 12.9768 13.4663 12.3746 13.4663H1.62546C1.02325 13.4663 0.532959 12.9752 0.532959 12.3721V10.0396C0.532959 9.90087 0.586252 9.77277 0.676849 9.67136L2.44084 7.74456C2.62203 7.54708 2.63269 7.24818 2.46749 7.04002L1.03391 5.23064C0.911337 5.07586 0.879362 4.86236 0.959301 4.68089L1.71073 2.89286C1.71073 2.89286 1.82797 2.55127 2.35024 2.55127H11.7138C12.1827 2.55127 12.3426 2.86084 12.3426 2.86084L13.0727 4.68623C13.1473 4.8677 13.1154 5.07586 12.9928 5.23064L11.5486 7.04536C11.3834 7.25352 11.394 7.55241 11.5752 7.75523L13.3339 9.68204C13.4245 9.78345 13.4778 9.91154 13.4778 10.0503L13.4671 10.0396Z" stroke="#6F7680" stroke-miterlimit="10"/>
               <path d="M0.831421 4.96924H13.1793" stroke="#6F7680" stroke-miterlimit="10"/>
               <path d="M0.532959 9.82617H13.4671" stroke="#6F7680" stroke-miterlimit="10"/>
               <path d="M4.55115 2.19366L5.11605 0.832619C5.22797 0.651148 5.45712 0.539062 5.70227 0.539062H8.28697C8.53744 0.539062 8.76127 0.651148 8.87319 0.832619L9.43809 2.19366" stroke="#6F7680" stroke-miterlimit="10"/>
               </g>
               <defs>
               <clipPath id="clip0_7827_12589">
               <rect width="14" height="14" fill="white"/>
               </clipPath>
               </defs>
            </>
         )
      },
      'repeating-contract': {
         width: 22,
         height: 22,
         viewBox: [0,0,22,22],
         fill: 'none',
         data: (
            <path d="M10.5464 1.70923C10.5464 1.70923 10.5887 1.70923 10.6056 1.73462L13.3281 4.45923C13.3281 4.45923 13.3535 4.49308 13.3535 4.51846C13.3535 4.54385 13.3535 4.56077 13.3281 4.57769L10.6056 7.30231C10.6056 7.30231 10.5717 7.32769 10.5464 7.32769C10.5379 7.32769 10.5295 7.32769 10.5126 7.32769C10.4787 7.31923 10.4618 7.28538 10.4618 7.25154V5.57615C8.77926 5.58462 6.94449 6.04154 5.85378 7.15C6.80921 5.29692 8.31423 3.74 10.4618 3.46923V1.78538C10.4618 1.78538 10.4787 1.72615 10.5126 1.70923C10.521 1.70923 10.5295 1.70923 10.5464 1.70923ZM14.8585 5.87231C16.7102 6.82846 18.2659 8.33461 18.5365 10.4838H20.2191C20.2191 10.4838 20.2783 10.5008 20.2952 10.5346C20.3036 10.5685 20.2952 10.6023 20.2783 10.6192L17.5557 13.3438C17.5557 13.3438 17.5219 13.3692 17.4965 13.3692C17.4711 13.3692 17.4542 13.3692 17.4373 13.3438L14.7148 10.6192C14.7148 10.6192 14.6894 10.56 14.6979 10.5346C14.7063 10.5008 14.7401 10.4838 14.774 10.4838H16.4481C16.4396 8.8 15.983 6.96385 14.8754 5.87231M4.50096 8.65615C4.50096 8.65615 4.54323 8.65615 4.56014 8.68154L7.2827 11.4062C7.2827 11.4062 7.30806 11.4654 7.29961 11.4908C7.29115 11.5246 7.25733 11.5415 7.22351 11.5415H5.54939C5.55785 13.2254 6.01443 15.0615 7.12205 16.1531C5.27037 15.1969 3.71463 13.6908 3.44406 11.5415H1.76149C1.76149 11.5415 1.7023 11.5246 1.68539 11.4908C1.67694 11.4569 1.68539 11.4231 1.7023 11.4062L4.42486 8.68154C4.42486 8.68154 4.45868 8.65615 4.48405 8.65615M11.4426 14.7062C11.4426 14.7062 11.4595 14.7062 11.4764 14.7062C11.5103 14.7146 11.5272 14.7485 11.5272 14.7823V16.4577C13.2098 16.4492 15.0445 15.9923 16.1352 14.8838C15.1798 16.7369 13.6748 18.2938 11.5272 18.5646V20.2485C11.5272 20.2485 11.5103 20.3077 11.4764 20.3246C11.468 20.3246 11.4595 20.3246 11.4426 20.3246C11.4257 20.3246 11.4004 20.3246 11.3834 20.2992L8.66089 17.5746C8.66089 17.5746 8.63552 17.5408 8.63552 17.5154C8.63552 17.49 8.63552 17.4731 8.66089 17.4562L11.3834 14.7315C11.3834 14.7315 11.4173 14.7062 11.4426 14.7062ZM10.5464 0.0169231C10.3266 0.0169231 10.0729 0.0676924 9.86997 0.152308C9.21047 0.423077 8.77926 1.06615 8.77926 1.78538V2.14077C6.96986 2.80077 5.45639 4.23923 4.35722 6.36308C4.25576 6.56615 4.19657 6.77769 4.1712 6.98923C3.82454 7.05692 3.50325 7.21769 3.24959 7.47154L0.518582 10.2046C0.0112734 10.7123 -0.140919 11.4654 0.138101 12.1338C0.408665 12.7938 1.05126 13.2254 1.7784 13.2254H2.13351C2.79302 15.0362 4.23039 16.5508 6.35263 17.6508C6.55556 17.7523 6.76693 17.8115 6.97831 17.8369C7.04595 18.1838 7.21506 18.5054 7.46871 18.7592L10.1913 21.4838C10.5126 21.8138 10.9776 22 11.4426 22C11.6625 22 11.9161 21.9492 12.119 21.8646C12.787 21.5938 13.2182 20.9508 13.2182 20.2231V19.8677C15.0276 19.2077 16.5411 17.7692 17.6403 15.6454C17.7417 15.4423 17.8009 15.2308 17.8263 15.0192C18.1729 14.9515 18.4942 14.7908 18.7479 14.5369L21.4789 11.8038C21.9862 11.3046 22.1384 10.5431 21.8678 9.87462C21.5973 9.20615 20.9547 8.77462 20.2275 8.77462H19.8724C19.2129 6.96385 17.7755 5.44923 15.6533 4.34923C15.4504 4.24769 15.239 4.18846 15.0276 4.16308C14.96 3.81615 14.7909 3.49462 14.5372 3.24077L11.8147 0.516154C11.4849 0.186154 11.0283 0 10.5633 0L10.5464 0.0169231ZM10.5464 9.02C11.0199 9.02 11.468 8.83385 11.7977 8.50385L13.4634 6.83692C13.5226 6.92154 13.5902 7.00615 13.6748 7.08231C14.0637 7.46308 14.3597 8.07231 14.5457 8.80846C13.92 8.88461 13.3789 9.29923 13.1337 9.89154C12.8631 10.5515 13.0153 11.3131 13.5226 11.8208L15.1883 13.4877C15.1037 13.5469 15.0192 13.6146 14.9431 13.6992C14.5626 14.0885 13.9538 14.3846 13.2182 14.5708C13.1421 13.9446 12.7363 13.4031 12.136 13.1577C11.933 13.0731 11.6794 13.0223 11.4595 13.0223C10.9861 13.0223 10.5379 13.2085 10.2082 13.5385L8.54251 15.2054C8.48333 15.1208 8.41569 15.0362 8.33114 14.96C7.9422 14.5792 7.64627 13.97 7.46026 13.2338C8.08594 13.1577 8.62707 12.7515 8.87226 12.1508C9.14283 11.4908 8.99909 10.7292 8.48333 10.2215L6.81767 8.55462C6.90222 8.49539 6.98677 8.42769 7.06286 8.34308C7.44335 7.95385 8.05212 7.65769 8.78771 7.47154C8.86381 8.09769 9.26966 8.63923 9.86997 8.88462C10.0729 8.96923 10.3266 9.02 10.5464 9.02Z" fill="#1A4D80"/>
         )
      },
      'repeating-contract-filled': {
         width: 22,
         height: 22,
         viewBox: [0,0,22,22],
         fill: 'none',
         data: (
            <>
               <g transform="scale(0.916666666)">
                  <path d="M23.9201 11.05C23.7501 10.64 23.3501 10.37 22.9101 10.37H21.7501C21.1901 8.18 19.5701 6.34 17.0301 5.03L15.7901 4.39C15.7901 4.39 15.7901 4.34 15.7901 4.32C15.7901 4.03 15.6701 3.75 15.4701 3.55L12.2401 0.32C12.0401 0.12 11.7601 0 11.4701 0H11.2701L11.0501 0.08C10.6401 0.25 10.3701 0.65 10.3701 1.09V2.25C8.18006 2.81 6.34006 4.43 5.03006 6.97L4.39006 8.21C4.39006 8.21 4.34006 8.21 4.32006 8.21C4.03006 8.21 3.75006 8.32 3.55006 8.53L0.320058 11.76C0.0100583 12.07 -0.0899417 12.54 0.0800583 12.95C0.250058 13.36 0.650058 13.63 1.09006 13.63H2.25006C2.81006 15.82 4.43006 17.66 6.97006 18.97L8.21006 19.62C8.21006 19.62 8.21006 19.67 8.21006 19.69C8.21006 19.98 8.32006 20.26 8.53006 20.46L11.7501 23.68C11.9501 23.88 12.2301 24 12.5201 24H12.7201L12.9401 23.92C13.3501 23.75 13.6201 23.35 13.6201 22.91V21.75C15.8101 21.19 17.6501 19.57 18.9601 17.03L19.6001 15.79C19.6001 15.79 19.6501 15.79 19.6701 15.79C19.9601 15.79 20.2301 15.68 20.4401 15.47L23.6701 12.24C23.9801 11.93 24.0801 11.46 23.9101 11.05H23.9201ZM13.6201 17.38V16.46C13.6201 16.01 13.3501 15.62 12.9401 15.45L12.7601 15.38H12.5301C12.2401 15.38 11.9601 15.49 11.7601 15.69L9.12006 18.33L8.14006 17.37C7.34006 16.58 6.80006 15.22 6.63006 13.63H7.55006C8.00006 13.63 8.39006 13.36 8.56006 12.95C8.73006 12.54 8.64006 12.07 8.32006 11.76L5.68006 9.12L6.64006 8.14C7.43006 7.34 8.79006 6.8 10.3801 6.63V7.55C10.3801 8 10.6501 8.39 11.0601 8.56L11.2401 8.64H11.4701C11.7601 8.64 12.0401 8.53 12.2401 8.33L14.8801 5.69L15.8601 6.65C16.6601 7.44 17.2001 8.8 17.3701 10.39H16.4501C16.0001 10.39 15.6101 10.66 15.4401 11.07C15.2701 11.48 15.3601 11.95 15.6801 12.26L18.3201 14.9L17.3601 15.88C16.5701 16.68 15.2101 17.22 13.6201 17.39V17.38Z" fill="#1A4D80"/>
               </g>
            </>
         )
      },
      'calendar-clock': {
         width: 15,
         height: 16,
         viewBox: [0,0,15,16],
         fill: 'none',
         data: (
            <>
               <path d="M12.9895 8.15265V2.60544C12.9895 1.66609 12.1889 0.910156 11.2077 0.910156H2.2818C1.29505 0.910156 0.5 1.67165 0.5 2.60544V11.2431C0.5 12.1824 1.30068 12.9384 2.2818 12.9384H7.85276" stroke="#6F7680" stroke-miterlimit="10" stroke-linecap="round"/>
               <path d="M11.1019 14.6837C12.9786 14.6837 14.5 13.202 14.5 11.3742C14.5 9.54641 12.9786 8.0647 11.1019 8.0647C9.22514 8.0647 7.70374 9.54641 7.70374 11.3742C7.70374 13.202 9.22514 14.6837 11.1019 14.6837Z" stroke="#6F7680" stroke-linecap="round" stroke-linejoin="round"/>
               <path d="M11.0387 10.3376V11.8217" stroke="#6F7680" stroke-linecap="round" stroke-linejoin="round"/>
               <path d="M12.3017 11.8215H11.0387" stroke="#6F7680" stroke-linecap="round" stroke-linejoin="round"/>
               <path d="M2.849 0.5V2.1008" stroke="#6F7680" stroke-linecap="round" stroke-linejoin="round"/>
               <path d="M10.7661 0.5V2.1008" stroke="#6F7680" stroke-linecap="round" stroke-linejoin="round"/>
               <path d="M5.37158 3.8562C5.52572 3.8562 5.63912 3.97748 5.63916 4.11206C5.63916 4.24667 5.52575 4.36792 5.37158 4.36792C5.21755 4.36779 5.10498 4.2466 5.10498 4.11206C5.10502 3.97755 5.21757 3.85633 5.37158 3.8562Z" fill="#B7BCC2" stroke="#6F7680"/>
               <path d="M7.79651 3.8562C7.95065 3.8562 8.06405 3.97748 8.06409 4.11206C8.06409 4.24667 7.95067 4.36792 7.79651 4.36792C7.64247 4.36779 7.52991 4.2466 7.52991 4.11206C7.52995 3.97755 7.6425 3.85633 7.79651 3.8562Z" fill="#B7BCC2" stroke="#6F7680"/>
               <path d="M10.2267 3.8562C10.3808 3.8562 10.4942 3.97748 10.4943 4.11206C10.4943 4.24667 10.3808 4.36792 10.2267 4.36792C10.0726 4.36779 9.96008 4.2466 9.96008 4.11206C9.96012 3.97755 10.0727 3.85633 10.2267 3.8562Z" fill="#B7BCC2" stroke="#6F7680"/>
               <path d="M2.94141 6.52979C3.09554 6.52979 3.20894 6.65106 3.20898 6.78564C3.20898 6.92025 3.09557 7.0415 2.94141 7.0415C2.78737 7.04137 2.6748 6.92018 2.6748 6.78564C2.67485 6.65114 2.7874 6.52992 2.94141 6.52979Z" fill="#B7BCC2" stroke="#6F7680"/>
               <path d="M5.37158 6.52979C5.52572 6.52979 5.63912 6.65106 5.63916 6.78564C5.63916 6.92026 5.52575 7.0415 5.37158 7.0415C5.21755 7.04137 5.10498 6.92018 5.10498 6.78564C5.10502 6.65114 5.21757 6.52992 5.37158 6.52979Z" fill="#B7BCC2" stroke="#6F7680"/>
               <path d="M7.79651 6.52979C7.95064 6.52979 8.06405 6.65106 8.06409 6.78564C8.06409 6.92025 7.95067 7.0415 7.79651 7.0415C7.64247 7.04137 7.52991 6.92018 7.52991 6.78564C7.52995 6.65114 7.6425 6.52992 7.79651 6.52979Z" fill="#B7BCC2" stroke="#6F7680"/>
               <path d="M10.2267 6.52979C10.3808 6.52979 10.4942 6.65106 10.4943 6.78564C10.4943 6.92025 10.3808 7.0415 10.2267 7.0415C10.0726 7.04137 9.96008 6.92018 9.96008 6.78564C9.96012 6.65114 10.0727 6.52992 10.2267 6.52979Z" fill="#B7BCC2" stroke="#6F7680"/>
               <path d="M2.94141 9.10913C3.09554 9.10913 3.20894 9.23041 3.20898 9.36499C3.20898 9.4996 3.09557 9.62085 2.94141 9.62085C2.78737 9.62072 2.6748 9.49953 2.6748 9.36499C2.67484 9.23048 2.7874 9.10926 2.94141 9.10913Z" fill="#B7BCC2" stroke="#6F7680"/>
               <path d="M5.37158 9.10913C5.52572 9.10913 5.63912 9.23041 5.63916 9.36499C5.63916 9.4996 5.52575 9.62085 5.37158 9.62085C5.21755 9.62072 5.10498 9.49953 5.10498 9.36499C5.10502 9.23048 5.21757 9.10926 5.37158 9.10913Z" fill="#B7BCC2" stroke="#6F7680"/>
               <path d="M7.79651 9.10913C7.95065 9.10913 8.06405 9.23041 8.06409 9.36499C8.06409 9.4996 7.95067 9.62085 7.79651 9.62085C7.64247 9.62072 7.52991 9.49953 7.52991 9.36499C7.52995 9.23048 7.6425 9.10926 7.79651 9.10913Z" fill="#B7BCC2" stroke="#6F7680"/>
            </>
         )
      },
      'smart-audit-worker': {
         width: 15,
         height: 15,
         viewBox: [0,0,15,15],
         fill: 'none',
         data: (
            <>
               <path stroke="#6F7680" stroke-linejoin="round" d="M11.27 13.547c-.9-1.053-2.364-1.553-3.764-1.553-1.394 0-2.859.5-3.759 1.553"/><path fill="#000" stroke="#6F7680" d="M10.09 7.324a.674.674 0 0 1 .193.44c.075 1.598-1.076 2.973-2.599 3.16h-.022l-.026.002c-.093.01-.193.015-.295.015-1.487 0-2.759-1.162-2.938-2.744l-.001-.007-.001-.008-.001-.01v-.06l.002-.034c.001-.028.004-.07.004-.114V7.9c0-.18.07-.341.182-.462V7.9c0 .018 0 .047-.003.092a3.882 3.882 0 0 0-.002.132v.028l.002.027c.161 1.438 1.323 2.586 2.762 2.586.069 0 .179-.001.296-.017l.001.002.009-.002h.006l-.001-.001c1.476-.174 2.523-1.488 2.453-2.971l-.022-.452Zm-.424-.2a.67.67 0 0 1 .388.166l-.453.01-4.524.1-.46.01a.67.67 0 0 1 .45-.187h.003l4.523-.1h.073Z"/><mask id="a" fill="#fff"><path d="M7.735 3.341a.258.258 0 0 1 .212.235l.024.753c0 .124.111.218.229.218.059 0 .082-.012.106-.03.07-.04.13-.105.112-.194l-.024-.4c.741.383 1.253 1.147 1.324 2.065l.082.03a.31.31 0 0 1 .294.282l.012.023c-.006.16-.118.289-.27.289h-.012l-4.836.1h-.006c-.211 0-.258-.106-.335-.318.006-.159.118-.288.27-.288h.012c.036-.947.56-1.76 1.324-2.16l.012.507c0 .123.111.217.23.217.058 0 .081-.011.105-.029.07-.041.13-.106.112-.194L6.7 3.653c0-.124.088-.241.206-.247l.812-.077m.017-1.164h-.111l-.789.076a1.373 1.373 0 0 0-1.076.641c-.018.006-.03.018-.047.024a3.702 3.702 0 0 0-1.883 2.53 1.493 1.493 0 0 0-.353.893 1.21 1.21 0 0 0 .071.46c.294.81.841 1.046 1.294 1.087.053.006.106.012.159.012h.024l4.811-.1h.012c.765 0 1.4-.618 1.441-1.4a1.185 1.185 0 0 0-.059-.43 1.49 1.49 0 0 0-.452-.74 3.637 3.637 0 0 0-1.848-2.342 1.428 1.428 0 0 0-1.088-.711H7.73h.006Z"/></mask><path fill="#000" d="M7.735 3.341a.258.258 0 0 1 .212.235l.024.753c0 .124.111.218.229.218.059 0 .082-.012.106-.03.07-.04.13-.105.112-.194l-.024-.4c.741.383 1.253 1.147 1.324 2.065l.082.03a.31.31 0 0 1 .294.282l.012.023c-.006.16-.118.289-.27.289h-.012l-4.836.1h-.006c-.211 0-.258-.106-.335-.318.006-.159.118-.288.27-.288h.012c.036-.947.56-1.76 1.324-2.16l.012.507c0 .123.111.217.23.217.058 0 .081-.011.105-.029.07-.041.13-.106.112-.194L6.7 3.653c0-.124.088-.241.206-.247l.812-.077m.017-1.164h-.111l-.789.076a1.373 1.373 0 0 0-1.076.641c-.018.006-.03.018-.047.024a3.702 3.702 0 0 0-1.883 2.53 1.493 1.493 0 0 0-.353.893 1.21 1.21 0 0 0 .071.46c.294.81.841 1.046 1.294 1.087.053.006.106.012.159.012h.024l4.811-.1h.012c.765 0 1.4-.618 1.441-1.4a1.185 1.185 0 0 0-.059-.43 1.49 1.49 0 0 0-.452-.74 3.637 3.637 0 0 0-1.848-2.342 1.428 1.428 0 0 0-1.088-.711H7.73h.006Z"/><path fill="#6F7680" d="m7.947 3.576 1-.03v-.008l-.001-.007-.999.045Zm.024.753h1v-.031l-1 .031Zm.335.188-.504-.863-.05.029-.046.034.6.8Zm.112-.194-.999.06.004.068.014.068.98-.196Zm-.024-.4.459-.888-1.56-.805.103 1.752.998-.059Zm1.324 2.065-.997.077.05.647.61.218.337-.942Zm.082.03-.336.941.127.046.135.01.074-.998Zm.294.282-.997.077.015.195.088.175.894-.447Zm.012.023 1 .037.009-.255L11 5.876l-.894.447Zm-.282.289v-1H9.803l.02 1Zm-4.836.1v1h.02l-.02-1Zm-.34-.318-1-.037-.007.194.066.183.94-.34Zm.281-.288v1h.964l.036-.963-1-.037Zm1.324-2.16 1-.022-.038-1.609-1.426.746.464.886Zm.012.507h1V4.43l-1 .023Zm.335.188-.504-.864-.05.03L6 3.84l.6.8Zm.112-.194-1 .015.001.091.018.09.98-.196ZM6.7 3.653h-1v.015l1-.015Zm.206-.247.05.998h.022L7 4.4l-.094-.995Zm.718-1.241v-1h-.049l-.048.004.097.996Zm-.789.076.068.998.014-.001.015-.002-.097-.995Zm-.911.43.707.707.008-.009.008-.008-.723-.69Zm-.165.211.316.949.345-.115.19-.31-.851-.524Zm-.047.024-.316-.949-.078.026-.073.038.467.885Zm-1.883 2.53.761.648.167-.195.052-.252-.98-.202Zm-.353.893-.998-.051v.014l.998.037Zm.071.46-.94.338v.002l.94-.34Zm1.294 1.087.11-.994h-.01l-.01-.002-.09.996Zm.183.012v1h.02l-.02-1Zm4.811-.1v-1h-.02l.02 1Zm1.453-1.4.999.053v-.013l-.999-.04Zm-.059-.43-.967.252.008.033.01.032.95-.316Zm-.452-.74-.968.251.076.293.226.202.665-.747ZM8.928 2.875l-.866.5.147.254.26.135.46-.889Zm-1.088-.711.1-.995-.05-.005h-.05v1ZM7.735 3.34l-.124.992a.756.756 0 0 1-.45-.218.753.753 0 0 1-.213-.493l1-.046.998-.045a1.247 1.247 0 0 0-.358-.817 1.245 1.245 0 0 0-.729-.365l-.124.992Zm.212.235-1 .032.024.752 1-.03 1-.032-.024-.753-1 .031Zm.024.753h-1c0 .759.646 1.218 1.229 1.218v-2c.203 0 .383.078.516.2a.79.79 0 0 1 .255.582h-1Zm.229.218v1a1.126 1.126 0 0 0 .706-.23l-.6-.8-.6-.8a.874.874 0 0 1 .494-.17v1Zm.106-.03.504.864c.188-.11.735-.52.588-1.254l-.98.196-.98.196a.851.851 0 0 1 .122-.631.739.739 0 0 1 .242-.234l.504.863Zm.112-.194.998-.058-.024-.4-.998.058-.998.06.023.4.999-.06Zm-.024-.4-.458.89c.419.215.74.664.785 1.252l.997-.077.997-.077c-.096-1.247-.8-2.328-1.862-2.876l-.459.888Zm1.324 2.065-.337.942.083.03.336-.943.336-.941-.082-.03-.336.942Zm.082.03-.074.997a.69.69 0 0 1-.629-.638l.997-.077.997-.077A1.31 1.31 0 0 0 9.874 5.02l-.074.997Zm.294.282-.894.447.011.024.895-.448.894-.447-.011-.023-.895.447Zm.012.023-1-.037a.72.72 0 0 1 .73-.674v2c.802 0 1.248-.675 1.27-1.252l-1-.037Zm-.27.289v-1H9.823v2H9.836v-1Zm-.012 0-.021-1-4.835.1.02 1 .02 1 4.836-.1-.02-1Zm-4.836.1v-1h-.005v2h.005v-1Zm-.006 0v-1a.64.64 0 0 1 .22.043c.12.045.225.12.304.207.069.076.099.141.103.15l-.021-.058-.94.34-.941.34c.02.058.11.342.315.568.292.324.665.41.96.41v-1Zm-.335-.318 1 .037a.72.72 0 0 1-.73.675v-2c-.802 0-1.248.674-1.27 1.251l1 .037Zm.27-.288v1H4.93v-2H4.917v1Zm.012 0 1 .037c.022-.599.35-1.081.787-1.31l-.463-.886-.464-.886c-1.091.57-1.81 1.712-1.859 3.007l1 .038Zm1.324-2.16-1 .024.012.506 1-.023 1-.023-.012-.506-1 .023Zm.012.507h-1c0 .759.646 1.217 1.23 1.217v-2c.202 0 .382.079.515.2a.79.79 0 0 1 .255.583h-1Zm.23.217v1a1.127 1.127 0 0 0 .706-.23l-.601-.799-.6-.8a.874.874 0 0 1 .494-.17v1Zm.105-.029.504.864c.189-.11.735-.52.588-1.254l-.98.196-.98.196a.851.851 0 0 1 .122-.632.739.739 0 0 1 .242-.234l.504.864Zm.112-.194 1-.015-.012-.794-1 .015-1 .015.012.794 1-.015ZM6.7 3.653h1a.73.73 0 0 1-.163.46.798.798 0 0 1-.581.291l-.05-.998-.05-.999c-.794.04-1.156.746-1.156 1.246h1Zm.206-.247L7 4.4l.811-.076-.093-.996-.094-.995-.812.076.094.996Zm.83-1.241v-1H7.623v2H7.736v-1Zm-.112 0-.097-.996-.788.077.096.995.097.995.788-.076-.096-.995Zm-.789.076-.067-.998A2.373 2.373 0 0 0 5.2 1.98l.724.69.723.69a.374.374 0 0 1 .256-.121l-.068-.998Zm-.911.43-.708-.708c-.13.13-.23.266-.309.395l.852.524.851.524a.279.279 0 0 1 .02-.028l-.706-.708Zm-.165.211-.316-.948a1.085 1.085 0 0 0-.222.102l.007-.004a.845.845 0 0 1 .168-.075l.316.949.316.948a1.082 1.082 0 0 0 .222-.103l-.007.005a.854.854 0 0 1-.168.075l-.316-.949Zm-.047.024-.467-.885A4.702 4.702 0 0 0 2.85 5.233l.98.202.979.202a2.702 2.702 0 0 1 1.37-1.847l-.467-.884Zm-1.883 2.53-.76-.65a2.493 2.493 0 0 0-.591 1.492l.998.051 1 .052a.494.494 0 0 1 .114-.297l-.76-.649Zm-.353.893-.999-.037c-.01.285.032.565.13.835l.94-.339.94-.339a.21.21 0 0 1-.011-.083l-1-.037Zm.071.46-.94.34c.207.57.53 1.007.944 1.304.407.293.84.406 1.2.44l.09-.997.09-.996a.419.419 0 0 1-.213-.07c-.047-.035-.144-.122-.23-.363l-.94.341Zm1.294 1.087-.11.994c.043.005.151.018.269.018v-2h.004a1.025 1.025 0 0 1-.052-.006l-.11.994ZM5 7.888v1H5.024v-2H5v1Zm.024 0 .02 1 4.812-.1-.02-1-.021-1-4.812.1.02 1Zm4.811-.1v1H9.848v-2H9.835v1Zm.012 0v1c1.318 0 2.372-1.056 2.44-2.347l-.999-.053-.998-.052a.463.463 0 0 1-.443.452v1Zm1.441-1.4 1 .04c.01-.257-.021-.52-.11-.786l-.949.317-.948.316c.005.017.01.036.008.073l1 .04Zm-.059-.43.968-.251a2.49 2.49 0 0 0-.755-1.236l-.665.746-.666.747a.49.49 0 0 1 .15.246l.968-.251Zm-.452-.74.967-.252a4.637 4.637 0 0 0-2.356-2.978l-.459.888-.458.889c.66.34 1.141.95 1.338 1.704l.968-.252ZM8.928 2.875l.867-.499A2.428 2.428 0 0 0 7.942 1.17l-.1.995-.102.994c.128.013.251.092.323.216l.866-.499Zm-1.088-.711v-1H7.73v2H7.842v-1Zm-.112 0v1h.006v-2H7.73v1Z" mask="url(#a)"/><path stroke="#6F7680" stroke-linecap="round" stroke-linejoin="round" d="M7.5 14.5a7 7 0 1 0 0-14 7 7 0 0 0 0 14Z"/>
            </>
         )
      },
      'audit-completion-indicator': {
         height: 14,
         width: 19,
         viewBox: [0,0,19,14],
         fill: 'none',
         data: (
            <path d="M3.51736 14C2.78037 14.0015 2.06428 13.7627 1.48151 13.3224C0.898736 12.8813 0.483939 12.2638 0.300979 11.5659C-0.481456 8.61893 0.283338 5.48459 2.34247 3.19804C7.50275 -2.73027 17.5707 0.054999 18.8496 7.67902C19.2549 9.60092 19.0566 13.9906 15.4854 14L3.51736 14ZM9.42339 1.22919C4.31427 1.09333 0.0963579 6.46974 1.5383 11.2505C1.76763 12.1342 2.58378 12.7533 3.51736 12.7509H15.4709C16.0456 12.7674 16.5963 12.5261 16.9672 12.0976C17.7793 11.1453 17.8201 9.29732 17.5875 7.88363C17.2383 6.01707 16.2302 4.32933 14.7387 3.11381C13.2464 1.89755 11.3665 1.23094 9.42339 1.22926V1.22919ZM9.49458 9.88277C9.23793 9.87881 9.0086 9.72664 8.91025 9.49473C8.8119 9.26282 8.86388 8.99659 9.04216 8.81716L10.8646 7.03718C11.1141 6.79353 11.5192 6.79353 11.7687 7.03718C12.0189 7.28083 12.0189 7.6765 11.7687 7.92015L9.94717 9.70012C9.82728 9.81722 9.6643 9.88278 9.49477 9.88278L9.49458 9.88277ZM15.0361 8.65722C14.7387 8.65646 14.4815 8.45657 14.4143 8.17403C14.1761 7.07713 13.5535 6.09658 12.6535 5.40039C11.7535 4.70483 10.6329 4.33874 9.48519 4.3645C8.34135 4.34102 7.2256 4.70954 6.33031 5.40512C5.43593 6.10068 4.81727 7.07955 4.58308 8.17341C4.50315 8.50839 4.16033 8.71756 3.81735 8.64028C3.47358 8.56297 3.25864 8.22813 3.33697 7.89241C3.76863 6.06489 5.02829 4.52781 6.75881 3.71511C8.4901 2.90245 10.5052 2.90245 12.2364 3.71435C13.9677 4.52701 15.2274 6.06335 15.6591 7.89165C15.7031 8.0766 15.6575 8.27176 15.536 8.42089C15.4154 8.56925 15.2315 8.65662 15.0365 8.65738L15.0361 8.65722Z" fill="white"/>
         )
      },
      'reassign-item-button': {
         height: 40,
         width: 40,
         viewBox: [0,0,40,40],
         fill: 'none',
         data: (
            <>
               <g clip-path="url(#clip0_7889_4969)">
               <path d="M33.3067 0.0266685H6.69333C2.99671 0.0266685 0 3.02338 0 6.72V33.3333C0 37.03 2.99671 40.0267 6.69333 40.0267H33.3067C37.0033 40.0267 40 37.03 40 33.3333V6.72C40 3.02338 37.0033 0.0266685 33.3067 0.0266685Z" fill="#F3F3F3"/>
               <path d="M25.1865 31.32H30.7465V33.9467L35.9332 29.8667L30.7465 25.7867V28.3867H25.1865" stroke="#2E2E30" stroke-width="1.85" stroke-linecap="round" stroke-linejoin="round"/>
               <path d="M20.0001 29.7467C25.383 29.7467 29.7468 25.3829 29.7468 20C29.7468 14.6171 25.383 10.2533 20.0001 10.2533C14.6171 10.2533 10.2534 14.6171 10.2534 20C10.2534 25.3829 14.6171 29.7467 20.0001 29.7467Z" stroke="#2E2E30" stroke-width="1.85" stroke-miterlimit="10" stroke-linecap="round"/>
               <path d="M20.7466 13.96V15.84" stroke="#2E2E30" stroke-width="1.85" stroke-linecap="round" stroke-linejoin="round"/>
               <path d="M19.0532 15.84V13.96" stroke="#2E2E30" stroke-width="1.85" stroke-linecap="round" stroke-linejoin="round"/>
               <path d="M24.8798 27.3733C24.5864 25.36 22.2131 24.44 19.9864 24.44C17.7731 24.44 15.3998 25.36 15.1064 27.3733" stroke="#2E2E30" stroke-width="1.85" stroke-linecap="round" stroke-linejoin="round"/>
               <path d="M22.9467 17.9333C23.3734 17.9333 23.9467 18.28 23.9467 18.7067V18.92C23.9467 19.3467 23.6 19.6933 23.1734 19.6933H19.9067H16.64C16.2134 19.6933 15.8667 19.3467 15.8667 18.92V18.7067C15.8667 18.28 16.4534 17.9333 16.88 17.9333" stroke="#2E2E30" stroke-width="1.85" stroke-linecap="round" stroke-linejoin="round"/>
               <path d="M17 17.9333V17.3733C17 16.3733 17.4533 15.1333 18.48 14.8933L18.92 14.28H20.76L21.16 14.8933C22.1867 15.12 22.8 16.24 22.8 17.3733V17.9333" stroke="#2E2E30" stroke-width="1.85" stroke-linecap="round" stroke-linejoin="round"/>
               <path d="M23.2534 20.3467C23.2534 22.2267 21.7467 23.76 19.9067 23.76C18.0667 23.76 16.5601 22.2267 16.5601 20.3467" stroke="#2E2E30" stroke-width="1.85" stroke-linecap="round" stroke-linejoin="round"/>
               </g>
               <defs>
               <clipPath id="clip0_7889_4969">
               <rect width="40" height="40" fill="white"/>
               </clipPath>
               </defs>
            </>
         )
      },
      'close-item-button': {
         height: 40,
         width: 40,
         viewBox: [0,0,40,40],
         fill: 'none',
         data: (
            <>
               <g clip-path="url(#clip0_7889_3826)">
               <path d="M33.3067 0H6.69333C2.99671 0 0 2.99671 0 6.69333V33.3067C0 37.0033 2.99671 40 6.69333 40H33.3067C37.0033 40 40 37.0033 40 33.3067V6.69333C40 2.99671 37.0033 0 33.3067 0Z" fill="#F3F3F3"/>
               <path d="M20.2398 29.4933C25.6228 29.4933 29.9865 25.1296 29.9865 19.7467C29.9865 14.3637 25.6228 10 20.2398 10C14.8569 10 10.4932 14.3637 10.4932 19.7467C10.4932 25.1296 14.8569 29.4933 20.2398 29.4933Z" stroke="#2E2E30" stroke-width="1.85" stroke-miterlimit="10" stroke-linecap="round"/>
               <path d="M15.4932 20.1733C16.7065 22.04 18.0398 23.0533 18.6265 23.44C18.8132 23.56 19.0532 23.5467 19.2265 23.4C20.1732 22.5867 21.3332 21.36 24.5065 16.8533" stroke="#2E2E30" stroke-width="1.85" stroke-miterlimit="10" stroke-linecap="round"/>
               </g>
               <defs>
               <clipPath id="clip0_7889_3826">
               <rect width="40" height="40" fill="white"/>
               </clipPath>
               </defs>
            </>
         )
      },
      'download-item-button': {
         height: 40,
         width: 40,
         viewBox: [0,0,40,40],
         fill: 'none',
         data: (
            <>
               <path d="M15.5439 14.9549H18.2788" stroke="#2E2E30" stroke-width="1.85" stroke-miterlimit="10" stroke-linecap="round"/>
               <path d="M15.5439 18.1842H18.2788" stroke="#2E2E30" stroke-width="1.85" stroke-miterlimit="10" stroke-linecap="round"/>
               <path d="M15.5439 21.4143H18.2788" stroke="#2E2E30" stroke-width="1.85" stroke-miterlimit="10" stroke-linecap="round"/>
               <path d="M21.0347 14.9549H23.7695" stroke="#2E2E30" stroke-width="1.85" stroke-miterlimit="10" stroke-linecap="round"/>
               <path d="M21.0347 18.1842H23.7695" stroke="#2E2E30" stroke-width="1.85" stroke-miterlimit="10" stroke-linecap="round"/>
               <path d="M21.0347 21.4143H23.7695" stroke="#2E2E30" stroke-width="1.85" stroke-miterlimit="10" stroke-linecap="round"/>
               <path d="M17.7632 27.4544L19.6571 28.9314L21.551 27.4544L19.6571 28.9314V24.7761" stroke="#2E2E30" stroke-width="1.85" stroke-linecap="round" stroke-linejoin="round"/>
               <path d="M14.7595 25.0604H12.4133C11.636 25.0604 11 24.4244 11 23.6471V12.2343C11 11.4569 11.636 10.8209 12.4133 10.8209H26.9002C27.6775 10.8209 28.3135 11.4569 28.3135 12.2343V23.6471C28.3135 24.4244 27.6775 25.0604 26.9002 25.0604H24.6247" stroke="#2E2E30" stroke-width="1.85" stroke-linecap="round" stroke-linejoin="round"/>
            </>
         )
      },
      'view-all-items': {
         width: 18,
         height: 15,
         viewBox: [0, 0, 15, 15],
         fill: 'none',
         data: (
            <>
               <path d="M12.25 4.94C12.37 4.79 12.39 4.6 12.33 4.43L11.64 2.7C11.64 2.7 11.49 2.41 11.05 2.41H2.21001C1.72001 2.41 1.61001 2.73 1.61001 2.73L0.90001 4.43C0.83001 4.6 0.85001 4.8 0.97001 4.95L2.32001 6.67C2.48001 6.87 2.47001 7.15 2.30001 7.34L0.64001 9.17C0.55001 9.27 0.51001 9.39 0.51001 9.52V11.74C0.51001 12.31 0.97001 12.78 1.54001 12.78H10.11C10.09 12.72 10.07 12.66 10.07 12.58" stroke="#6F7680" stroke-linecap="round" stroke-linejoin="round"/>
               <path d="M0.780029 4.71H12.43" stroke="#6F7680" stroke-linecap="round" stroke-linejoin="round"/>
               <path d="M0.5 9.31H8.66" stroke="#6F7680" stroke-linecap="round" stroke-linejoin="round"/>
               <path d="M4.29004 2.07L4.83004 0.78C4.94004 0.61 5.15004 0.5 5.38004 0.5H7.82004C8.05004 0.5 8.27004 0.61 8.37004 0.78L8.91004 2.07" stroke="#6F7680" stroke-linecap="round" stroke-linejoin="round"/>
               <path d="M12.69 13.5C14.993 13.5 16.86 11.6241 16.86 9.31C16.86 6.99593 14.993 5.12 12.69 5.12C10.387 5.12 8.52002 6.99593 8.52002 9.31C8.52002 11.6241 10.387 13.5 12.69 13.5Z" stroke="#6F7680" stroke-linecap="round" stroke-linejoin="round"/>
               <path d="M14.4399 9.31H10.9299" stroke="#6F7680" stroke-linecap="round" stroke-linejoin="round"/>
               <path d="M12.6899 11.07V7.55" stroke="#6F7680" stroke-linecap="round" stroke-linejoin="round"/>
            </>
         ),
      },
      'video-call': {
         width: 22,
         height: 22,
         viewBox: [0, 0, 22, 22],
         fill: 'none',
         data: (
            <>
               <path d="M12.5339 8.61279C12.5339 8.71161 12.5275 8.81044 12.5146 8.90927C12.5232 8.85126 12.5297 8.79541 12.5382 8.7374C12.5103 8.92862 12.4609 9.11338 12.3857 9.29169C12.4072 9.24013 12.4287 9.18856 12.4502 9.137C12.3943 9.26591 12.3277 9.39051 12.2482 9.50867C12.2332 9.53231 12.216 9.55379 12.1988 9.57742C12.1365 9.66551 12.3148 9.43777 12.2138 9.55809C12.173 9.6075 12.1279 9.65691 12.0806 9.70203C12.0355 9.74715 11.9861 9.79227 11.9367 9.83524C11.8164 9.93621 12.0441 9.76004 11.956 9.8202C11.9324 9.83524 11.9109 9.85242 11.8873 9.86961C11.7691 9.9491 11.6466 10.0157 11.5156 10.0716L11.6703 10.0071C11.492 10.0802 11.3072 10.1317 11.116 10.1597C11.174 10.1511 11.2299 10.1446 11.2879 10.136C11.0902 10.1618 10.8926 10.1618 10.6949 10.136C10.7529 10.1446 10.8088 10.1511 10.8668 10.1597C10.6755 10.1317 10.4908 10.0823 10.3125 10.0071L10.4672 10.0716C10.3383 10.0157 10.2136 9.94911 10.0955 9.86961C10.0719 9.85457 10.0504 9.83738 10.0267 9.8202C9.93866 9.75789 10.1664 9.93621 10.0461 9.83524C9.99666 9.79441 9.94725 9.7493 9.90213 9.70203C9.85702 9.65692 9.8119 9.6075 9.76893 9.55809C9.66795 9.43777 9.84413 9.66551 9.78397 9.57742C9.76893 9.55379 9.75174 9.53231 9.73455 9.50867C9.65506 9.39051 9.58846 9.26805 9.53259 9.137C9.55408 9.18856 9.57556 9.24013 9.59705 9.29169C9.524 9.11337 9.47244 8.9286 9.44451 8.7374C9.4531 8.79541 9.45955 8.85126 9.46814 8.90927C9.44236 8.71162 9.44236 8.51397 9.46814 8.3163C9.45955 8.37431 9.4531 8.43017 9.44451 8.48818C9.47244 8.29696 9.52185 8.1122 9.59705 7.93389C9.57556 7.98545 9.55408 8.03701 9.53259 8.08857C9.58845 7.95967 9.65506 7.83506 9.73455 7.7169C9.74959 7.69327 9.76678 7.67178 9.78397 7.64815C9.84627 7.56006 9.66795 7.7878 9.76893 7.66749C9.80975 7.61807 9.85487 7.56866 9.90213 7.52354C9.94725 7.47842 9.99666 7.43331 10.0461 7.39034C10.1664 7.28936 9.93866 7.46553 10.0267 7.40538C10.0504 7.39034 10.0719 7.37315 10.0955 7.35596C10.2137 7.27647 10.3361 7.20987 10.4672 7.154L10.3125 7.21846C10.4908 7.14541 10.6756 7.09385 10.8668 7.06592C10.8088 7.07451 10.7529 7.08096 10.6949 7.08955C10.8925 7.06377 11.0902 7.06377 11.2879 7.08955C11.2299 7.08096 11.174 7.07451 11.116 7.06592C11.3072 7.09385 11.492 7.14326 11.6703 7.21846L11.5156 7.154C11.6445 7.20986 11.7691 7.27646 11.8873 7.35596C11.9109 7.371 11.9324 7.38819 11.956 7.40538C12.0441 7.46768 11.8164 7.28936 11.9367 7.39034C11.9861 7.43116 12.0355 7.47628 12.0806 7.52354C12.1257 7.56866 12.1709 7.61807 12.2138 7.66749C12.3148 7.7878 12.1386 7.56006 12.1988 7.64815C12.2138 7.67178 12.231 7.69327 12.2482 7.7169C12.3277 7.83506 12.3943 7.95753 12.4502 8.08857C12.4287 8.03701 12.4072 7.98545 12.3857 7.93389C12.4588 8.11221 12.5103 8.29698 12.5382 8.48818C12.5297 8.43017 12.5232 8.37431 12.5146 8.3163C12.5254 8.41513 12.5318 8.51395 12.5339 8.61279C12.5361 8.95008 12.8283 9.27237 13.1785 9.25731C13.5265 9.24227 13.8251 8.97372 13.823 8.61279C13.8187 8.04559 13.6511 7.45693 13.3138 6.99716C12.9529 6.50302 12.4867 6.14424 11.9087 5.93583C10.8496 5.55125 9.55401 5.9036 8.84085 6.77802C8.44769 7.26142 8.21995 7.81142 8.16838 8.43448C8.12326 8.99522 8.2715 9.58603 8.56154 10.0673C8.84083 10.5313 9.26623 10.9374 9.76252 11.163C10.3404 11.4251 10.9485 11.5024 11.5736 11.3843C12.1623 11.2726 12.7403 10.9309 13.1248 10.4733C13.5652 9.94696 13.8166 9.30672 13.8209 8.61488C13.8231 8.27758 13.5223 7.9553 13.1764 7.97035C12.8262 7.98539 12.5361 8.2518 12.534 8.61273L12.5339 8.61279Z" fill="#1A4D80"/>
               <path d="M15.6041 14.8134C15.5998 13.8853 15.3205 12.9443 14.7791 12.1859C14.214 11.3952 13.4513 10.8066 12.5404 10.4693C10.7787 9.81614 8.66893 10.3833 7.47213 11.8314C6.77388 12.6757 6.38072 13.7135 6.37642 14.8135C6.37427 15.1615 6.6729 15.458 7.02094 15.458H7.81157H9.7021H11.9987H13.9774C14.2997 15.458 14.6241 15.4644 14.9464 15.458H14.9593C15.2966 15.458 15.6189 15.1615 15.6038 14.8135C15.5888 14.4633 15.3202 14.1689 14.9593 14.1689H14.1687H12.2781H9.9815H8.00279C7.68052 14.1689 7.35611 14.1582 7.03383 14.1689H7.02094L7.66547 14.8135C7.66547 14.633 7.67836 14.4547 7.70199 14.2764C7.6934 14.3344 7.68695 14.3902 7.67836 14.4482C7.72562 14.1023 7.81801 13.7672 7.95121 13.4471C7.92973 13.4986 7.90824 13.5502 7.88676 13.6018C7.98559 13.3676 8.10804 13.142 8.24985 12.9293C8.28423 12.8777 8.32075 12.8283 8.35513 12.7789C8.43462 12.6672 8.2606 12.8971 8.33149 12.809C8.34868 12.7875 8.36587 12.766 8.3852 12.7424C8.4647 12.6457 8.55063 12.5512 8.64086 12.4609C8.73109 12.3707 8.82348 12.2869 8.92232 12.2053C8.9438 12.1881 8.96529 12.1709 8.98892 12.1516C9.077 12.0807 8.86216 12.2461 8.9481 12.1838C9.00181 12.1451 9.05337 12.1064 9.10923 12.0699C9.32193 11.9281 9.54536 11.8078 9.7817 11.7068C9.73013 11.7283 9.67857 11.7498 9.62701 11.7713C9.94927 11.6381 10.2844 11.5457 10.6282 11.4984C10.5702 11.507 10.5143 11.5135 10.4563 11.5221C10.8129 11.4748 11.1717 11.4748 11.5284 11.5221C11.4704 11.5135 11.4145 11.507 11.3565 11.4984C11.7024 11.5457 12.0375 11.6381 12.3577 11.7713C12.3061 11.7498 12.2545 11.7283 12.203 11.7068C12.4372 11.8057 12.6627 11.9281 12.8754 12.0699C12.927 12.1043 12.9764 12.1408 13.0258 12.1752C13.1376 12.2547 12.9077 12.0807 12.9958 12.1516C13.0172 12.1687 13.0387 12.1859 13.0624 12.2053C13.159 12.2848 13.2536 12.3707 13.3438 12.4609C13.434 12.5512 13.5178 12.6435 13.5995 12.7424C13.6167 12.7639 13.6338 12.7853 13.6532 12.809C13.7241 12.8971 13.5587 12.6822 13.621 12.7682C13.6596 12.8219 13.6983 12.8734 13.7348 12.9293C13.8766 13.142 13.9969 13.3654 14.0979 13.6018L14.0335 13.4471C14.1667 13.7693 14.2591 14.1045 14.3063 14.4482C14.2977 14.3902 14.2913 14.3344 14.2827 14.2764C14.3063 14.4547 14.3171 14.633 14.3192 14.8135C14.3214 15.1508 14.6157 15.4731 14.9637 15.458C15.3075 15.443 15.6061 15.1744 15.604 14.8135L15.6041 14.8134Z" fill="#1A4D80"/>
               <path d="M19.3728 13.9736C19.3728 14.0144 19.3685 14.0531 19.3642 14.0917C19.3728 14.0337 19.3793 13.9779 19.3878 13.9199C19.3771 13.9865 19.3599 14.0509 19.3363 14.1154L19.4007 13.9607C19.3793 14.0101 19.3556 14.0531 19.3298 14.0982C19.2697 14.2013 19.3707 14.0423 19.3728 14.0466C19.375 14.0509 19.3191 14.1046 19.317 14.1089C19.2998 14.1261 19.2826 14.139 19.2654 14.1562C19.2138 14.2077 19.4029 14.0638 19.317 14.1154C19.2675 14.1433 19.2203 14.1712 19.1666 14.1948C19.2181 14.1734 19.2697 14.1519 19.3212 14.1304C19.2568 14.154 19.1945 14.1712 19.1257 14.182C19.1838 14.1734 19.2396 14.1669 19.2976 14.1583C19.1236 14.1798 18.941 14.1669 18.7648 14.1669H17.581H15.815H13.6537H11.2817H8.88832H6.66907H4.78917H3.4464H2.82765C2.78038 14.1669 2.73526 14.1648 2.688 14.1583C2.74601 14.1669 2.80186 14.1734 2.85987 14.182C2.79327 14.1712 2.72882 14.154 2.66437 14.1304C2.71593 14.1519 2.76749 14.1734 2.81905 14.1948C2.76964 14.1734 2.72667 14.1497 2.68155 14.124C2.57843 14.0638 2.73741 14.1648 2.73312 14.1669C2.72882 14.1691 2.67511 14.1132 2.67081 14.1111C2.65362 14.0939 2.64073 14.0767 2.62355 14.0595C2.57198 14.0079 2.71593 14.197 2.66437 14.1111C2.63644 14.0616 2.60851 14.0144 2.58488 13.9607C2.60636 14.0122 2.62785 14.0638 2.64933 14.1154C2.62569 14.0509 2.60851 13.9886 2.59777 13.9199C2.60636 13.9779 2.61281 14.0337 2.6214 14.0917C2.60636 13.9757 2.61281 13.8576 2.61281 13.7415V13.0497V10.7423V7.9472V5.53233C2.61281 5.15421 2.60851 4.77608 2.61281 4.39796C2.61281 4.35499 2.61495 4.31202 2.6214 4.26905C2.61281 4.32706 2.60636 4.38292 2.59777 4.44093C2.60851 4.37433 2.62569 4.30987 2.64933 4.24542C2.62784 4.29698 2.60636 4.34854 2.58488 4.40011C2.60636 4.35069 2.62999 4.30772 2.65577 4.26261C2.71593 4.15948 2.61495 4.31847 2.6128 4.31417C2.61066 4.30987 2.66652 4.25616 2.66866 4.25187C2.68585 4.23468 2.70304 4.22179 2.72023 4.2046C2.77179 4.15304 2.58273 4.29698 2.66866 4.24542C2.71808 4.21749 2.76534 4.18956 2.81905 4.16593C2.76749 4.18741 2.71593 4.2089 2.66437 4.23038C2.72882 4.20675 2.79113 4.18956 2.85987 4.17882C2.80187 4.18741 2.74601 4.19386 2.688 4.20245C2.86202 4.18097 3.04464 4.19386 3.2208 4.19386H4.40459H6.1706H8.33192H10.7039H13.0973H15.3166H17.1965H18.5392H19.158C19.2052 4.19386 19.2504 4.19601 19.2976 4.20245C19.2396 4.19386 19.1838 4.18741 19.1257 4.17882C19.1923 4.18956 19.2568 4.20675 19.3213 4.23038C19.2697 4.2089 19.2181 4.18741 19.1666 4.16593C19.216 4.18741 19.2589 4.21105 19.3041 4.23683C19.4072 4.29698 19.2482 4.19601 19.2525 4.19386C19.2568 4.19171 19.3105 4.24757 19.3148 4.24972C19.332 4.26691 19.3449 4.28409 19.3621 4.30128C19.4136 4.35284 19.2697 4.16378 19.3212 4.24972C19.3492 4.29913 19.3771 4.3464 19.4007 4.40011L19.3363 4.24542C19.3599 4.30987 19.3771 4.37218 19.3878 4.44093C19.3793 4.38292 19.3728 4.32706 19.3642 4.26905C19.3793 4.38507 19.3728 4.50322 19.3728 4.61926V5.29816V7.57772V10.3706V12.7769C19.3728 13.17 19.3642 13.5632 19.3728 13.9564V13.9736C19.3728 14.3109 19.6693 14.6331 20.0173 14.6181C20.3675 14.603 20.6619 14.3345 20.6619 13.9736V12.1323V8.32524V5.05311C20.6619 4.83397 20.664 4.61697 20.6619 4.39784C20.6533 3.56209 19.983 2.90468 19.1494 2.90037C18.6531 2.89822 18.1568 2.90037 17.6605 2.90037H14.5345H10.6286H6.79139H3.89748H3.07893C2.86839 2.90037 2.67072 2.89607 2.46233 2.94119C1.79631 3.08299 1.33655 3.72107 1.32581 4.38494V4.53103V5.49353V9.07073V12.6995V13.7543V13.9606C1.33225 14.4848 1.59652 14.9682 2.04554 15.2432C2.34846 15.4301 2.67932 15.4559 3.01878 15.4559H3.77717H6.59812H10.3966H14.3218H17.5187H19.1301C19.2654 15.4559 19.3986 15.443 19.5297 15.4151C20.1978 15.2733 20.6555 14.6373 20.6662 13.9735C20.6727 13.6362 20.3654 13.3139 20.0217 13.329C19.6629 13.344 19.3793 13.6126 19.3728 13.9735L19.3728 13.9736Z" fill="#1A4D80"/>
               <path d="M7.84169 19.0962H9.97514H13.3611H14.1367C14.474 19.0962 14.7963 18.7997 14.7812 18.4517C14.7662 18.1015 14.4976 17.8071 14.1367 17.8071H12.0033H8.61728H7.84169C7.50439 17.8071 7.18211 18.1036 7.19716 18.4517C7.21435 18.8019 7.48076 19.0962 7.84169 19.0962Z" fill="#1A4D80"/>
               <path d="M11.636 18.4509V15.2625V14.8135C11.636 14.4762 11.3395 14.1539 10.9915 14.169C10.6412 14.184 10.3469 14.4526 10.3469 14.8135V18.0018V18.4509C10.3469 18.7882 10.6434 19.1104 10.9915 19.0954C11.3395 19.0803 11.636 18.8139 11.636 18.4509Z" fill="#1A4D80"/>
            </>
         ),
      }
   },

   allIds: [
      'actions',
      'import',
      'text',
      'bin',
      'copy',
      'loaned',
      'returned',
      'returned to owner',
      'tick',
      'warehouse loaned',
      'warehouse',
      'warehouse-outlined',
      'warehouse-arrow',
      'warehouse-yellow-bg',
      'home-warehouse',
      'return tool',
      'toolbox',
      'manage-kit',
      'add-to-kit',
      'remove-from-kit',
      'assigned to',
      'chevron',
      'help',
      'history',
      'items',
      'locations',
      'logout',
      'notes',
      'profile',
      'settings',
      'subscriptions',
      'audit',
      'connections',
      'dashboard',
      'discounts',
      'global-prices',
      'fast-forward',
      'forward',
      'edit',
      'delete',
      'close',
      'ellipsis',
      'glass',
      'error',
      'warning',
      'information',
      'success',
      'plus',
      'add',
      'excel-export',
      'export',
      'filters',
      'calendar',
      'portal',
      'email',
      'tick-circle',
      'face',
      'clock',
      'placeholder',
      'tasks',
      'pin',
      'pinNoShadow',
      'export-row',
      'selectItems',
      'addToCart',
      'removeFromCart',
      'cart',
      'attachmentPaperclip',
      'documentIcon',
      'imageIcon',
      'location-tracking',
      'gps',
      'bluetooth',
      'cardViewGps',
      'cardViewBluetooth',
      'cardViewCategory',
      'cardViewAssignedToKit',
      'cardViewBarcode',
      'cardViewText',
      'cardViewSerialNumber',
      'pinNoOutline',
      'lastSeenArea',
      'make-unavailable',
      'make-available',
      'images',
      'view',
      'add-note',
      'imageMatch',
      'matchedImage',
      'signout',
      'users',
      'images-nav',
      'reminders',
      'list',
      'action-tasks',
      'info-tasks',
      'global-tasks',
      'employee',
      'star',
      'expand',
      'borrow-request',
      'loan-request',
      'return-request',
      'transfer-request',
      'taskLocation',
      'taskWarehouse',
      'taskBarcode',
      'taskCustomField',
      'notepad',
      'warranty',
      'adjust',
      'info-outlined',
      'info-filled',
      'download',
      'cards',
      'table',
      'columns',
      'add-item',
      'delete-item',
      'scan-item',
      'auto-accept-item',
      'allow-transfer-item',
      'allow-add-location',
      'allow-transfer-to-employees',
      'allow-transfer-to-view-only',
      'edit-outlined',
      'delete-outlined',
      'audit-sent',
      'audit-due',
      'audit-received',
      'comment-outlined',
      'comment-filled',
      'print-calendar-from',
      'print-location-warehouse',
      'print-location-item',
      'print-serial-number-item',
      'print-barcode-item',
      'print-id-item',
      'print-custom-text-item',
      'print-due-back-to',
      'print-location-pin',
      'print-comment',
      'print-loan',
      'print-transfer-return',
      'sharemytoolbox-print-logo',
      'smart-audit-worker',
      'calendar-clock',
      'repeating-contract',
      'repeating-contract-filled',
      'smart-audit-toolbox',
      'smart-audit-location-pin',
      'audit-completion-indicator',
      'reassign-item-button',
      'close-item-button',
      'view-all-items',
      'video-call',
   ],
}

export { svgIcons }
